module.exports = {
	"abbvie": {
		"path": "abbvie",
		"employer": "abbvie",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 37230,
		"short_name": "Abbvie",
		"plan_short_name": "Abbvie's 401(k)",
		"primary_plan_name": "Abbvie Savings Plan",
		"chart_plan_title": "Abbvie Savings Plan",
		"primary_plan_logo": "abbvie",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "State Street Global Advisors",
		"default_fund_manager_path": "state_street_global_advisors",
		"default_fund_name": "State Street Target Retirement Series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Abbvie Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Abbvie Savings Plan Form 5500 Filing and Attachment 2023",
				"abbvie-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 11453839000,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 3393365000,
			"equity": 4680525000,
			"bond": 525222000,
			"other": 2854727000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"AbbVie Inc., common shares",
				1972595000,
				"Common shares"
			],
			[
				"",
				"Abbott Laboratories, common shares",
				422197000,
				"Common shares"
			],
			[
				"",
				"Galliard Stable Return Fund W",
				356831000,
				"Collective trust funds"
			],
			[
				"",
				"Galliard Managed Income Fund Core",
				100703000,
				"Collective trust funds"
			],
			[
				"",
				"Vanguard Federal Money Market",
				2328000,
				"Money market fund"
			],
			[
				"",
				"Interest bearing cash",
				73000,
				"Interest bearing cash"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00H9T",
				"TCW Metwest Total Return Bond Fund Class A",
				355767000,
				"Collective trust funds"
			],
			[
				"F00000QT2H",
				"State Street US Bond Index Securities Lending Series Fund Class XIV",
				169455000,
				"Collective trust funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000T8Y5",
				"State Street S&P 500 Index Securities Lending Series Fund Class II",
				1750850000,
				"Collective trust funds"
			],
			[
				"F000002PJ1",
				"Capital Group Growth Fund of America, Class U4",
				839185000,
				"Collective trust funds"
			],
			[
				"F00000VV1D",
				"State Street Russell Small/Mid Index Securities Lending Series Fund Class II",
				652487000,
				"Collective trust funds"
			],
			[
				"F00000T8Y8",
				"State Street Global Allcap Equity Ex-US Index Securities Lending Series Fund Class II",
				566379000,
				"Collective trust funds"
			],
			[
				"F000002PIZ",
				"Capital Group Washington Mutual Investors Trust, Class U3",
				376296000,
				"Collective trust funds"
			],
			[
				"F000002P1T",
				"Capital Group EuroPacific Growth Trust, Class U2",
				283447000,
				"Collective trust funds"
			],
			[
				"F00000N6WY",
				"Diamond Hill Small/Mid-Cap Portfolio",
				211881000,
				"Collective trust funds"
			]
		],
		"default_plan_options": [
			[
				"F00000T8YW",
				"State Street Target Retirement 2035 Securities Lending Series Fund Class IV",
				592760000,
				"Collective trust funds"
			],
			[
				"F00000T8Z0",
				"State Street Target Retirement 2040 Securities Lending Series Fund Class IV",
				579899000,
				"Collective trust funds"
			],
			[
				"F00000T8YS",
				"State Street Target Retirement 2030 Securities Lending Series Fund Class IV",
				541370000,
				"Collective trust funds"
			],
			[
				"F00000T8Z4",
				"State Street Target Retirement 2045 Securities Lending Series Fund Class IV",
				455371000,
				"Collective trust funds"
			],
			[
				"F00000T8YO",
				"State Street Target Retirement 2025 Securities Lending Series Fund Class IV",
				383587000,
				"Collective trust funds"
			],
			[
				"F00000T8XK",
				"State Street Target Retirement 2050 Securities Lending Series Fund Class IV",
				302970000,
				"Collective trust funds"
			],
			[
				"F00000T8XO",
				"State Street Target Retirement 2055 Securities Lending Series Fund Class IV",
				182193000,
				"Collective trust funds"
			],
			[
				"F00000T8YK",
				"State Street Target Retirement 2020 Securities Lending Series Fund Class IV",
				167084000,
				"Collective trust funds"
			],
			[
				"F00000T8XS",
				"State Street Target Retirement 2060 Securities Lending Series Fund Class IV",
				87445000,
				"Collective trust funds"
			],
			[
				"F00000T8YC",
				"State Street Target Retirement Income Securities Lending Series Fund Class IV",
				79200000,
				"Collective trust funds"
			],
			[
				"F000014AX4",
				"State Street Target Retirement 2065 Securities Lending Series Fund Class IV",
				21486000,
				"Collective trust funds"
			]
		],
		"rated_as_option": [
			[
				"F00000T8XK",
				"State Street Target Retirement 2050 Securities Lending Series Fund Class IV",
				302970000,
				"Collective trust funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				336543125,
				191697591,
				0,
				0
			],
			"dff": [
				11858668,
				11466649,
				0,
				0
			],
			"gff": [
				6623354,
				1718509,
				0,
				0
			],
			"pff": [
				76222096,
				25259341,
				0,
				0
			],
			"wff": [
				217814997,
				79298968,
				0,
				0
			],
			"tff": [
				45718314,
				12898968,
				0,
				0
			]
		}
	},
	"accenture": {
		"path": "accenture",
		"employer": "accenture",
		"year": 2022,
		"updated": " April 2024",
		"filing_received": " 04/11/2024",
		"participants": 101565,
		"short_name": "Accenture",
		"plan_short_name": "Accenture's 401(k)",
		"primary_plan_name": "Accenture United States 401(k) Match and Savings Plan",
		"chart_plan_title": "Accenture United States 401(k)\nMatch and Savings Plan",
		"primary_plan_logo": "accenture",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Accenture United States 401(k) Match and Savings Plan",
			"Accenture United States Profit Sharing and 401(k) Trust"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Accenture United States 401(k) Match and Savings Plan Form 5500 Filing and Attachment 2022",
				"accenture-united-states-401k-match-and-savings-plan-form-5500-filing-and-attachment-2022.pdf"
			],
			[
				"Accenture United States Profit Sharing and 401(k) Trust Form 5500 Filing and Attachment 2022",
				"accenture-united-states-profit-sharing-and-401k-trust-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 16716626673,
		"plan_option_count": 33,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 4172126588,
			"equity": 10576130009,
			"bond": 1263471111,
			"other": 704898965,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 4172126588
		},
		"other_plan_options": [
			[
				"",
				"Pimco Stable Value Fund",
				401083668,
				"Guaranteed Investment Contract"
			],
			[
				"",
				"Vanguard Federal Money Market Fund+C60",
				242849699,
				"Mutual Funds"
			],
			[
				"",
				"Vanguard Admiral - U.S. Treasury Money Market Portfolio",
				40772189,
				"Mutual Funds"
			],
			[
				"",
				"Temporary Investment Funds, variable rate, due on demand",
				10405953,
				"Short-Term Securities"
			],
			[
				"",
				"PIMCO Stable Value Fund",
				9787456,
				"Short-Term Securities"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Bond Index Fund",
				806838807,
				"Institutional-Only Funds"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund",
				277531845,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05C3V",
				"Vanguard Inflation-Protected Securities",
				179100459,
				"Mutual Funds"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Instl Index Fund",
				2966025726,
				"Institutional-Only Funds"
			],
			[
				"F00000JTEF",
				"Vanguard Total International Stock Index Fund",
				1273099516,
				"Institutional-Only Funds"
			],
			[
				"FOUSA02TYC",
				"Vanguard Mid-Cap Fund",
				1176061182,
				"Mutual Funds"
			],
			[
				"F00000YI8R",
				"Fidelity Contrafund",
				1052538563,
				"Institutional-Only Funds"
			],
			[
				"FOUSA00L97",
				"Vanguard Growth Index",
				866531377,
				"Mutual Funds"
			],
			[
				"FOUSA00L7W",
				"Vanguard Small-Cap Fund",
				767215535,
				"Mutual Funds"
			],
			[
				"FOUSA06TY5",
				"Fidelity OTC Portfolio",
				708730378,
				"Institutional-Only Funds"
			],
			[
				"FOUSA00LA4",
				"Vanguard Value Fund",
				555756224,
				"Mutual Funds"
			],
			[
				"F000002PIY",
				"American Funds New Perspective Fund®",
				538823718,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05IBW",
				"Vanguard Emerging Markets Fund",
				249951706,
				"Mutual Funds"
			],
			[
				"F00000YK7W",
				"Fidelity Diversified International Fund",
				208709265,
				"Institutional-Only Funds"
			],
			[
				"FOUSA02TYE",
				"Vanguard REIT Index Fund",
				198355324,
				"Mutual Funds"
			],
			[
				"",
				"Vanguard Target Retirement Income & Growth",
				14331495,
				"Institutional-Only Funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZF",
				"Vanguard Target 2040 Fund",
				775074384,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target 2050 Fund",
				700559836,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030 Fund",
				512794370,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045 Fund",
				497112595,
				"Institutional-Only Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055 Fund",
				443205873,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target 2035 Fund",
				343275606,
				"Institutional-Only Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060 Fund",
				285388365,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025 Fund",
				188882040,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Date Income",
				157258621,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020 Fund",
				154495735,
				"Institutional-Only Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065 Fund",
				108050419,
				"Institutional-Only Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070 Fund",
				6028744,
				"Institutional-Only Funds"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target 2050 Fund",
				700559836,
				"Institutional-Only Funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZF",
				"Vanguard Target 2040 Fund",
				775074384,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target 2050 Fund",
				700559836,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030 Fund",
				512794370,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045 Fund",
				497112595,
				"Institutional-Only Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055 Fund",
				443205873,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target 2035 Fund",
				343275606,
				"Institutional-Only Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060 Fund",
				285388365,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025 Fund",
				188882040,
				"Institutional-Only Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Date Income",
				157258621,
				"Institutional-Only Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020 Fund",
				154495735,
				"Institutional-Only Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065 Fund",
				108050419,
				"Institutional-Only Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070 Fund",
				6028744,
				"Institutional-Only Funds"
			]
		],
		"screen_results": {
			"fff": [
				938377468,
				289398221,
				0,
				289398221
			],
			"dff": [
				42162669,
				18295539,
				0,
				18295539
			],
			"gff": [
				9030045,
				2825648,
				0,
				2825648
			],
			"pff": [
				148062194,
				39189338,
				0,
				39189338
			],
			"wff": [
				425716852,
				115989903,
				0,
				115989903
			],
			"tff": [
				48108127,
				19825957,
				0,
				19825957
			]
		}
	},
	"adobe": {
		"path": "adobe",
		"employer": "adobe",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/04/2024",
		"participants": 20337,
		"short_name": "Adobe",
		"plan_short_name": "Adobe's 401(k)",
		"primary_plan_name": "Adobe Inc. 401(k) Retirement Savings Plan",
		"chart_plan_title": "Adobe Inc. 401(k) Retirement\nSavings Plan",
		"primary_plan_logo": "adobe",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Adobe Inc. 401(k) Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Adobe Inc. 401(k) Retirement Savings Plan Form 5500 Filing and Attachment 2023",
				"adobe-inc-401k-retirement-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3922214005,
		"plan_option_count": 27,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1938382492,
			"equity": 1706861658,
			"bond": 211492318,
			"other": 65477537,
			"sri": 63147874,
			"cref": 0,
			"vanguard_target": 1938382492
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust III",
				64468221,
				"Common/Collective Trust"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				1009316,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Institutional Total Bond Market Index Trust",
				161556561,
				"Common/Collective Trust"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund; Institutional Class",
				29666875,
				"Mutual Fund"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation-Protected Securities Fund: Inst'l Shares",
				20268882,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				648039395,
				"Common/Collective Trust"
			],
			[
				"F00000JXVR",
				"Vanguard FTSE All-World ex-US Index Fund; Inst'l Plus Shares",
				235282346,
				"Mutual Fund"
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust",
				202245458,
				"Common/Collective Trust"
			],
			[
				"FOUSA02TIF",
				"Vanguard U.S. Growth Fund Admiral Shares",
				139240145,
				"Mutual Fund"
			],
			[
				"FOUSA00C2O",
				"DFA US Small Cap Value Portfolio Inst'l Class",
				123210318,
				"Mutual Fund"
			],
			[
				"FOUSA02T18",
				"Vanguard Wellington Fund Admiral Shares",
				106615564,
				"Mutual Fund"
			],
			[
				"FOUSA02T2O",
				"Vanguard Windsor II Fund Admiral Shares",
				72045630,
				"Mutual Fund"
			],
			[
				"FOUSA02SNF",
				"Vanguard FTSE Social Index Fund Institutional Shares",
				63147874,
				"Mutual Fund",
				"sri"
			],
			[
				"F00001DHK0",
				"Dodge & Cox International Stock Fund; Class X",
				61568075,
				"Mutual Fund"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Fund Admiral Shares",
				55466853,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				346556066,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				345670261,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				308456086,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				273880238,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				228197031,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				178569022,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				103603722,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				97867119,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				21316963,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				18232032,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				15387353,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				646599,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				346556066,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				346556066,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				345670261,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				308456086,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				273880238,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				228197031,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				178569022,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				103603722,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				97867119,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				21316963,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				18232032,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				15387353,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				646599,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				127763648,
				139000137,
				0,
				139000137
			],
			"dff": [
				5015417,
				8789948,
				0,
				8789948
			],
			"gff": [
				1851839,
				1356769,
				0,
				1356769
			],
			"pff": [
				18662618,
				18818069,
				0,
				18818069
			],
			"wff": [
				57984765,
				55707912,
				0,
				55707912
			],
			"tff": [
				9087586,
				9521669,
				0,
				9521669
			]
		}
	},
	"advanced-micro-devices": {
		"path": "advanced_micro_devices",
		"employer": "advanced-micro-devices",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 11482,
		"short_name": "Advanced Micro Devices",
		"plan_short_name": "Advanced Micro Devices's 401(k)",
		"primary_plan_name": "Advanced Micro Devices, Inc. Retirement Savings Plan",
		"chart_plan_title": "Advanced Micro Devices, Inc.\nRetirement Savings Plan",
		"primary_plan_logo": "advanced_micro_devices",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Advanced Micro Devices, Inc. Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Advanced Micro Devices, Inc. Retirement Savings Plan Form 5500 Filing and Attachment 2023",
				"advanced-micro-devices-inc-retirement-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 2173800539,
		"plan_option_count": 25,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 735049319,
			"equity": 1241738076,
			"bond": 172757197,
			"other": 24255947,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 735049319
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Managed Custom Fund",
				23051355,
				"Managed Custom Fund"
			],
			[
				"",
				"Vanguard Vanguard Treasury Money Market Fund",
				1204592,
				"Money Market Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"",
				"Galliard Managed Income Fund MC",
				84678297,
				"Collective Trust Funds"
			],
			[
				"FOUSA02TYI",
				"Vanguard Total Bond Market Index Fund",
				55958928,
				"Mutual Funds"
			],
			[
				"FOUSA06Y04",
				"Western Asset Core Bond Fund Class IS",
				32119972,
				"Mutual Funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				512896130,
				"Mutual Funds"
			],
			[
				"FOUSA00C3I",
				"Dodge & Cox Balanced Fund",
				266727365,
				"Mutual Funds"
			],
			[
				"FOUSA00GPW",
				"Vanguard Extened Market Index Fund",
				172980717,
				"Mutual Funds"
			],
			[
				"FOUSA02VMM",
				"DFA US Target Value",
				84385730,
				"Mutual Funds"
			],
			[
				"",
				"Boston Partners Large Cap Value Equity",
				82629087,
				"Collective Trust Funds"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund Class R-6",
				66399238,
				"Mutual Funds"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund",
				38721913,
				"Mutual Funds"
			],
			[
				"F00000VOGS",
				"Loomis Small Mid-Cap Growth",
				16997896,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Fund",
				121248919,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Fund",
				109258777,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Fund",
				99363597,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Fund",
				96739802,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Fund",
				91784411,
				"Collective Trust Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Fund",
				71009488,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Fund",
				68320470,
				"Collective Trust Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Fund",
				34837882,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Fund",
				19388091,
				"Collective Trust Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Fund",
				11993549,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Fund",
				10357477,
				"Collective Trust Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Fund",
				746856,
				"Collective Trust Funds"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Fund",
				91784411,
				"Collective Trust Funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Fund",
				121248919,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Fund",
				109258777,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Fund",
				99363597,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Fund",
				96739802,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Fund",
				91784411,
				"Collective Trust Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Fund",
				71009488,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Fund",
				68320470,
				"Collective Trust Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Fund",
				34837882,
				"Collective Trust Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Fund",
				19388091,
				"Collective Trust Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Fund",
				11993549,
				"Collective Trust Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Fund",
				10357477,
				"Collective Trust Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Fund",
				746856,
				"Collective Trust Funds"
			]
		],
		"screen_results": {
			"fff": [
				85419322,
				49938125,
				0,
				49938125
			],
			"dff": [
				3303143,
				3156035,
				0,
				3156035
			],
			"gff": [
				1045382,
				487758,
				0,
				487758
			],
			"pff": [
				17934813,
				6764458,
				0,
				6764458
			],
			"wff": [
				45675478,
				20016243,
				0,
				20016243
			],
			"tff": [
				7978574,
				3421503,
				0,
				3421503
			]
		}
	},
	"airbnb": {
		"path": "airbnb",
		"employer": "airbnb",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/05/2023",
		"participants": 4949,
		"short_name": "Airbnb",
		"plan_short_name": "Airbnb's 401(k)",
		"primary_plan_name": "Airbnb 401(k) Plan",
		"chart_plan_title": "Airbnb 401(k) Plan",
		"primary_plan_logo": "airbnb",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Airbnb 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Airbnb 401(k) Plan Form 5500 Filing and Attachment 2022",
				"airbnb-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 461155617,
		"plan_option_count": 28,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 256629170,
			"equity": 187581073,
			"bond": 12175815,
			"other": 4769559,
			"sri": 762722,
			"cref": 0,
			"vanguard_target": 256629170
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Government Money Market Fund K6",
				4769559,
				"Registered Investment Company"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				7275364,
				"Registered Investment Company"
			],
			[
				"FOUSA00H9T",
				"Metropolitan West Total Return Bond Fund I",
				4900451,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				97983347,
				"Registered Investment Company"
			],
			[
				"F00000WMWX",
				"T. Rowe Price Blue Chip Growth Fund I",
				22263182,
				"Registered Investment Company"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index Fund",
				14868589,
				"Registered Investment Company"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				13717500,
				"Registered Investment Company"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index Fund",
				12714581,
				"Registered Investment Company"
			],
			[
				"F00000VWMV",
				"T. Rowe Price Mid-Cap Growth Fund I",
				7539999,
				"Registered Investment Company"
			],
			[
				"F00000XEEK",
				"JPMorgan Value Advantage Fund R6",
				4205137,
				"Registered Investment Company"
			],
			[
				"F00000MJRT",
				"Fidelity Real Estate Index Fund",
				3747603,
				"Registered Investment Company"
			],
			[
				"FOUSA06TXM",
				"Fidelity Emerging Markets Index Fund",
				3502807,
				"Registered Investment Company"
			],
			[
				"F00000PJJE",
				"Undiscovered Managers Behavioral Value Fund R6",
				2618221,
				"Registered Investment Company"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund R6",
				2370987,
				"Registered Investment Company"
			],
			[
				"F00000NB29",
				"Invesco Oppenheimer Developing Markets Fund Class R6",
				1286398,
				"Registered Investment Company"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund Admiral Shares",
				762722,
				"Registered Investment Company",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				71168511,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				67573979,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				48568085,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				23999878,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				18331190,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				10898650,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				5770771,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				4082983,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				2370881,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				2144205,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				1702260,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				17777,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				71168511,
				"Registered Investment Company"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				71168511,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				67573979,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				48568085,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				23999878,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				18331190,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				10898650,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				5770771,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				4082983,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				2370881,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				2144205,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				1702260,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				17777,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				14548938,
				20060266,
				0,
				20060266
			],
			"dff": [
				504876,
				1270660,
				0,
				1270660
			],
			"gff": [
				183627,
				195455,
				0,
				195455
			],
			"pff": [
				3094123,
				2711626,
				0,
				2711626
			],
			"wff": [
				6265927,
				8037181,
				0,
				8037181
			],
			"tff": [
				986344,
				1373392,
				0,
				1373392
			]
		}
	},
	"amazon-com": {
		"path": "amazon_com",
		"employer": "amazon-com",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 1214063,
		"short_name": "Amazon.com",
		"plan_short_name": "Amazon's 401(k)",
		"primary_plan_name": "Amazon 401(k) Plan",
		"chart_plan_title": "Amazon 401(k) Plan",
		"primary_plan_logo": "amazon_com",
		"coreissue": "deforestation",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "net zero by 2040",
		"proposal_title": "Proposal 5 - Shareholder Proposal Requesting a Report on Retirement Plan Options",
		"proposal_url": "2021/12/10-amazon-report-on-aligning-retirement-plan-options-with-company-climate-goals",
		"plan_names": [
			"Amazon 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Amazon 401(k) Plan Form 5500 Filing and Attachment 2023",
				"amazon-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 25132634000,
		"plan_option_count": 28,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 15336148000,
			"equity": 6861452000,
			"bond": 480826000,
			"other": 2454208000,
			"sri": 635380000,
			"cref": 0,
			"vanguard_target": 15336148000
		},
		"other_plan_options": [
			[
				"",
				"AMAZON.COM STOCK",
				2002039000,
				"Company Stock"
			],
			[
				"",
				"VANG RET SVNG TR II",
				423544000,
				"Collective Investment Trust"
			],
			[
				"",
				"VANG CR FED MM ADM",
				28536000,
				"Money Market"
			],
			[
				"",
				"VANG VMMR-FED MMKT",
				89000,
				"Money Market"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"VG IS TOT BD MKT IDX",
				279369000,
				"Collective Investment Trust"
			],
			[
				"FOUSA00EFI",
				"PIMCO TOTAL RTN II",
				201457000,
				"Collective Investment Trust"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"VANG INST 500 IDX TR",
				3024462000,
				"Collective Investment Trust"
			],
			[
				"F00000J3K7",
				"SSGA LG CAP GROWTH",
				1198446000,
				"Collective Trust Fund"
			],
			[
				"FOUSA02SNF",
				"VANG FTSE SOC IDX IS",
				635380000,
				"Mutual Fund",
				"sri"
			],
			[
				"FOUSA02TY5",
				"VANG EXPLORER ADM",
				484779000,
				"Mutual Fund"
			],
			[
				"F00000JTBU",
				"VG IS TL INTL STK MK",
				464474000,
				"Collective Investment Trust"
			],
			[
				"F00000J3KB",
				"SSGA LG CAP VALUE",
				331336000,
				"Collective Trust Fund"
			],
			[
				"FOUSA00K2U",
				"VANG SM VAL IDX INST",
				285859000,
				"Mutual Fund"
			],
			[
				"F00000VV1B",
				"SSGA SM/MID CAP",
				170223000,
				"Collective Trust Fund"
			],
			[
				"F000002P1T",
				"AF EUROPAC GROWTH R6",
				157196000,
				"Mutual Fund"
			],
			[
				"FOUSA00E9G",
				"HARRIS OAKMRK INTL 3",
				109297000,
				"Collective Investment Trust"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"VANGUARD TARGET 2055",
				2956110000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				2955495000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET 2045",
				2380026000,
				"Collective Investment Trust"
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET 2060",
				1891248000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZF",
				"VANGUARD TARGET 2040",
				1707802000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET 2035",
				1285722000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET 2030",
				769716000,
				"Collective Investment Trust"
			],
			[
				"F00000YE51",
				"VANGUARD TARGET 2065",
				736576000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET 2025",
				372070000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET INC",
				122962000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET 2020",
				110979000,
				"Collective Investment Trust"
			],
			[
				"F00001DBZ9",
				"VANGUARD TARGET 2070",
				47442000,
				"Collective Investment Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				2955495000,
				"Collective Investment Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"VANGUARD TARGET 2055",
				2956110000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				2955495000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET 2045",
				2380026000,
				"Collective Investment Trust"
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET 2060",
				1891248000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZF",
				"VANGUARD TARGET 2040",
				1707802000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET 2035",
				1285722000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET 2030",
				769716000,
				"Collective Investment Trust"
			],
			[
				"F00000YE51",
				"VANGUARD TARGET 2065",
				736576000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET 2025",
				372070000,
				"Collective Investment Trust"
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET INC",
				122962000,
				"Collective Investment Trust"
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET 2020",
				110979000,
				"Collective Investment Trust"
			],
			[
				"F00001DBZ9",
				"VANGUARD TARGET 2070",
				47442000,
				"Collective Investment Trust"
			]
		],
		"screen_results": {
			"fff": [
				456113482,
				1165443216,
				0,
				1165443216
			],
			"dff": [
				17912242,
				73764412,
				0,
				73764412
			],
			"gff": [
				5645353,
				11364930,
				0,
				11364930
			],
			"pff": [
				109941934,
				157650723,
				0,
				157650723
			],
			"wff": [
				223732062,
				467004536,
				0,
				467004536
			],
			"tff": [
				33321744,
				79810704,
				0,
				79810704
			]
		}
	},
	"apple": {
		"path": "apple",
		"employer": "apple",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/11/2024",
		"participants": 147753,
		"short_name": "Apple",
		"plan_short_name": "Apple's 401(k)",
		"primary_plan_name": "Apple 401(k) Plan",
		"chart_plan_title": "Apple 401(k) Plan",
		"primary_plan_logo": "apple",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock Global LifePath Index series",
		"access_self_directed": "Schwab Brokerage",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Apple 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Apple 401(k) Plan Form 5500 Filing and Attachment 2023",
				"apple-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 18682446877,
		"plan_option_count": 24,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 8864588480,
			"equity": 8455748516,
			"bond": 910261111,
			"other": 451848770,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"GALLIARD Stable Value Fund Separately Managed Account",
				437732297,
				"Separately Managed Account"
			],
			[
				"",
				"WF/BLACKROCK SHORT TERM INVESTMENT FUND S",
				14116473,
				"Common/Collective Trust Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"VANGUARD TOTAL BOND MARKET INDEX TRUST",
				618895064,
				"Common/Collective Trust Fund"
			],
			[
				"F00001GKN1",
				"EATON VANCE HIGH YIELD CIT V",
				172894497,
				"Common/Collective Trust Fund"
			],
			[
				"FOUSA00CZR",
				"LOOMIS SAYLES CORE PLUS FIXED INCOME CIT F",
				118471550,
				"Common/Collective Trust Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"VANGUARD INSTITUTIONAL 500 INDEX TRUST",
				3321841308,
				"Common/Collective Trust Fund"
			],
			[
				"FOUSA06TX6",
				"FIDELITY CONTRA COMM POOL CL 3",
				1657118969,
				"Common/Collective Trust Fund"
			],
			[
				"FOUSA00LB6",
				"VANGUARD EXTENDED MARKET INDEX TRUST",
				934912853,
				"Common/Collective Trust Fund"
			],
			[
				"F00000JTBU",
				"VANGUARD TOTAL INTL STOCK INDEX TRUST",
				819849449,
				"Common/Collective Trust Fund"
			],
			[
				"FOUSA05U9B",
				"BHMS Large Cap Value Equity Separately Managed Account",
				605456009,
				"Separately Managed Account"
			],
			[
				"FOUSA04BJY",
				"William Blair Small-Mid Cap Growth Separately Managed Account",
				384300692,
				"Separately Managed Account"
			],
			[
				"F00000V3SK",
				"BAILLIE GIFFORD INTERNATIONAL ALPHA CIT C",
				319582175,
				"Common/Collective Trust Fund"
			],
			[
				"FOUSA05BKA",
				"AB US SMALL AND MID CAP VALUE CIT (W SERIES)",
				220977516,
				"Common/Collective Trust Fund"
			],
			[
				"F00000Q3F3",
				"BNY MELLON EB GLOBAL REAL ESTATE SEC II",
				191709545,
				"Common/Collective Trust Fund"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPG",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2050 ACCOUNT A",
				1776430177,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAPH",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2045 ACCOUNT A",
				1691485514,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAP0",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2055 ACCOUNT A",
				1397873265,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAPI",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2040 ACCOUNT A",
				1213738062,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAPJ",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2035 ACCOUNT A",
				920464079,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAPK",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2030 ACCOUNT A",
				606603063,
				"Common/Collective Trust Fund"
			],
			[
				"F00000WM8M",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2060 ACCOUNT A",
				545498045,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAOX",
				"BLACKROCK GLOBAL LIFEPATH INDEX RETIREMENT ACCOUNT A",
				304817788,
				"Common/Collective Trust Fund"
			],
			[
				"F00000MAPL",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2025 ACCOUNT A",
				303283604,
				"Common/Collective Trust Fund"
			],
			[
				"F000013OYO",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2065 ACCOUNT A",
				104394883,
				"Common/Collective Trust Fund"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BLACKROCK GLOBAL LIFEPATH INDEX 2050 ACCOUNT A",
				1776430177,
				"Common/Collective Trust Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				801691946,
				656529808,
				0,
				0
			],
			"dff": [
				16744088,
				36306923,
				0,
				0
			],
			"gff": [
				5539355,
				5936420,
				0,
				0
			],
			"pff": [
				92296576,
				87783909,
				0,
				0
			],
			"wff": [
				336454595,
				263559536,
				0,
				0
			],
			"tff": [
				50864760,
				43110594,
				0,
				0
			]
		}
	},
	"atlassian": {
		"path": "atlassian",
		"employer": "atlassian",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/26/2023",
		"participants": 3547,
		"short_name": "Atlassian",
		"plan_short_name": "Atlassian's 401(k)",
		"primary_plan_name": "Atlassian 401(k) Plan",
		"chart_plan_title": "Atlassian 401(k) Plan",
		"primary_plan_logo": "atlassian",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "American Funds/Capital Group",
		"default_fund_manager_path": "american_funds_capital_group",
		"default_fund_name": "American Funds Target Date Retirement series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Atlassian 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Atlassian 401(k) Plan Form 5500 Filing and Attachment 2022",
				"atlassian-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 349015808,
		"plan_option_count": 32,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 199045367,
			"equity": 133398735,
			"bond": 12744152,
			"other": 3827554,
			"sri": 5235386,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Gabelli US Treasury Money Market Fund",
				3827554,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity US Bond Index Fund",
				5406905,
				"Mutual Fund"
			],
			[
				"FOUSA00CGB",
				"Fidelity Capital & Income Fund",
				3581064,
				"Mutual Fund"
			],
			[
				"FOUSA00H9T",
				"Metropolitan West Total Return Bond Fund I",
				2107927,
				"Mutual Fund"
			],
			[
				"FOUSA05C3V",
				"Vanguard Inflation-Protected Admiral Fund",
				1648256,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				64832546,
				"Mutual Fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				9771806,
				"Mutual Fund"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				9595469,
				"Mutual Fund"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index Fund",
				8311704,
				"Mutual Fund"
			],
			[
				"F00000YI8R",
				"Fidelity Contrafund K6",
				7609278,
				"Mutual Fund"
			],
			[
				"F00000ZKH4",
				"Calvert US Large Cap Core Responsible Index Fund R6",
				5235386,
				"Mutual Fund",
				"sri"
			],
			[
				"F00000OB9Z",
				"Janus Henderson Enterprise Fund Class N",
				4673464,
				"Mutual Fund"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				4619781,
				"Mutual Fund"
			],
			[
				"F00000SCG4",
				"Victory Sycamore Established Value Fund R6",
				4198028,
				"Mutual Fund"
			],
			[
				"F00000WZW5",
				"Fidelity Large Cap Growth Index Fund",
				3445149,
				"Mutual Fund"
			],
			[
				"F000002PJ9",
				"American Funds New World R6",
				3278184,
				"Mutual Fund"
			],
			[
				"FOUSA02VMM",
				"DFA U.S. Targeted Value I Fund",
				3188897,
				"Mutual Fund"
			],
			[
				"F00000JSAV",
				"JPMorgran International Equity Fund Class R6",
				1798912,
				"Mutual Fund"
			],
			[
				"F00000OB8D",
				"Janus Henderson Triton Fund Class N",
				1375561,
				"Mutual Fund"
			],
			[
				"F000002PJG",
				"American Funds Balanced Fund R6",
				1292315,
				"Mutual Fund"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index Fund",
				172255,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"F000002Q7W",
				"American Funds 2050 Target Date Retirement Fund Class R6",
				49180340,
				"Mutual Fund"
			],
			[
				"F0000045YA",
				"American Funds 2055 Target Date Retirement Fund Class R6",
				43606401,
				"Mutual Fund"
			],
			[
				"F000002Q7V",
				"American Funds 2045 Target Date Retirement Fund Class R6",
				33830848,
				"Mutual Fund"
			],
			[
				"F00000ULLF",
				"American Funds 2060 Target Date Retirement Fund Class R6",
				22254644,
				"Mutual Fund"
			],
			[
				"F000002Q7Y",
				"American Funds 2040 Target Date Retirement Fund Class R6",
				22118943,
				"Mutual Fund"
			],
			[
				"F000002Q7U",
				"American Funds 2035 Target Date Retirement Fund Class R6",
				14167127,
				"Mutual Fund"
			],
			[
				"F000002Q7X",
				"American Funds 2030 Target Date Retirement Fund Class R6",
				8634088,
				"Mutual Fund"
			],
			[
				"F000002Q7T",
				"American Funds 2025 Target Date Retirement Fund Class R6",
				2694496,
				"Mutual Fund"
			],
			[
				"F000002QON",
				"American Funds 2020 Target Date Retirement Fund Class R6",
				2334414,
				"Mutual Fund"
			],
			[
				"F000002POB",
				"American Funds 2010 Target Date Retirement Fund Class R6",
				150786,
				"Mutual Fund"
			],
			[
				"F000002Q7R",
				"American Funds 2015 Target Date Retirement Fund Class R6",
				73280,
				"Mutual Fund"
			]
		],
		"rated_as_option": [
			[
				"F000002Q7W",
				"American Funds 2050 Target Date Retirement Fund Class R6",
				49180340,
				"Mutual Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				10676177,
				11715693,
				0,
				0
			],
			"dff": [
				332154,
				753854,
				0,
				0
			],
			"gff": [
				114609,
				490059,
				0,
				0
			],
			"pff": [
				2050219,
				3895508,
				0,
				0
			],
			"wff": [
				5016886,
				11609433,
				0,
				0
			],
			"tff": [
				682040,
				4891979,
				0,
				0
			]
		}
	},
	"autodesk": {
		"path": "autodesk",
		"employer": "autodesk",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/25/2023",
		"participants": 8218,
		"short_name": "Autodesk",
		"plan_short_name": "Autodesk's 401(k)",
		"primary_plan_name": "Autodesk 401(k) Plan",
		"chart_plan_title": "Autodesk 401(k) Plan",
		"primary_plan_logo": "autodesk",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Autodesk 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Autodesk 401(k) Plan Form 5500 Filing and Attachment 2022",
				"autodesk-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 1379347996,
		"plan_option_count": 23,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 654520046,
			"equity": 585154753,
			"bond": 96164226,
			"other": 43508971,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 654520046
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust I Fund",
				43282140,
				"Common/Collective Trust"
			],
			[
				"",
				"Vanguard Cash Reserves Federal Money Market Fund",
				226831,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund",
				83011102,
				"Mutual Fund"
			],
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund",
				13153124,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund Plus Shares",
				248274131,
				"Mutual Fund"
			],
			[
				"FOUSA02T2O",
				"Vanguard Windsor II Fund Admiral Shares",
				90940911,
				"Mutual Fund"
			],
			[
				"FOUSA02TID",
				"Vanguard International Growth Fund Admiral Shares",
				82164591,
				"Mutual Fund"
			],
			[
				"F000002PJ1",
				"American Funds Growth Fund of America R-6",
				71781893,
				"Mutual Fund"
			],
			[
				"FOUSA00FIG",
				"Vanguard International Value Fund",
				36767437,
				"Mutual Fund"
			],
			[
				"FOUSA02VNS",
				"AMG TimesSquare Small Cap Growth Fund Class Z",
				30275084,
				"Mutual Fund"
			],
			[
				"FOUSA00IHW",
				"Goldman Sachs Small Cap Value Fund",
				24950706,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I Fund",
				153237963,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I Fund",
				97153295,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I Fund",
				89975629,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I Fund",
				77874164,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I Fund",
				64457725,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I Fund",
				61517491,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I Fund",
				53680803,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I Fund",
				19424265,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I Fund",
				17709773,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I Fund",
				13466513,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I Fund",
				6008915,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I Fund",
				13510,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I Fund",
				77874164,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I Fund",
				153237963,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I Fund",
				97153295,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I Fund",
				89975629,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I Fund",
				77874164,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I Fund",
				64457725,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I Fund",
				61517491,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I Fund",
				53680803,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I Fund",
				19424265,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I Fund",
				17709773,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I Fund",
				13466513,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I Fund",
				6008915,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I Fund",
				13510,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				40243676,
				43168505,
				0,
				43168505
			],
			"dff": [
				1225696,
				2728797,
				0,
				2728797
			],
			"gff": [
				1072829,
				421539,
				0,
				421539
			],
			"pff": [
				8944528,
				5846293,
				0,
				5846293
			],
			"wff": [
				24616003,
				17302136,
				0,
				17302136
			],
			"tff": [
				2461014,
				2957469,
				0,
				2957469
			]
		}
	},
	"bloomberg": {
		"path": "bloomberg",
		"employer": "bloomberg",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/18/2023",
		"participants": 17358,
		"short_name": "Bloomberg",
		"plan_short_name": "Bloomberg's 401(k)",
		"primary_plan_name": "Bloomberg L.P. 401(k) Plan",
		"chart_plan_title": "Bloomberg L.P. 401(k) Plan",
		"primary_plan_logo": "bloomberg",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock LifePath Index series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Bloomberg L.P. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Bloomberg L.P. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"bloomberg-l-p-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 3745337791,
		"plan_option_count": 26,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1326621310,
			"equity": 1934375862,
			"bond": 185770830,
			"other": 298569789,
			"sri": 46985887,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"BlackRock Short-Term Investment-W",
				199576866,
				"Common Collective Trust"
			],
			[
				"",
				"Galliard Managed Income Fund Core MC",
				98992923,
				"Common Collective Trust"
			]
		],
		"bond_plan_options": [
			[
				"",
				"Prudential Core Plus Bond Fund 5",
				117982227,
				"Common Collective Trust"
			],
			[
				"F00000QT2G",
				"State Street Global Advisors US Bond Index Non-Lending Fund Class K",
				67788603,
				"Common Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00F0N",
				"State Street Global Advisors S&P 500 Index Fund Class K",
				649017506,
				"Common Collective Trust"
			],
			[
				"F00000VV1D",
				"State Street Global Advisors Russell Small/Mid Cap Index Fund K",
				210684574,
				"Common Collective Trust"
			],
			[
				"FOUSA00D2I",
				"Harbor Trust Company Capital Appreciation CIT 4",
				202815449,
				"Common Collective Trust"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				170878132,
				"Mutual Funds"
			],
			[
				"FOUSA00CEO",
				"Fidelity Contrafund Commingled Pool",
				146978435,
				"Common Collective Trust"
			],
			[
				"F00000VOGS",
				"Loomis Sayles Small/Mid Cap Growth Trust",
				140184536,
				"Common Collective Trust"
			],
			[
				"FOUSA00C3I",
				"Dodge & Cox Balanced Fund",
				112070073,
				"Mutual Funds"
			],
			[
				"",
				"TSW International Large Cap Equity Class 2",
				83060383,
				"Common Collective Trust"
			],
			[
				"F00000T8Y8",
				"State Street Global Advisors Global All Cap Equity EX-US Index",
				77134187,
				"Common Collective Trust"
			],
			[
				"",
				"Alliance Bernstein AB US Small & Mid Cap Value P-2 Class",
				53302917,
				"Common Collective Trust"
			],
			[
				"FOUSA05HGA",
				"Parnassus Sustainable Core Equity CIT 1",
				46985887,
				"Common Collective Trust",
				"sri"
			],
			[
				"FOUSA05CLF",
				"DFA Emerging Markets Core Equity I",
				41263783,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPH",
				"BlackRock Life Path Index 2045 Non-Lendable M",
				253705879,
				"Common Collective Trust"
			],
			[
				"F00000MAPG",
				"BlackRock Life Path Index 2050 Non-Lendable M",
				240686207,
				"Common Collective Trust"
			],
			[
				"F00000MAPI",
				"BlackRock Life Path Index 2035 Non-Lendable M",
				218719985,
				"Common Collective Trust"
			],
			[
				"F00000MAPJ",
				"BlackRock Life Path Index 2035 Non-Lendable M",
				168749455,
				"Common Collective Trust"
			],
			[
				"F00000MAP0",
				"BlackRock Life Path Index 2055 Non-Lendable M",
				143784330,
				"Common Collective Trust"
			],
			[
				"F00000MAPK",
				"BlackRock Life Path Index 2030 Non-Lendable M",
				117009447,
				"Common Collective Trust"
			],
			[
				"F00000WM8M",
				"BlackRock Life Path Index 2060 Non-Lendable M",
				75248425,
				"Common Collective Trust"
			],
			[
				"F00000MAPL",
				"BlackRock Life Path Index 2025 Non-Lendable M",
				63692752,
				"Common Collective Trust"
			],
			[
				"F00000MAOX",
				"BlackRock Life Path Index Retirement Non-Lendable M",
				29199259,
				"Common Collective Trust"
			],
			[
				"F000013OYO",
				"BlackRock Life Path Index 2065 Non-Lendable M",
				15825571,
				"Common Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock Life Path Index 2050 Non-Lendable M",
				240686207,
				"Common Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				123596802,
				95341761,
				0,
				0
			],
			"dff": [
				3058597,
				5213894,
				0,
				0
			],
			"gff": [
				1059656,
				854267,
				0,
				0
			],
			"pff": [
				24349480,
				12636207,
				0,
				0
			],
			"wff": [
				76809838,
				37879348,
				0,
				0
			],
			"tff": [
				6880932,
				6202552,
				0,
				0
			]
		}
	},
	"booking-holdings": {
		"path": "booking_holdings",
		"employer": "booking-holdings",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/19/2024",
		"participants": 5519,
		"short_name": "Booking Holdings",
		"plan_short_name": "Booking Holdings' 401(k)",
		"primary_plan_name": "The Booking Holdings Inc, 401(k) Plan",
		"chart_plan_title": "The Booking Holdings Inc,\n401(k) Plan",
		"primary_plan_logo": "booking_holdings",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"The Booking Holdings Inc, 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"The Booking Holdings Inc, 401(k) Plan Form 5500 Filing and Attachment 2023",
				"the-booking-holdings-inc-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 434730881,
		"plan_option_count": 28,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 188197998,
			"equity": 214193052,
			"bond": 19932183,
			"other": 12407648,
			"sri": 32039127,
			"cref": 0,
			"vanguard_target": 188197371
		},
		"other_plan_options": [
			[
				"",
				"BNYM MELLON STABLE VALUE FUND M",
				11635101,
				"Stable Value Fund"
			],
			[
				"",
				"GABELLI US TREASURY MMKT AA",
				772547,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"F00001DHJY",
				"DODGE & COX INCOME X",
				9505442,
				"Mutual Fund"
			],
			[
				"F00000LZX3",
				"FIDELITY US BOND INDEX",
				6900981,
				"Mutual Fund"
			],
			[
				"",
				"PIMCO DIVERSIFIED REAL ASSET CIT",
				3405575,
				"Common Collective Trust"
			],
			[
				"F00000NBIL",
				"VANGUARD TOTAL INTL BD IDX ADMIRAL",
				120185,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"FIDELITY 500 INDEX",
				85722260,
				"Mutual Fund"
			],
			[
				"FOUSA00LB6",
				"FIDELITY EXTENDED MARKET IDX",
				37813559,
				"Mutual Fund"
			],
			[
				"FOUSA05HGA",
				"PARNASSUS SUSTAINABLE CORE EQUITY CIT 1",
				32039127,
				"Common Collective Trust",
				"sri"
			],
			[
				"F000002P1T",
				"AMERICAN FUNDS EUROPACIFIC GR R6",
				22970024,
				"Mutual Fund"
			],
			[
				"F00000JSAQ",
				"PGIM JENNISON SMALL COMPANY R6",
				18751010,
				"Mutual Fund"
			],
			[
				"F00000WZVM",
				"FIDELITY TOTAL INTERNATIONAL INDEX",
				12827953,
				"Mutual Fund"
			],
			[
				"F00000JSGY",
				"JP MORGAN LARGE CAP GROWTH R6",
				1748170,
				"Mutual Fund"
			],
			[
				"F00000WHXG",
				"VICTORY SYCAMORE SMALL COMPANY OPP R6",
				1334165,
				"Mutual Fund"
			],
			[
				"FOUSA02TIM",
				"VANGUARD EQUITY-INCOME ADM",
				986784,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"VANGUARD TARGET RETIREMENT 2050 TRUST",
				41866282,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"VANGUARD TARGET RETIREMENT 2055 TRUST",
				36698637,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET RETIREMENT 2045 TRUST",
				35541856,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"VANGUARD TARGET RETIREMENT 2040 TRUST",
				19453902,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET RETIREMENT 2060 TRUST",
				14870939,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET RETIREMENT 2035 TRUST",
				14428515,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET RETIREMENT 2030 TRUST",
				12740332,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET RETIREMENT 2025 TRUST",
				6315000,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET REITREMENT INCOME TRUST",
				2281333,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET RETIREMENT 2020 TRUST",
				2224243,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"VANGUARD TARGET RETIREMENT 2065 TRUST",
				1716698,
				"Common Collective Trust"
			],
			[
				"F00001DBZ9",
				"VANGUARD TARGET RETIREMENT 2070 TRUST",
				59634,
				"Common Collective Trust"
			],
			[
				"",
				"TARGET RETIREMENT INCOME AND GROWTH TRUST",
				627,
				"Common Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"VANGUARD TARGET RETIREMENT 2050 TRUST",
				41866282,
				"Common Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"VANGUARD TARGET RETIREMENT 2050 TRUST",
				41866282,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"VANGUARD TARGET RETIREMENT 2055 TRUST",
				36698637,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET RETIREMENT 2045 TRUST",
				35541856,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"VANGUARD TARGET RETIREMENT 2040 TRUST",
				19453902,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET RETIREMENT 2060 TRUST",
				14870939,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET RETIREMENT 2035 TRUST",
				14428515,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET RETIREMENT 2030 TRUST",
				12740332,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET RETIREMENT 2025 TRUST",
				6315000,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET REITREMENT INCOME TRUST",
				2281333,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET RETIREMENT 2020 TRUST",
				2224243,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"VANGUARD TARGET RETIREMENT 2065 TRUST",
				1716698,
				"Common Collective Trust"
			],
			[
				"F00001DBZ9",
				"VANGUARD TARGET RETIREMENT 2070 TRUST",
				59634,
				"Common Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				14406411,
				14067105,
				0,
				14067105
			],
			"dff": [
				481515,
				890453,
				0,
				890453
			],
			"gff": [
				154479,
				137159,
				0,
				137159
			],
			"pff": [
				2694322,
				1902667,
				0,
				1902667
			],
			"wff": [
				8392734,
				5636704,
				0,
				5636704
			],
			"tff": [
				1068224,
				963291,
				0,
				963291
			]
		}
	},
	"bristol-myers-squibb": {
		"path": "bristol_myers_squibb",
		"employer": "bristol-myers-squibb",
		"year": 2022,
		"updated": " June 2023",
		"filing_received": " 06/27/2023",
		"participants": 4584,
		"short_name": "Bristol-Myers Squibb",
		"plan_short_name": "Bristol-Myers Squibb's 401(k)",
		"primary_plan_name": "Bristol-Myers Squibb Savings Plans Master Trust",
		"chart_plan_title": "Bristol-Myers Squibb\nSavings Plans Master Trust",
		"primary_plan_logo": "bristol_myers_squibb",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Bristol-Myers Squibb Savings Plans Master Trust",
			"Bristol-Myers Squibb Savings And Investment Program",
			"Bristol-Myers Squibb Puerto Rico, Inc. Savings And Investment Program",
			"Bristol-Myers Squibb Company Employee Incentive Thrift Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Bristol-Myers Squibb Savings Plans Master Trust Form 5500 Filing and Attachment 2022",
				"bristol-myers-squibb-savings-plans-master-trust-form-5500-filing-and-attachment-2022.pdf"
			],
			[
				"Bristol-Myers Squibb Savings And Investment Program Form 5500 Filing and Attachment 2022",
				"bristol-myers-squibb-savings-and-investment-program-form-5500-filing-and-attachment-2022.pdf"
			],
			[
				"Bristol-Myers Squibb Puerto Rico, Inc. Savings And Investment Program Form 5500 Filing and Attachment 2022",
				"bristol-myers-squibb-puerto-rico-inc-savings-and-investment-program-form-5500-filing-and-attachment-2022.pdf"
			],
			[
				"Bristol-Myers Squibb Company Employee Incentive Thrift Plan Form 5500 Filing and Attachment 2022",
				"bristol-myers-squibb-company-employee-incentive-thrift-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 8863222744,
		"plan_option_count": 28,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 2551935513,
			"equity": 3913874001,
			"bond": 1117084197,
			"other": 1280329033,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"COMPANY STOCK",
				802241852,
				""
			],
			[
				"",
				"VANG VMMR-FED MMKT",
				478087181,
				""
			]
		],
		"bond_plan_options": [
			[
				"",
				"GALLIARD FIXED INC",
				549361928,
				""
			],
			[
				"F00000LZX3",
				"FID US BOND IDX",
				496217779,
				""
			],
			[
				"FOUSA00H9T",
				"TCW/MW TOT RTN CIT",
				55339908,
				""
			],
			[
				"",
				"GALLIARD FIX INC PR",
				16164582,
				""
			],
			[
				"FOUSA00H9T",
				"METWEST TOT RTN BD D",
				0,
				""
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"SP 500 INDEX PL CL E",
				1450889984,
				""
			],
			[
				"FOUSA00CH5",
				"FID GR CO POOL CL 3",
				1101343820,
				""
			],
			[
				"F00000JTBU",
				"VG IS TL INTL STK MK",
				415804697,
				""
			],
			[
				"F00000MJRH",
				"NT EXT MKT IDX NL 4",
				367301317,
				""
			],
			[
				"F00000YDFU",
				"GW&K SMID CIT",
				275186188,
				""
			],
			[
				"F000002P1T",
				"CG EUROPAC GRTH U2",
				182791069,
				""
			],
			[
				"F0000152GG",
				"MFS LARGE CAP VAL 4",
				98448966,
				""
			],
			[
				"F00000JTBV",
				"VANG TOT INTL STK IP",
				22107960,
				""
			]
		],
		"default_plan_options": [
			[
				"FOUSA02VNC",
				"TRP RETIRE 2030 E",
				490827741,
				""
			],
			[
				"FOUSA02VND",
				"TRP RETIRE 2040 E",
				476221986,
				""
			],
			[
				"FOUSA0565C",
				"TRP RETIRE 2035 E",
				406172298,
				""
			],
			[
				"FOUSA05C00",
				"TRP RETIRE 2045 E",
				284337298,
				""
			],
			[
				"FOUSA0565B",
				"TRP RETIRE 2025 E",
				283551416,
				""
			],
			[
				"FOUSA068A0",
				"TRP RETIRE 2050 E",
				229382666,
				""
			],
			[
				"FOUSA02VNB",
				"TRP RETIRE 2020 E",
				140389476,
				""
			],
			[
				"FOUSA068A1",
				"TRP RETIRE 2055 E",
				104472002,
				""
			],
			[
				"F00000SZHW",
				"TRP RETIRE 2060 E",
				48618244,
				""
			],
			[
				"FOUSA05659",
				"TRP RETIRE 2005 E",
				35845830,
				""
			],
			[
				"FOUSA0565A",
				"TRP RETIRE 2015 E",
				28245954,
				""
			],
			[
				"FOUSA02VNA",
				"TRP RETIRE 2010 E",
				14485810,
				""
			],
			[
				"F0000155P4",
				"TRP RETIRE 2065 E",
				9384792,
				""
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"TRP RETIRE 2050 E",
				229382666,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				238163121,
				212873252,
				0,
				0
			],
			"dff": [
				10307476,
				14551807,
				0,
				0
			],
			"gff": [
				2363853,
				2642165,
				0,
				0
			],
			"pff": [
				41286624,
				18869800,
				0,
				0
			],
			"wff": [
				132943440,
				93419787,
				0,
				0
			],
			"tff": [
				30173180,
				4930523,
				0,
				0
			]
		}
	},
	"broadcom": {
		"path": "broadcom",
		"employer": "broadcom",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/16/2023",
		"participants": 21709,
		"short_name": "Broadcom",
		"plan_short_name": "Broadcom's 401(k)",
		"primary_plan_name": "Broadcom U.S. 401(k) Plan",
		"chart_plan_title": "Broadcom U.S. 401(k) Plan",
		"primary_plan_logo": "broadcom",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Broadcom U.S. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Broadcom U.S. 401(k) Plan Form 5500 Filing 2022",
				"broadcom-us-401k-plan-form-5500-filing-2022.pdf"
			]
		],
		"plan_assets": 5919595683,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1727463714,
			"equity": 3388450629,
			"bond": 330354550,
			"other": 473326790,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1727463714
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Investments Money Market Treasury - Insititutional Class",
				406688378,
				"Money Market Fund"
			],
			[
				"",
				"Invesco Stable Value Trust Class A1",
				66604359,
				"Common/Collective Trust"
			],
			[
				"",
				"Fidelity Investments Money Market Treasury - Class I",
				34053,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00FPV",
				"TCW Total Return Bond I",
				128319944,
				"Common/Collective Trust"
			],
			[
				"F00000MPYP",
				"Vanguard Short-Term Bond Index Fund Institutional",
				108522210,
				"Registered Investment Company"
			],
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund Institutional",
				93512396,
				"Common/Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA06U0Z",
				"Fidelity Growth Company Pool Class 3",
				1211191148,
				"Common/Collective Trust"
			],
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				1060973909,
				"Common/Collective Trust"
			],
			[
				"FOUSA00J83",
				"Vanguard Mid Cap Index IS",
				205825041,
				"Registered Investment Company"
			],
			[
				"F00000JS7I",
				"MassMutual Select Mid Cap Growth",
				197199838,
				"Registered Investment Company"
			],
			[
				"",
				"Boston Partners Mid Cap Value Equity",
				173715984,
				"Separately Managed Account"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth R6",
				161048902,
				"Registered Investment Company"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				151256676,
				"Registered Investment Company"
			],
			[
				"FOUSA00GQ5",
				"Vanguard Small Cap Index Fund Institutional",
				141889832,
				"Registered Investment Company"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Investment Fund",
				85349299,
				"Common/Collective Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				343000110,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				330872746,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				279224647,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				265798607,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				167639414,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				109881407,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				109617011,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				57099200,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				38562977,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				13258138,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				12509457,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				109617011,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				343000110,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				330872746,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				279224647,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				265798607,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				167639414,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				109881407,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				109617011,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				57099200,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				38562977,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				13258138,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				12509457,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				180885355,
				104260439,
				0,
				104260439
			],
			"dff": [
				6313318,
				6581575,
				0,
				6581575
			],
			"gff": [
				1576457,
				1019599,
				0,
				1019599
			],
			"pff": [
				42911338,
				14137732,
				0,
				14137732
			],
			"wff": [
				102118389,
				41798698,
				0,
				41798698
			],
			"tff": [
				22720333,
				7146112,
				0,
				7146112
			]
		}
	},
	"campbell-soup": {
		"path": "campbell_soup",
		"employer": "campbell-soup",
		"year": 2022,
		"updated": " July 2023",
		"filing_received": " 07/18/2023",
		"participants": 20039,
		"short_name": "Campbell Soup Company",
		"plan_short_name": "Campbell Soup's 401(k)",
		"primary_plan_name": "Campbell Soup Company 401(k) Retirement Plan",
		"chart_plan_title": "Campbell Soup Company 401(k)\nRetirement Plan",
		"primary_plan_logo": "campbell_soup",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "reduce Scope 1 and 2 emissions by 42% by 2030",
		"proposal_title": "Proposal 6 - 401(k) Retirement Fund Investment Report",
		"proposal_url": "2023/06/20-campbell-protect-retirement-beneficiaries-portfolio-climate-risk",
		"plan_names": [
			"Campbell Soup Company 401(k) Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Campbell Soup Company 401(k) Retirement Plan Form 5500 Filing and Attachment 2022",
				"campbell-soup-company-401k-retirement-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 1729929483,
		"plan_option_count": 25,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 698214119,
			"equity": 684267855,
			"bond": 84261027,
			"other": 263186482,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 698214119
		},
		"other_plan_options": [
			[
				"",
				"Campbell Soup Company Stock Fund",
				137707666,
				"Company Stock"
			],
			[
				"",
				"Blackrock Short-Term Investment Fund",
				125478816,
				"Common Collective Trust"
			]
		],
		"bond_plan_options": [
			[
				"F00000MPYP",
				"Vanguard Short-Term Bond Index Fund Institutional Shares",
				31313638,
				"Mutual Fund"
			],
			[
				"F000004494",
				"Vanguard Institutional Total Bond Market Index Trust",
				23849861,
				"Common Collective Trust"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund Institutional Class",
				21920388,
				"Mutual Fund"
			],
			[
				"FOUSA00G06",
				"PIMCO Real Return Fund Institutional Class",
				7177140,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F000002PJ1",
				"American Funds Growth Fund of America Class R-6",
				183310244,
				"Mutual Fund"
			],
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				173127318,
				"Common Collective Trust"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity-Income Fund Admiral Shares",
				132548847,
				"Mutual Fund"
			],
			[
				"FOUSA00GPW",
				"Vanguard Institutional Extended Market Index Trust",
				73696727,
				"Common Collective Trust"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund Class R-6",
				53326872,
				"Mutual Fund"
			],
			[
				"FOUSA00EKG",
				"T. Rowe Price Small-Cap Value Equity Trust D",
				47414834,
				"Common Collective Trust"
			],
			[
				"F00000JTBU",
				"Vanguard Institutional Total International Stock Index Trust",
				20843013,
				"Common Collective Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I",
				103181651,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I",
				94085159,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I",
				89200852,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I",
				88267166,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I",
				88060153,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				85630441,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I",
				56341901,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I",
				34694040,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I",
				28301197,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I",
				20720616,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I",
				9502947,
				"Common Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I",
				227996,
				"Common Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				85630441,
				"Common Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I",
				103181651,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I",
				94085159,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I",
				89200852,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I",
				88267166,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I",
				88060153,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				85630441,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I",
				56341901,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I",
				34694040,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I",
				28301197,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I",
				20720616,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I",
				9502947,
				"Common Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I",
				227996,
				"Common Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				65060183,
				45523590,
				0,
				45523590
			],
			"dff": [
				2421132,
				2877546,
				0,
				2877546
			],
			"gff": [
				1304611,
				444556,
				0,
				444556
			],
			"pff": [
				12500333,
				6165483,
				0,
				6165483
			],
			"wff": [
				34042929,
				18246210,
				0,
				18246210
			],
			"tff": [
				5740896,
				3118860,
				0,
				3118860
			]
		}
	},
	"centene": {
		"path": "centene",
		"employer": "centene",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/11/2024",
		"participants": 65995,
		"short_name": "Centene Corporation",
		"plan_short_name": "Centene's 401(k)",
		"primary_plan_name": "Centene Management Corporation Retirement Plan",
		"chart_plan_title": "Centene Management Corporation\nRetirement Plan",
		"primary_plan_logo": "centene",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Blend series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Centene Management Corporation Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Centene Management Corporation Retirement Plan Form 5500 Filing and Attachment 2023",
				"centene-management-corporation-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3936439236,
		"plan_option_count": 33,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 2690196831,
			"equity": 978936169,
			"bond": 116753603,
			"other": 150552633,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Putnam Stable Value Fund",
				96056943,
				"Collective Trust Fund"
			],
			[
				"",
				"Fidelity Investments Money Market Government Portfolio Institutional Class",
				54495690,
				"Money Market Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02VNL",
				"Fidelity Total Bond",
				96893916,
				"Mutual Fund"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation Protected Securities Fund Institutional",
				19859687,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				299809738,
				"Mutual Fund"
			],
			[
				"F00000WZVI",
				"Fidelity Large Cap Value Index",
				135873826,
				"Mutual Fund"
			],
			[
				"F00000WMWX",
				"T. Rowe Price Blue Chip Growth T2",
				93602533,
				"Collective Trust Fund"
			],
			[
				"FOUSA06TXE",
				"Fidelity International Discovery Pool",
				70134898,
				"Collective Trust Fund"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index",
				55723365,
				"Mutual Fund"
			],
			[
				"FOUSA02TY7",
				"Vanguard Healthcare Administration",
				53277978,
				"Mutual Fund"
			],
			[
				"F00000OB9Z",
				"Janus Henderson Enterprise N",
				51908373,
				"Mutual Fund"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index",
				50625066,
				"Mutual Fund"
			],
			[
				"FOUSA00B2S",
				"American Beacon Large Cap Value Institutional",
				49566628,
				"Mutual Fund"
			],
			[
				"F000011GCX",
				"Invesco Developing Markets R5",
				24661655,
				"Mutual Fund"
			],
			[
				"FOUSA00HD4",
				"UBS U.S. Small Cap Growth",
				21872321,
				"Mutual Fund"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value R6",
				20465513,
				"Mutual Fund"
			],
			[
				"F00000WZW5",
				"Fidelity Large Cap Growth Index",
				19593103,
				"Mutual Fund"
			],
			[
				"FOUSA00BP7",
				"Cohen & Steer Realty",
				16694830,
				"Mutual Fund"
			],
			[
				"FOUSA00DUZ",
				"Delaware Small Cap Value Institutional",
				8718088,
				"Mutual Fund"
			],
			[
				"F00000N785",
				"Ariel Fund Institutional",
				6408254,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"F000010OKH",
				"Fidelity Freedom Blend 2035 T",
				462221731,
				"Collective Trust Fund"
			],
			[
				"F000010OKQ",
				"Fidelity Freedom Blend 2040 T",
				437020425,
				"Collective Trust Fund"
			],
			[
				"F000010OF4",
				"Fidelity Freedom Blend 2045 T",
				390263285,
				"Collective Trust Fund"
			],
			[
				"F000010OK8",
				"Fidelity Freedom Blend 2030 T",
				379268213,
				"Collective Trust Fund"
			],
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 T",
				325660797,
				"Collective Trust Fund"
			],
			[
				"F000010OJZ",
				"Fidelity Freedom Blend 2025 T",
				249889504,
				"Collective Trust Fund"
			],
			[
				"F000010OFS",
				"Fidelity Freedom Blend 2055 T",
				212250966,
				"Collective Trust Fund"
			],
			[
				"F000010OJQ",
				"Fidelity Freedom Blend 2020 T",
				107884317,
				"Collective Trust Fund"
			],
			[
				"F000010OFU",
				"Fidelity Freedom Blend 2060 T",
				80307491,
				"Collective Trust Fund"
			],
			[
				"F000010OJH",
				"Fidelity Freedom Blend 2015 T",
				22646754,
				"Collective Trust Fund"
			],
			[
				"F000010OG4",
				"Fidelity Freedom Blend 2005 T",
				10182042,
				"Collective Trust Fund"
			],
			[
				"F000010OGD",
				"Fidelity Freedom Blend 2010 T",
				7913106,
				"Collective Trust Fund"
			],
			[
				"F000010OET",
				"Fidelity Freedom Blend Income T",
				4688200,
				"Collective Trust Fund"
			]
		],
		"rated_as_option": [
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 T",
				325660797,
				"Collective Trust Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				81568013,
				182825903,
				0,
				0
			],
			"dff": [
				2665551,
				7284500,
				0,
				0
			],
			"gff": [
				1181445,
				1750111,
				0,
				0
			],
			"pff": [
				16278139,
				20970096,
				0,
				0
			],
			"wff": [
				40542866,
				120663439,
				0,
				0
			],
			"tff": [
				5804921,
				11525281,
				0,
				0
			]
		}
	},
	"chevron": {
		"path": "chevron",
		"employer": "chevron",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/11/2023",
		"participants": 34202,
		"short_name": "Chevron",
		"plan_short_name": "Chevron's 401(k)",
		"primary_plan_name": "Chevron Employee Savings Investment Plan",
		"chart_plan_title": "Chevron Employee Savings\nInvestment Plan",
		"primary_plan_logo": "chevron",
		"coreissue": "prison-industrial-complex",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Chevron Employee Savings Investment Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Chevron Employee Savings Investment Plan Form 5500 Filing and Attachment 2022",
				"chevron-employee-savings-investment-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 18046810000,
		"plan_option_count": 28,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1961412000,
			"equity": 7219301000,
			"bond": 1291217000,
			"other": 7574880000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1961412000
		},
		"other_plan_options": [
			[
				"",
				"Chevron Corporation",
				6192864000,
				"Common Stock"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				1375609000,
				"Registered Investment Companies"
			],
			[
				"",
				"TRP Stable Value Fund ",
				3307000,
				"Stable Value Collective Investment Funds"
			],
			[
				"",
				"ABC Stable Value Fund ",
				3100000,
				"Stable Value Collective Investment Funds"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Institutional Total Bond Market Index Trust",
				655750000,
				"Collective Investment Funds"
			],
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Separate Account",
				349652000,
				"Separate Account"
			],
			[
				"FOUSA02TYF",
				"Vanguard Short-Term Bond Fund Index",
				167117000,
				"Registered Investment Companies"
			],
			[
				"FOUSA06B89",
				"SSgA Inflation Prot Bond Index",
				118698000,
				"Collective Investment Funds"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				3054898000,
				"Collective Investment Funds"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Fund",
				1217184000,
				"Registered Investment Companies"
			],
			[
				"F00000WTNQ",
				"Vanguard Institutional Extended Market Trust",
				1075595000,
				"Collective Investment Funds"
			],
			[
				"FOUSA00LA4",
				"Vanguard Value Index Fund",
				737706000,
				"Registered Investment Companies"
			],
			[
				"FOUSA02SN7",
				"Vanguard Developed Market Index Trust",
				612531000,
				"Collective Investment Funds"
			],
			[
				"FOUSA00CBJ",
				"Capital Group EuropPacific Growth Trust",
				214670000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05IBW",
				"Vanguard Emerging Market Stock Index Fund",
				200636000,
				"Registered Investment Companies"
			],
			[
				"FOUSA02TYE",
				"Vanguard REIT Index Fund",
				106081000,
				"Registered Investment Companies"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B98",
				"Vanguard Target Date Retirement Trust 2025 Select",
				298030000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Date Retirement Trust 2030 Select",
				276191000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Date Retirement Trust 2035 Select",
				261270000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Date Retirement Trust 2040 Select",
				235168000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Date Retirement Trust 2045 Select",
				230103000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Date Retirement Trust 2020 Select",
				183090000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Date Retirement Trust 2050 Select",
				183057000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Date Retirement Trust Select",
				114215000,
				"Collective Investment Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target Date Retirement Trust 2055 Select",
				105052000,
				"Collective Investment Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Date Retirement Trust 2060 Select",
				52242000,
				"Collective Investment Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Date Retirement Trust 2065 Select",
				21746000,
				"Collective Investment Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Date Retirement Trust 2070 Select",
				1248000,
				"Collective Investment Funds"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Date Retirement Trust 2050 Select",
				183057000,
				"Collective Investment Funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B98",
				"Vanguard Target Date Retirement Trust 2025 Select",
				298030000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Date Retirement Trust 2030 Select",
				276191000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Date Retirement Trust 2035 Select",
				261270000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Date Retirement Trust 2040 Select",
				235168000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Date Retirement Trust 2045 Select",
				230103000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Date Retirement Trust 2020 Select",
				183090000,
				"Collective Investment Funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Date Retirement Trust 2050 Select",
				183057000,
				"Collective Investment Funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Date Retirement Trust Select",
				114215000,
				"Collective Investment Funds"
			],
			[
				"F00000ISUB",
				"Vanguard Target Date Retirement Trust 2055 Select",
				105052000,
				"Collective Investment Funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Date Retirement Trust 2060 Select",
				52242000,
				"Collective Investment Funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Date Retirement Trust 2065 Select",
				21746000,
				"Collective Investment Funds"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Date Retirement Trust 2070 Select",
				1248000,
				"Collective Investment Funds"
			]
		],
		"screen_results": {
			"fff": [
				611974419,
				119529447,
				0,
				119529447
			],
			"dff": [
				21791010,
				7555474,
				0,
				7555474
			],
			"gff": [
				7636028,
				1167251,
				0,
				1167251
			],
			"pff": [
				114822187,
				16188424,
				0,
				16188424
			],
			"wff": [
				288676106,
				47908312,
				0,
				47908312
			],
			"tff": [
				44355406,
				8189058,
				0,
				8189058
			]
		}
	},
	"chipotle": {
		"path": "chipotle",
		"employer": "chipotle",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/14/2024",
		"participants": 80598,
		"short_name": "Chipotle Mexican Grill",
		"plan_short_name": "Chipotle's 401(k)",
		"primary_plan_name": "Chipotle Mexican Grill, Inc. 401(k) Plan",
		"chart_plan_title": "Chipotle Mexican Grill, Inc.\n401(k) Plan",
		"primary_plan_logo": "chipotle",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Chipotle Mexican Grill, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Chipotle Mexican Grill, Inc. 401(k) Plan Form 5500 Filing and Attachment 2023",
				"chipotle-mexican-grill-inc-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 230088185,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 141571298,
			"equity": 77702135,
			"bond": 5360189,
			"other": 5454563,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 141571298
		},
		"other_plan_options": [
			[
				"",
				"Goldman Sachs Stable Value Collective Trust",
				4328344,
				"Common Collective Fund"
			],
			[
				"",
				"Vanguard Funds - Short Term Investment Grade Fund",
				1126219,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00P5F",
				"Baird Core Plus Bond Inst",
				3711554,
				"Mutual Fund"
			],
			[
				"FOUSA02TYI",
				"Vanguard Total Bond Market Index Adm",
				1648635,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index I",
				18939034,
				"Mutual Fund"
			],
			[
				"F00000JSGY",
				"JP Morgan Large Cap Growth R6 Fund",
				16958991,
				"Mutual Fund"
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Inst Fund",
				12690624,
				"Mutual Fund"
			],
			[
				"FOUSA00C29",
				"DFA Funds - US Small Cap Portfolio Fund",
				8108331,
				"Mutual Fund"
			],
			[
				"F000002P1T",
				"American Funds - Europacific Fund",
				6215264,
				"Mutual Fund"
			],
			[
				"F00000JTEF",
				"Vanguard Total International Stock Index Adm",
				3902479,
				"Mutual Fund"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Adm",
				3342410,
				"Mutual Fund"
			],
			[
				"FOUSA00H6R",
				"DFA Funds - International Small Company Fund",
				2831255,
				"Mutual Fund"
			],
			[
				"F00000MMWN",
				"Carillon Eagle Mid Cap Growth",
				2373059,
				"Mutual Fund"
			],
			[
				"F00000Q7J5",
				"American Century Mid Cap Value",
				2340688,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Investment",
				36454076,
				"Mutual Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional - Target Retirement 2045 Fund",
				35524502,
				"Mutual Fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional - Target Retirement 2035 Fund",
				20997436,
				"Mutual Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional - Target Retirement 2060 Fund",
				11934353,
				"Mutual Fund"
			],
			[
				"F00000YE51",
				"Vangaurd Institutional - Target Retirement 2065 Fund",
				10643546,
				"Mutual Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional - Target Retirement 2025 Fund",
				8944906,
				"Mutual Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional - Target Retirement 2050 Fund",
				8033423,
				"Mutual Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional - Target Retirement 2040 Fund",
				3779289,
				"Mutual Fund"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional - Target Retirement 2030 Fund",
				2601937,
				"Mutual Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Investment",
				1204819,
				"Mutual Fund"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				1166414,
				"Mutual Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				286597,
				"Mutual Fund"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional - Target Retirement 2050 Fund",
				8033423,
				"Mutual Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Investment",
				36454076,
				"Mutual Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional - Target Retirement 2045 Fund",
				35524502,
				"Mutual Fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional - Target Retirement 2035 Fund",
				20997436,
				"Mutual Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional - Target Retirement 2060 Fund",
				11934353,
				"Mutual Fund"
			],
			[
				"F00000YE51",
				"Vangaurd Institutional - Target Retirement 2065 Fund",
				10643546,
				"Mutual Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional - Target Retirement 2025 Fund",
				8944906,
				"Mutual Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional - Target Retirement 2050 Fund",
				8033423,
				"Mutual Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional - Target Retirement 2040 Fund",
				3779289,
				"Mutual Fund"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional - Target Retirement 2030 Fund",
				2601937,
				"Mutual Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Investment",
				1204819,
				"Mutual Fund"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				1166414,
				"Mutual Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				286597,
				"Mutual Fund"
			]
		],
		"screen_results": {
			"fff": [
				6773235,
				10598570,
				0,
				10598570
			],
			"dff": [
				176795,
				671025,
				0,
				671025
			],
			"gff": [
				80514,
				103318,
				0,
				103318
			],
			"pff": [
				1206186,
				1433265,
				0,
				1433265
			],
			"wff": [
				3212131,
				4246703,
				0,
				4246703
			],
			"tff": [
				791814,
				725725,
				0,
				725725
			]
		}
	},
	"chubb-us": {
		"path": "chubb_us",
		"employer": "chubb-us",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/01/2024",
		"participants": 22134,
		"short_name": "Chubb US",
		"plan_short_name": "The Chubb US 401(k)",
		"primary_plan_name": "Chubb US 401(k) Plan",
		"chart_plan_title": "Chubb US 401(k) Plan",
		"primary_plan_logo": "chubb_us",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Chubb US 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Chubb US 401(k) Plan Form 5500 Filing and Attachment 2023",
				"chubb-us-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 4079576261,
		"plan_option_count": 25,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1760463207,
			"equity": 1794043576,
			"bond": 269100539,
			"other": 255968939,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"T. Rowe Price STABLE VALUE F",
				167314663,
				""
			],
			[
				"",
				"Vanguard TREASURY MM",
				88654276,
				""
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02VYJ",
				"PIMCO TOTAL RETURN",
				174664690,
				""
			],
			[
				"FOUSA04BL6",
				"Vanguard INFL PROT INST",
				92158274,
				""
			],
			[
				"FOUSA00DIL",
				"Vanguard TOT BD MKT INST",
				2277575,
				""
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard INST INDEX PLUS",
				662677129,
				""
			],
			[
				"FOUSA02VIY",
				"T. Rowe Price US LG CAP GR EQ",
				313953376,
				""
			],
			[
				"FOUSA00EJD",
				"T. Rowe Price INTL GR EQ C",
				273694142,
				""
			],
			[
				"FOUSA00EJR",
				"T. Rowe Price NEW HORIZONS",
				201016153,
				""
			],
			[
				"FOUSA00KWE",
				"T. Rowe Price IS MID CP EQ GR",
				196595428,
				""
			],
			[
				"FOUSA02T18",
				"Wellington EQ INC",
				136498115,
				""
			],
			[
				"FOUSA06LBG",
				"Goldman Sachs INTL SM CP INS I",
				9609233,
				""
			]
		],
		"default_plan_options": [
			[
				"FOUSA04BEZ",
				"T. Rowe Price RETIRE 2030 C",
				317507630,
				""
			],
			[
				"FOUSA06BXI",
				"T. Rowe Price RETIRE 2035 C",
				289466467,
				""
			],
			[
				"FOUSA06BXG",
				"T. Rowe Price RETIRE 2025 C",
				257144294,
				""
			],
			[
				"FOUSA04BF0",
				"T. Rowe Price RETIRE 2040 C",
				239271445,
				""
			],
			[
				"FOUSA06BXK",
				"T. Rowe Price RETIRE 2045 C",
				192527979,
				""
			],
			[
				"FOUSA068A3",
				"T. Rowe Price RETIRE 2050 C",
				137918342,
				""
			],
			[
				"FOUSA06BXM",
				"T. Rowe Price RETIRE 2055 C",
				107216866,
				""
			],
			[
				"FOUSA04BEY",
				"T. Rowe Price RETIRE 2020 C",
				95990051,
				""
			],
			[
				"F00000SZHY",
				"T. Rowe Price RETIRE 2060 C",
				69478904,
				""
			],
			[
				"FOUSA06BXE",
				"T. Rowe Price RETIRE 2015 C",
				29287554,
				""
			],
			[
				"FOUSA04BH5",
				"T. Rowe Price RETIRE BAL C",
				14521623,
				""
			],
			[
				"FOUSA06BXC",
				"T. Rowe Price RETIRE 2005 C",
				5377539,
				""
			],
			[
				"FOUSA04BEX",
				"T. Rowe Price RETIRE 2010 C",
				4754513,
				""
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A3",
				"T. Rowe Price RETIRE 2050 C",
				137918342,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				98666865,
				145612773,
				0,
				0
			],
			"dff": [
				1256453,
				9940487,
				0,
				0
			],
			"gff": [
				928360,
				1816289,
				0,
				0
			],
			"pff": [
				24583328,
				12928276,
				0,
				0
			],
			"wff": [
				75998344,
				63878899,
				0,
				0
			],
			"tff": [
				6778520,
				3385924,
				0,
				0
			]
		}
	},
	"columbia-university": {
		"path": "columbia_university",
		"employer": "columbia-university",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 07/31/2024",
		"participants": 31807,
		"short_name": "Columbia University",
		"plan_short_name": "The Retirement Plan for Officers of Columbia University",
		"primary_plan_name": "Retirement Plan for Officers of Columbia University",
		"chart_plan_title": "Retirement Plan for Officers\nof Columbia University",
		"primary_plan_logo": "columbia_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "TD Ameritrade",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Retirement Plan for Officers of Columbia University"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Retirement Plan for Officers of Columbia University Form 5500 Filing and Attachment 2023",
				"retirement-plan-for-officers-of-columbia-university-2023.pdf"
			]
		],
		"plan_assets": 4908288194,
		"plan_option_count": 39,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1470314417,
			"equity": 1990972592,
			"bond": 333567278,
			"other": 1113433907,
			"sri": 73264124,
			"cref": 1289869863,
			"vanguard_target": 1470314417
		},
		"other_plan_options": [
			[
				"",
				"TIAA TRADITIONAL NON BENEFIT RESPONSIVE NBR - RA",
				870095609,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				106650843,
				"Registered Investment Company"
			],
			[
				"",
				"TIAA TRADITIONAL NON BENEFIT RESPONSIVE 2 NB2 - RC",
				90222681,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"CREF MONEY MARKET R3 KI",
				40059454,
				"Variable Annuity"
			],
			[
				"",
				"TIAA Real Estate",
				4162532,
				"Pooled Separate Account"
			],
			[
				"",
				"New York Life Guaranteed Interest Account; 10 bps Fee Class",
				1834786,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"TIAA TRADITIONAL BENEFIT RESPONSIVE 2 BR2 - RCP",
				408002,
				"Unallocated Annuity Contracts"
			]
		],
		"bond_plan_options": [
			[
				"STIAA00023",
				"CREF BOND MARKET R3 KK",
				169140417,
				"Variable Annuity"
			],
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund: Inst'l Shr",
				90489049,
				"Registered Investment Company"
			],
			[
				"STIAA00027",
				"CREF INFLATION-LINKED BOND R3 KS",
				61417722,
				"Variable Annuity"
			],
			[
				"F00000ONBZ",
				"VANGUARD SHRT-TERM IP SEC ID I CC",
				5102207,
				"Registered Investment Company"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation-Protected Securities Fund: Inst'l Shares",
				4315043,
				"Registered Investment Company"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Inst'l Shares",
				3102840,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF STOCK R3 KH",
				704821024,
				"Variable Annuity"
			],
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund Plus Shares",
				333712110,
				"Registered Investment Company"
			],
			[
				"FOUSA00GQ7",
				"Vanguard Total Stock Market Index Fund: Inst'l Shr",
				259347150,
				"Registered Investment Company"
			],
			[
				"STIAA00015",
				"CREF GLOBAL EQUITIES R3 KO",
				136690000,
				"Variable Annuity"
			],
			[
				"STIAA00011",
				"CREF GROWTH R3 KQ",
				106590444,
				"Variable Annuity"
			],
			[
				"FOUSA06UOQ",
				"Vanguard Total World Stock Index Fund: Inst'l Shr",
				100685893,
				"Registered Investment Company"
			],
			[
				"FOUSA00GPW",
				"Vanguard Extended Market Index Fund: Inst'l Shares",
				81389561,
				"Registered Investment Company"
			],
			[
				"STIAA00019",
				"CREF SOCIAL CHOICE R3 KJ",
				73264124,
				"Variable Annuity",
				"sri"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund: Inst'l Shr",
				45662487,
				"Registered Investment Company"
			],
			[
				"STIAA00003",
				"CREF EQUITY INDEX R3 KR",
				37946132,
				"Variable Annuity"
			],
			[
				"F00000ZKH4",
				"Calvert US Large-Cap Core Responsible Index Fund; Class R6",
				35381760,
				"Registered Investment Company"
			],
			[
				"FOUSA02SN7",
				"Vanguard Developed Markets Index Fund Institutional Shares",
				28674393,
				"Registered Investment Company"
			],
			[
				"FOUSA04BEQ",
				"Vanguard Real Estate Index Fund - Instl Shares",
				27992715,
				"Registered Investment Company"
			],
			[
				"FOUSA00P1W",
				"Vanguard Emerging Markets Stock Index Fund: Inst'l Shares",
				18814799,
				"Registered Investment Company"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				249682110,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				237295881,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				226599672,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				195613093,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				155211901,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				154122535,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				88150078,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				83792465,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				62411684,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				14536463,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				2640125,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				258410,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				155211901,
				"Registered Investment Company"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF STOCK R3 KH",
				704821024,
				"Variable Annuity"
			],
			[
				"STIAA00023",
				"CREF BOND MARKET R3 KK",
				169140417,
				"Variable Annuity"
			],
			[
				"STIAA00015",
				"CREF GLOBAL EQUITIES R3 KO",
				136690000,
				"Variable Annuity"
			],
			[
				"STIAA00011",
				"CREF GROWTH R3 KQ",
				106590444,
				"Variable Annuity"
			],
			[
				"STIAA00019",
				"CREF SOCIAL CHOICE R3 KJ",
				73264124,
				"Variable Annuity"
			],
			[
				"STIAA00027",
				"CREF INFLATION-LINKED BOND R3 KS",
				61417722,
				"Variable Annuity"
			],
			[
				"STIAA00003",
				"CREF EQUITY INDEX R3 KR",
				37946132,
				"Variable Annuity"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				249682110,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				237295881,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				226599672,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				195613093,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				155211901,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				154122535,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				88150078,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				83792465,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				62411684,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				14536463,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				2640125,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				258410,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				153040508,
				92847394,
				78622137,
				92847394
			],
			"dff": [
				6795160,
				5866351,
				4097637,
				5866351
			],
			"gff": [
				1752591,
				907115,
				765590,
				907115
			],
			"pff": [
				21351002,
				12579778,
				7765626,
				12579778
			],
			"wff": [
				68197602,
				37216949,
				34896959,
				37216949
			],
			"tff": [
				8918927,
				6361965,
				3379313,
				6361965
			]
		}
	},
	"columbia-university-2": {
		"path": "columbia_university_2",
		"employer": "columbia-university",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 07/31/2024",
		"participants": 36768,
		"short_name": "Columbia University",
		"plan_short_name": "The Columbia University Voluntary Retirement Savings Plan",
		"primary_plan_name": "Columbia University Voluntary Retirement Savings Plan",
		"chart_plan_title": "Columbia University Voluntary\nRetirement Savings Plan",
		"primary_plan_logo": "columbia_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "TD Ameritrade",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Columbia University Voluntary Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Columbia University Voluntary Retirement Savings Plan Form 5500 Filing and Attachment 2023",
				"columbia-university-voluntary-retirement-savings-plan-2023.pdf"
			]
		],
		"plan_assets": 4054654452,
		"plan_option_count": 60,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 1455950773,
			"equity": 1703451088,
			"bond": 174223324,
			"other": 721029267,
			"sri": 98819363,
			"cref": 772361019,
			"vanguard_target": 1455950773
		},
		"other_plan_options": [
			[
				"",
				"TIAA TRADITIONAL BENEFIT RESPONSIVE BR1 - GSRA",
				370015205,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"TIAA TRADITIONAL BENEFIT RESPONSIVE 2 BR2 - RCP",
				129218843,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				72895874,
				"Registered Investment Company"
			],
			[
				"",
				"TIAA TRADITIONAL NON BENEFIT RESPONSIVE NBR - RA",
				72644016,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"TIAA Real Estate",
				59390095,
				"Pooled Separate account"
			],
			[
				"",
				"CREF MONEY MARKET R3 KI",
				13855569,
				"Variable Annuity"
			],
			[
				"",
				"PLAN LOAN DEFAULT FUND 98 - GSRA",
				1640710,
				"Unallocated Annuity Contracts"
			],
			[
				"",
				"New York Life Guaranteed Interest Account; 10 bps Fee Class",
				1368955,
				"Unallocated Annuity Contracts"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund: Inst'l Shr",
				98253168,
				"Registered Investment Company"
			],
			[
				"STIAA00023",
				"CREF BOND MARKET R3 KK",
				39553585,
				"Variable Annuity"
			],
			[
				"STIAA00027",
				"CREF INFLATION-LINKED BOND R3 KS",
				22883361,
				"Variable Annuity"
			],
			[
				"F00000ONBZ",
				"VANGUARD SHRT-TERM IP SEC ID I CC",
				5596586,
				"Registered Investment Company"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Admiral Shr",
				4243000,
				"Registered Investment Company"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation-Protected Securities Fund: Inst'l Shares",
				3688330,
				"Registered Investment Company"
			],
			[
				"FOUSA05H99",
				"TIAA ACCESS BOND PLUS T1 2Y",
				5294,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund Plus Shares",
				348379961,
				"Registered Investment Company"
			],
			[
				"STIAA00007",
				"CREF STOCK R3 KH",
				337856312,
				"Variable Annuity"
			],
			[
				"FOUSA00GQ7",
				"Vanguard Total Stock Market Index Fund Institutional Plus Shares",
				303691743,
				"Registered Investment Company"
			],
			[
				"STIAA00015",
				"CREF GLOBAL EQUITIES R3 KO",
				115037706,
				"Variable Annuity"
			],
			[
				"STIAA00011",
				"CREF GROWTH R3 KQ",
				113694536,
				"Variable Annuity"
			],
			[
				"STIAA00003",
				"CREF EQUITY INDEX R3 KR",
				86119321,
				"Variable Annuity"
			],
			[
				"FOUSA00GPW",
				"Vanguard Extended Market Index Fund: Inst'l Shares",
				84762488,
				"Registered Investment Company"
			],
			[
				"FOUSA06UOQ",
				"Vanguard Total World Stock Index Fund: Inst'l Shr",
				83280213,
				"Registered Investment Company"
			],
			[
				"STIAA00019",
				"CREF SOCIAL CHOICE R3 KJ",
				57216198,
				"Variable Annuity",
				"sri"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund: Inst'l Shr",
				47156274,
				"Registered Investment Company"
			],
			[
				"F00000ZKH4",
				"Calvert US Large-Cap Core Responsible Index Fund; Class R6",
				41603165,
				"Registered Investment Company",
				"sri"
			],
			[
				"FOUSA02SN7",
				"Vanguard Developed Markets Index Fund Institutional Shares",
				33442794,
				"Registered Investment Company"
			],
			[
				"FOUSA04BEQ",
				"Vanguard Real Estate Index Fund - Instl Shares",
				28253184,
				"Registered Investment Company"
			],
			[
				"FOUSA00P1W",
				"Vanguard Emerging Markets Stock Index Fund: Inst'l Shares",
				22493745,
				"Registered Investment Company"
			],
			[
				"FOUSA06MDL",
				"TIAA ACCESS LIFECYCLE 2050 T1 32",
				126421,
				"Registered Investment Company"
			],
			[
				"FOUSA02VXK",
				"TIAA ACCESS SM-CAP BL IDX T1 2Q",
				96944,
				"Registered Investment Company"
			],
			[
				"FOUSA06A96",
				"TIAA ACCESS LIFECYCLE 2040 T1 26",
				49206,
				"Registered Investment Company"
			],
			[
				"FOUSA02VUW",
				"TIAA ACCESS LG-CAP VAL T1 2C",
				41760,
				"Registered Investment Company"
			],
			[
				"FOUSA02VXF",
				"TIAA ACCESS MID-CAP GR T1 2E",
				39384,
				"Registered Investment Company"
			],
			[
				"FOUSA06MDI",
				"TIAA ACCESS LIFECYCLE 2045 T1 31",
				24547,
				"Registered Investment Company"
			],
			[
				"FOUSA02VXM",
				"TIAA ACCESS QUANT SML CP EQ T1 2G",
				17692,
				"Registered Investment Company"
			],
			[
				"FOUSA02VXI",
				"TIAA ACCESS MID-CAP VAL T1 2F",
				17573,
				"Registered Investment Company"
			],
			[
				"FOUSA02VH5",
				"TIAA ACCESS INTL EQUITY T1 2A",
				14867,
				"Registered Investment Company"
			],
			[
				"FOUSA05H97",
				"TIAA ACCESS LG-CAP GR T1 2W",
				12000,
				"Registered Investment Company"
			],
			[
				"FOUSA02VXS",
				"TIAA ACCESS REAL EST SECS T1 2S",
				11114,
				"Registered Investment Company"
			],
			[
				"FOUSA06A94",
				"TIAA ACCESS LIFECYCLE 2030 T1 24",
				6305,
				"Registered Investment Company"
			],
			[
				"FOUSA05HAH",
				"TIAA ACCESS GROWTH & INCOME T1 2B",
				4734,
				"Registered Investment Company"
			],
			[
				"FOUSA06A91",
				"TIAA ACCESS LIFECYCLE 2015 T1 21",
				275,
				"Registered Investment Company"
			],
			[
				"FOUSA06A8Z",
				"TIAA ACCESS LIFECYCLE 2010 T1 20",
				228,
				"Registered Investment Company"
			],
			[
				"FOUSA06A95",
				"TIAA ACCESS LIFECYCLE 2035 T1 25",
				111,
				"Registered Investment Company"
			],
			[
				"FOUSA06A93",
				"TIAA ACCESS LIFECYCLE 2025 T1 23",
				101,
				"Registered Investment Company"
			],
			[
				"FOUSA06A92",
				"TIAA ACCESS LIFECYCLE 2020 T1 22",
				96,
				"Registered Investment Company"
			],
			[
				"FOUSA06MDR",
				"TIAA ACCESS LFCYLE RTMT INC T1 33",
				90,
				"Registered Investment Company"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				222469774,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				211849799,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				210782097,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				198797291,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				160714551,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				153742732,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				96787687,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				95033421,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				74045250,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				25360272,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				6022053,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				345846,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				153742732,
				"Registered Investment Company"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF STOCK R3 KH",
				337856312,
				"Variable Annuity"
			],
			[
				"STIAA00015",
				"CREF GLOBAL EQUITIES R3 KO",
				115037706,
				"Variable Annuity"
			],
			[
				"STIAA00011",
				"CREF GROWTH R3 KQ",
				113694536,
				"Variable Annuity"
			],
			[
				"STIAA00003",
				"CREF EQUITY INDEX R3 KR",
				86119321,
				"Variable Annuity"
			],
			[
				"STIAA00019",
				"CREF SOCIAL CHOICE R3 KJ",
				57216198,
				"Variable Annuity"
			],
			[
				"STIAA00023",
				"CREF BOND MARKET R3 KK",
				39553585,
				"Variable Annuity"
			],
			[
				"STIAA00027",
				"CREF INFLATION-LINKED BOND R3 KS",
				22883361,
				"Variable Annuity"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund",
				222469774,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund",
				211849799,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund",
				210782097,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund",
				198797291,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund",
				160714551,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund",
				153742732,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund",
				96787687,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				95033421,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund",
				74045250,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund",
				25360272,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund",
				6022053,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Institutional Target Retirement 2070 Fund",
				345846,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				127383052,
				91159403,
				48218957,
				91159403
			],
			"dff": [
				5287411,
				5760294,
				2467362,
				5760294
			],
			"gff": [
				1578486,
				890524,
				519827,
				890524
			],
			"pff": [
				19604807,
				12349899,
				5052044,
				12349899
			],
			"wff": [
				57849870,
				36539632,
				22339670,
				36539632
			],
			"tff": [
				8026887,
				6246089,
				2126023,
				6246089
			]
		}
	},
	"comcast": {
		"path": "comcast",
		"employer": "comcast",
		"year": 2021,
		"updated": " December 2022",
		"filing_received": " 09/30/2022",
		"participants": 167936,
		"short_name": "Comcast",
		"plan_short_name": "Comcast's 401(k)",
		"primary_plan_name": "Comcast Corporation Employee Savings Plans Master Trust",
		"chart_plan_title": "Comcast Corporation Employee\nSavings Plans Master Trust",
		"primary_plan_logo": "comcast",
		"coreissue": "prison-industrial-complex",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "carbon neutral by 2035",
		"proposal_title": "Proposal 8 - Shareholder Proposal Requesting a Report on Retirement Plan Options",
		"proposal_url": "2021/12/20-comcast-report-on-aligning-retirement-plan-options-with-company-climate-goals",
		"plan_names": [
			"Comcast Corporation Retirement-Investment Plan",
			"NBCUniversal Capital Accumulation Plan",
			"Universal Orlando 401(k) Retirement Plan",
			"Comcast Corporation Employee Savings Plans Master Trust"
		],
		"secondary_plan_logos": [
			[
				"nbcuniversal",
				"NBCUniversal"
			],
			[
				"universal_orlando",
				"Universal Orlando"
			]
		],
		"files": [
			[
				"Comcast Corporation Employee Savings Plans Master Trust Form 5500 Filing and Attachment 2021",
				"comcast-corporation-employee-savings-plans-master-trust-form-5500-filing-and-attachment-2021.pdf"
			],
			[
				"Comcast Retirement-Investment Plan Form 5500 Filing and Attachment 2021",
				"comcast-corporation-retirement-investment-plan-form-5500-filing-and-attachment-2021"
			],
			[
				"NBCUniversal Capital Accumulation Plan Form 5500 Filing and Attachment 2021",
				"nbcuniversal-capital-accumulation-plan-form-5500-filing-and-attachment-2021.pdf"
			],
			[
				"Universal Orlando 401(k) Retirement Plan Form 5500 Filing and Attachment 2021",
				"universal-orlando-401k-retirement-plan-form-5500-filing-and-attachment-2021.pdf"
			]
		],
		"plan_assets": 17595079483,
		"plan_option_count": 21,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 9268186909,
			"equity": 6622970515,
			"bond": 963273701,
			"other": 740648358,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 9160813273
		},
		"other_plan_options": [
			[
				"",
				"COMCAST STABLE VALUE",
				740648358,
				""
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00FQH",
				"BOND INDEX FUND",
				722787364,
				""
			],
			[
				"",
				"BOND FUND",
				240486337,
				""
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"FID 500 INDEX",
				2627720518,
				""
			],
			[
				"FOUSA00BWS",
				"LARGE CAP STOCK FUND",
				1394528421,
				""
			],
			[
				"F00000MJRI",
				"FID GLB EX US IDX",
				932094640,
				""
			],
			[
				"FOUSA00L7W",
				"VANG SM CP IDX IS PL",
				783301757,
				""
			],
			[
				"",
				"SMALL MID CAP STOCK",
				548626425,
				""
			],
			[
				"F00000JTEF",
				"INTERNATIONAL FUND",
				336698754,
				""
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZF",
				"VANGUARD TARGET 2040",
				1542720011,
				""
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET 2035",
				1464184903,
				""
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET 2045",
				1400668934,
				""
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET 2030",
				1259365743,
				""
			],
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				1155649322,
				""
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET 2025",
				858675968,
				""
			],
			[
				"F00000ISUB",
				"VANGUARD TARGET 2055",
				707730361,
				""
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET 2020",
				392358018,
				""
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET 2060",
				253444613,
				""
			],
			[
				"FOUSA04B97",
				"VANGUARD TARGET 2015",
				107373636,
				""
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET INC",
				87573769,
				""
			],
			[
				"F00000YE51",
				"VANGUARD TARGET 2065",
				38441631,
				""
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				1155649322,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZF",
				"VANGUARD TARGET 2040",
				1542720011,
				""
			],
			[
				"FOUSA04B99",
				"VANGUARD TARGET 2035",
				1464184903,
				""
			],
			[
				"FOUSA04B9A",
				"VANGUARD TARGET 2045",
				1400668934,
				""
			],
			[
				"FOUSA05HZE",
				"VANGUARD TARGET 2030",
				1259365743,
				""
			],
			[
				"FOUSA05HZH",
				"VANGUARD TARGET 2050",
				1155649322,
				""
			],
			[
				"FOUSA04B98",
				"VANGUARD TARGET 2025",
				858675968,
				""
			],
			[
				"F00000ISUB",
				"VANGUARD TARGET 2055",
				707730361,
				""
			],
			[
				"FOUSA05HZD",
				"VANGUARD TARGET 2020",
				392358018,
				""
			],
			[
				"F00000N8OD",
				"VANGUARD TARGET 2060",
				253444613,
				""
			],
			[
				"FOUSA04B9B",
				"VANGUARD TARGET INC",
				87573769,
				""
			],
			[
				"F00000YE51",
				"VANGUARD TARGET 2065",
				38441631,
				""
			]
		],
		"screen_results": {
			"fff": [
				617997197,
				612814761,
				0,
				612814761
			],
			"dff": [
				21117968,
				38728090,
				0,
				38728090
			],
			"gff": [
				4144917,
				5985711,
				0,
				5985711
			],
			"pff": [
				76672546,
				83012171,
				0,
				83012171
			],
			"wff": [
				345565094,
				245630296,
				0,
				245630296
			],
			"tff": [
				36786756,
				41987318,
				0,
				41987318
			]
		}
	},
	"deloitte": {
		"path": "deloitte",
		"employer": "deloitte",
		"year": 2023,
		"updated": " April 2025",
		"filing_received": " 04/15/2025",
		"participants": 117341,
		"short_name": "Deloitte",
		"plan_short_name": "Deloitte's 401(k)",
		"primary_plan_name": "Deloitte 401k Plan",
		"chart_plan_title": "Deloitte 401k Plan",
		"primary_plan_logo": "deloitte",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Deloitte 401k Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Deloitte 401k Plan Form 5500 Filing and Attachment 2023",
				"deloitte-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 12986659023,
		"plan_option_count": 40,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 5790413516,
			"equity": 6175786733,
			"bond": 617722557,
			"other": 402736217,
			"sri": 167957411,
			"cref": 0,
			"vanguard_target": 5788656419
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Cash Res Fed MM Adm",
				279018872,
				"Registered Investment Company"
			],
			[
				"",
				"Vanguard Retirement Savings Trust II",
				123717345,
				"Commingled Trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Inst Tot Bd Mkt Ix Tr",
				456576020,
				"Commingled Trust"
			],
			[
				"F00000ONBZ",
				"Vanguard S-T Inf Pro Sec Inst",
				60298524,
				"Registered Investment Company"
			],
			[
				"F00000NBIN",
				"Vanguard Tot Intl Bond Ix Institl",
				47433858,
				"Registered Investment Company"
			],
			[
				"",
				"Prudential Core PlusBd15",
				29303078,
				"Commingled Trust"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund Inst",
				24111077,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Instl 500 Index Trust",
				1521839163,
				"Commingled Trust"
			],
			[
				"FOUSA00L83",
				"Vanguard Instl Tot Stk Mkt Idx Tr",
				910961902,
				"Commingled Trust"
			],
			[
				"F00000JTEF",
				"Vanguard Inst Tot Intl St Mt Ix Tr",
				669162919,
				"Commingled Trust"
			],
			[
				"F00000JXVT",
				"Vanguard Mid-Cap Idx InstlP",
				479644749,
				"Registered Investment Company"
			],
			[
				"FOUSA00JGS",
				"Vanguard Growth Index Fund Ins",
				468806833,
				"Registered Investment Company"
			],
			[
				"FOUSA00EI7",
				"TRP Blue Chip Grow Tr T6",
				363818813,
				"Commingled Trust"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Adm",
				351716205,
				"Registered Investment Company"
			],
			[
				"FOUSA00FUG",
				"Vanguard Div Growth",
				313329606,
				"Registered Investment Company"
			],
			[
				"F00000JXW4",
				"Vanguard Sm-Cap Index InstP",
				219706844,
				"Registered Investment Company"
			],
			[
				"FOUSA06M6P",
				"DFA US Sustain Core 1 Por",
				167957411,
				"Registered Investment Company",
				"sri"
			],
			[
				"F00000QKMB",
				"Vanguard Dev Mkt Index Inst Plus",
				138980489,
				"Commingled Trust"
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Fund Inst",
				137825721,
				"Registered Investment Company"
			],
			[
				"FOUSA02TID",
				"Vanguard Int'l Growth Adm",
				115250971,
				"Registered Investment Company"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Adm",
				96753540,
				"Registered Investment Company"
			],
			[
				"FOUSA00CSM",
				"Vanguard Global Equity Fund",
				96103780,
				"Registered Investment Company"
			],
			[
				"F000014VOK",
				"TRP Emerging MarkEq Tr D",
				37100685,
				"Commingled Trust"
			],
			[
				"",
				"TRP Int SmCap Equity C",
				27963080,
				"Commingled Trust"
			],
			[
				"",
				"TRP International CoreEqC",
				24721428,
				"Commingled Trust"
			],
			[
				"F000005OKQ",
				"Vanguard Explorer Value Fund",
				22971822,
				"Registered Investment Company"
			],
			[
				"FOUSA05BEU",
				"DH Large Cap Portfolio R2",
				11170772,
				"Commingled Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Ret 2045 Tr",
				984717775,
				"Commingled Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050 Tr",
				984616242,
				"Commingled Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Ret 2055 Tr",
				856220434,
				"Commingled Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Ret 2035 Tr",
				710624631,
				"Commingled Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Ret 2040 Tr",
				658259420,
				"Commingled Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Ret 2060 Tr",
				539852444,
				"Commingled Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Ret 2030 Tr",
				377955635,
				"Commingled Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Ret 2025 Tr",
				320868485,
				"Commingled Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Ret 2065 Tr",
				144032639,
				"Commingled Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income Tr",
				122239435,
				"Commingled Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Ret 2020 Tr",
				82706141,
				"Commingled Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Ret 2070 Tr",
				6563138,
				"Commingled Trust"
			],
			[
				"",
				"Vanguard Target Income & Growth Tr",
				1757097,
				"Commingled Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050 Tr",
				984616242,
				"Commingled Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Ret 2045 Tr",
				984717775,
				"Commingled Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050 Tr",
				984616242,
				"Commingled Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Ret 2055 Tr",
				856220434,
				"Commingled Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Ret 2035 Tr",
				710624631,
				"Commingled Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Ret 2040 Tr",
				658259420,
				"Commingled Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Ret 2060 Tr",
				539852444,
				"Commingled Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Ret 2030 Tr",
				377955635,
				"Commingled Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Ret 2025 Tr",
				320868485,
				"Commingled Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Ret 2065 Tr",
				144032639,
				"Commingled Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income Tr",
				122239435,
				"Commingled Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Ret 2020 Tr",
				82706141,
				"Commingled Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Ret 2070 Tr",
				6563138,
				"Commingled Trust"
			]
		],
		"screen_results": {
			"fff": [
				449486363,
				419291737,
				0,
				419291737
			],
			"dff": [
				21882232,
				26528642,
				0,
				26528642
			],
			"gff": [
				12230028,
				4090360,
				0,
				4090360
			],
			"pff": [
				98401008,
				56736973,
				0,
				56736973
			],
			"wff": [
				225158260,
				168025640,
				0,
				168025640
			],
			"tff": [
				25298558,
				28716965,
				0,
				28716965
			]
		}
	},
	"deloitte-psp": {
		"path": "deloitte_psp",
		"employer": "deloitte-psp",
		"year": 2022,
		"updated": " April 2023",
		"filing_received": " 04/15/2023",
		"participants": 7846,
		"short_name": "Deloitte Profit Sharing Plan",
		"plan_short_name": "Deloitte's Profit Sharing Plan",
		"primary_plan_name": "Deloitte Profit Sharing Plan",
		"chart_plan_title": "Deloitte Profit Sharing Plan",
		"primary_plan_logo": "deloitte_psp",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Deloitte Profit Sharing Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Deloitte Profit Sharing Plan Form 5500 Filing and Attachment 2022",
				"deloitte-profit-sharing-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 9311376238,
		"plan_option_count": 39,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 2834854692,
			"equity": 5165144062,
			"bond": 743873819,
			"other": 567503665,
			"sri": 196519410,
			"cref": 0,
			"vanguard_target": 2834854692
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Fed Money Mkt",
				408958540,
				"Registered Investment Company"
			],
			[
				"",
				"Vanguard Retirement Savings Trust II",
				158545125,
				"Commingled Trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Inst Tot Bd Mkt Ix Tr",
				482932272,
				"Commingled Trust"
			],
			[
				"F00000ONBZ",
				"Vanguard S T Inf Pro Sec Inst",
				83711756,
				"Registered Investment Company"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund Inst",
				68157822,
				"Registered Investment Company"
			],
			[
				"",
				"Prudential Core PlusBd15",
				66280424,
				"Commingled Trust"
			],
			[
				"F00000NBIN",
				"Vanguard Tot Intl Bond Ix Institl",
				42791545,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Instl 500 Index Trust",
				904702817,
				"Commingled Trust"
			],
			[
				"FOUSA00L83",
				"Vanguard Instl Tot Stk Mkt Idx Tr",
				557371942,
				"Commingled Trust"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Adm",
				516844269,
				"Registered Investment Company"
			],
			[
				"F00000JTEF",
				"Vanguard Inst Tot Intl St Mt Ix Tr",
				471511017,
				"Commingled Trust"
			],
			[
				"F00000JXVT",
				"Vanguard Mid Cap Idx InstlP",
				376591023,
				"Registered Investment Company"
			],
			[
				"FOUSA00EI7",
				"TRP Blue Chip Grow Tr T6",
				359322108,
				"Commingled Trust"
			],
			[
				"FOUSA00FUG",
				"Vanguard Div Growth",
				333037792,
				"Registered Investment Company"
			],
			[
				"FOUSA02TID",
				"Vanguard Int'l Growth Adm",
				231304949,
				"Registered Investment Company"
			],
			[
				"FOUSA06M6P",
				"DFA US Sustain Core 1 Por",
				196519410,
				"Registered Investment Company",
				"sri"
			],
			[
				"FOUSA00JGS",
				"Vanguard Growth Index Fund Ins",
				176396917,
				"Registered Investment Company"
			],
			[
				"F00000JXW4",
				"Vanguard Sm Cap Index InstP",
				156847503,
				"Registered Investment Company"
			],
			[
				"",
				"TRP International CoreEqA",
				149332609,
				"Commingled Trust"
			],
			[
				"FOUSA00CSM",
				"Vanguard Global Equity Fund",
				141341114,
				"Registered Investment Company"
			],
			[
				"F00000QKMB",
				"Vanguard Dev Mkt Index Inst Plus",
				119279400,
				"Commingled Trust"
			],
			[
				"F000014VOK",
				"TRP Emerging MarkEq Tr D",
				116281020,
				"Commingled Trust"
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Fund Inst",
				113989448,
				"Registered Investment Company"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Adm",
				104108280,
				"Registered Investment Company"
			],
			[
				"",
				"TRP Int SmCap Equity C",
				65542923,
				"Commingled Trust"
			],
			[
				"F000005OKQ",
				"Vanguard Explorer Value Fund",
				49366986,
				"Registered Investment Company"
			],
			[
				"FOUSA05BEU",
				"DH Large Cap Portfolio R2",
				25452535,
				"Commingled Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Ret 2035",
				769066287,
				"Commingled Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Ret 2030",
				512687279,
				"Commingled Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Ret 2040",
				476573972,
				"Commingled Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Ret 2025",
				423132753,
				"Commingled Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Ret 2045",
				343944216,
				"Commingled Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Ret 2020",
				147094215,
				"Commingled Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Ret Income Tr",
				80636965,
				"Commingled Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050",
				62693590,
				"Commingled Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Ret 2055",
				8422851,
				"Commingled Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Ret 2060",
				5108898,
				"Commingled Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Ret 2065",
				3946739,
				"Commingled Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Ret 2070",
				1546927,
				"Commingled Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050",
				62693590,
				"Commingled Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Ret 2035",
				769066287,
				"Commingled Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Ret 2030",
				512687279,
				"Commingled Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Ret 2040",
				476573972,
				"Commingled Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Ret 2025",
				423132753,
				"Commingled Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Ret 2045",
				343944216,
				"Commingled Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Ret 2020",
				147094215,
				"Commingled Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Ret Income Tr",
				80636965,
				"Commingled Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Ret 2050",
				62693590,
				"Commingled Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Ret 2055",
				8422851,
				"Commingled Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Ret 2060",
				5108898,
				"Commingled Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Ret 2065",
				3946739,
				"Commingled Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Ret 2070",
				1546927,
				"Commingled Trust"
			]
		],
		"screen_results": {
			"fff": [
				339154918,
				170443822,
				0,
				170443822
			],
			"dff": [
				19350598,
				10753104,
				0,
				10753104
			],
			"gff": [
				11361911,
				1667892,
				0,
				1667892
			],
			"pff": [
				75733920,
				23124809,
				0,
				23124809
			],
			"wff": [
				178271341,
				68339587,
				0,
				68339587
			],
			"tff": [
				16441903,
				11684682,
				0,
				11684682
			]
		}
	},
	"disney": {
		"path": "disney",
		"employer": "disney",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/08/2024",
		"participants": 201334,
		"short_name": "Disney",
		"plan_short_name": "Disney's 401(k)",
		"primary_plan_name": "Disney Savings Plan Master Trust",
		"chart_plan_title": "Disney Savings Plan\nMaster Trust",
		"primary_plan_logo": "disney",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock BTC LifePath series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Disney Savings Plan Master Trust",
			"Disney 401(k) Plan",
			"Disney Savings and Investment Plan",
			"Disney Hourly Savings and Investment Plan",
			"Disney Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Disney Savings Plan Master Trust Form 5500 Filing 2023",
				"disney-savings-plan-master-trust-form-5500-filing-2023.pdf"
			],
			[
				"Disney Retirement Savings Plan Form 5500 Filing 2023",
				"disney-retirement-savings-plan-form-5500-filing-2023.pdf"
			],
			[
				"Disney Savings and Investment Plan Form 5500 Filing 2023",
				"disney-savings-and-investment-plan-form-5500-filing-2023.pdf"
			],
			[
				"Disney Hourly Savings and Investment Plan Form 5500 Filing 2023",
				"disney-hourly-savings-and-investment-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 13420961627,
		"plan_option_count": 24,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 5442890533,
			"equity": 5781722653,
			"bond": 606999734,
			"other": 1589348707,
			"sri": 31945008,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"DISNEY STOCK-ESOP",
				1118325958,
				""
			],
			[
				"",
				"Vanguard Prime Money Market Fund Admiral Shares",
				469393607,
				""
			],
			[
				"",
				"DISNEY STOCK-NON-ESOP",
				1629142,
				""
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Institutional Total Bond Market Index Trust",
				452241350,
				""
			],
			[
				"FOUSA00DR2",
				"BlackRock BTC Total Return Bond M",
				154758384,
				""
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				3122485242,
				""
			],
			[
				"FOUSA02TYC",
				"Vanguard Mid-Cap Index Fund Institutional Shares",
				792844927,
				""
			],
			[
				"FOUSA00L83",
				"Vanguard Institutional Total Stock Market Index Trust",
				456664456,
				""
			],
			[
				"FOUSA00L7W",
				"Vanguard Small-Cap Index Fund Institutional Plus Shares",
				425933346,
				""
			],
			[
				"F000002PE0",
				"Baron Growth Fund - Unitized",
				344997449,
				""
			],
			[
				"FOUSA00CF9",
				"Fidelity Diversified International Commingled Pool",
				322556986,
				""
			],
			[
				"FEUSA0002W",
				"BlackRock EAFE EQUITY INDEX FUND",
				206242718,
				""
			],
			[
				"FOUSA00DQS",
				"BlackRock Emerging Markets Index Unitized",
				78052521,
				""
			],
			[
				"F000014VXA",
				"Northern Trust Global Sustainability Index Fund",
				31945008,
				"",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPI",
				"BlackRock BTC LIFEPATH 2040 F",
				801238835,
				""
			],
			[
				"F00000MAPJ",
				"BlackRock BTC LIFEPATH 2035 F",
				790964764,
				""
			],
			[
				"F00000MAPH",
				"BlackRock BTC LIFEPATH 2045 F",
				787671247,
				""
			],
			[
				"F00000MAPG",
				"BlackRock BTC LIFEPATH 2050 F",
				775118770,
				""
			],
			[
				"F00000MAPK",
				"BlackRock BTC LIFEPATH 2030 F",
				642664350,
				""
			],
			[
				"F00000MAP0",
				"BlackRock BTC LIFEPATH 2055 F",
				634762531,
				""
			],
			[
				"F00000MAPL",
				"BlackRock BTC LIFEPATH 2025 F",
				416646310,
				""
			],
			[
				"F00000WM8M",
				"BlackRock BTC LIFEPATH 2060 F",
				274307091,
				""
			],
			[
				"F00000MAOX",
				"BlackRock BTC LIFEPATH RET F",
				273543195,
				""
			],
			[
				"F000013OYO",
				"BlackRock BTC LIFEPATH 2065 F",
				45973440,
				""
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock BTC LIFEPATH 2050 F",
				775118770,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				503249032,
				366813860,
				0,
				0
			],
			"dff": [
				21428264,
				19826307,
				0,
				0
			],
			"gff": [
				5229532,
				3262856,
				0,
				0
			],
			"pff": [
				102056160,
				48267671,
				0,
				0
			],
			"wff": [
				248580097,
				144341804,
				0,
				0
			],
			"tff": [
				29218047,
				23667107,
				0,
				0
			]
		}
	},
	"dollar-general": {
		"path": "dollar_general",
		"employer": "dollar-general",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/27/2024",
		"participants": 206816,
		"short_name": "Dollar General",
		"plan_short_name": "Dollar General's 401(k)",
		"primary_plan_name": "Dollar General Corp 401(k) Savings and Retirement Plan",
		"chart_plan_title": "Dollar General Corp 401(k)\nSavings and Retirement Plan",
		"primary_plan_logo": "dollar_general",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Dollar General Corp 401(k) Savings and Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Dollar General Corp 401(k) Savings and Retirement Plan Form 5500 Filing and Attachment 2023",
				"dollar-general-corp-401k-savings-and-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 695697264,
		"plan_option_count": 27,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 192949799,
			"equity": 388111343,
			"bond": 58567501,
			"other": 56068621,
			"sri": 47103914,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Galliard Stable Return Fund",
				56068621,
				"Collective trust funds"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Total Bond Fund",
				42914893,
				"Mutual funds"
			],
			[
				"FOUSA00H9T",
				"MetWest Total Return Bnd Fund",
				15652608,
				"Mutual funds"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index Fund",
				104940178,
				"Mutual funds"
			],
			[
				"F00000JTBU",
				"Vanguard Total Int. Stock Idx Fund",
				54642071,
				"Mutual funds"
			],
			[
				"FOUSA00C3I",
				"Dodge & Cox Balanced Fund",
				52086335,
				"Mutual funds"
			],
			[
				"FOUSA08PQ5",
				"Nuveen Winslow Large Cap Growth",
				47103914,
				"Mutual funds",
				"sri"
			],
			[
				"F000002PIZ",
				"The American Funds Group Washington Mutual Investors Fund",
				36598417,
				"Mutual funds"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Mkts Idx Fund",
				34242322,
				"Mutual funds"
			],
			[
				"FOUSA00CFE",
				"Fidelity Low Priced Stock Fund",
				22326052,
				"Mutual funds"
			],
			[
				"F000002P1T",
				"The American Funds Group EuroPacific Growth Fund",
				14338296,
				"Mutual funds"
			],
			[
				"F00000UHR4",
				"Principal Small Cap Growth I R6 Fund",
				10797047,
				"Mutual funds"
			],
			[
				"F00000MMWN",
				"Carillon Eagle Mid Cap Growth Fund",
				7682336,
				"Mutual funds"
			],
			[
				"F00000PW1K",
				"Franklin Small Cap Value Fund",
				3354375,
				"Mutual funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045 Trust",
				28163642,
				"Collective trust funds"
			],
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035 Trust",
				28014405,
				"Collective trust funds"
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030 Trust",
				25897199,
				"Collective trust funds"
			],
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040 Trust",
				24549114,
				"Collective trust funds"
			],
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust",
				24316868,
				"Collective trust funds"
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055 Trust",
				20287572,
				"Collective trust funds"
			],
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025 Trust",
				14717383,
				"Collective trust funds"
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060 Trust",
				10163494,
				"Collective trust funds"
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020 Trust",
				5961256,
				"Collective trust funds"
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005 Trust",
				5159364,
				"Collective trust funds"
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065 Trust",
				2220520,
				"Collective trust funds"
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010 Trust",
				1840666,
				"Collective trust funds"
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015 Trust",
				1658316,
				"Collective trust funds"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust",
				24316868,
				"Collective trust funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				27803091,
				17007454,
				0,
				0
			],
			"dff": [
				1444440,
				1167928,
				0,
				0
			],
			"gff": [
				549206,
				208383,
				0,
				0
			],
			"pff": [
				6548754,
				1499226,
				0,
				0
			],
			"wff": [
				16085822,
				7471154,
				0,
				0
			],
			"tff": [
				3893670,
				388571,
				0,
				0
			]
		}
	},
	"dollar-tree": {
		"path": "dollar_tree",
		"employer": "dollar-tree",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/18/2024",
		"participants": 96302,
		"short_name": "Dollar Tree",
		"plan_short_name": "Dollar Tree's 401(k)",
		"primary_plan_name": "Dollar Tree Retirement Savings Plan",
		"chart_plan_title": "Dollar Tree Retirement\nSavings Plan",
		"primary_plan_logo": "dollar_tree",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Dollar Tree Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Dollar Tree Retirement Savings Plan Form 5500 Filing and Attachment 2023",
				"dollar-tree-retirement-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 870040352,
		"plan_option_count": 22,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 540096862,
			"equity": 224193430,
			"bond": 26821826,
			"other": 78928234,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 540096862
		},
		"other_plan_options": [
			[
				"",
				"Putnam Stable Value Fund",
				78928234,
				"Collective Trust Fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000MN7G",
				"MetWest Core Plus Bond",
				22106554,
				"Pooled Separate Account"
			],
			[
				"FOUSA02TYI",
				"Vanguard Total Bond Market Index Fund Admiral Shares",
				4715272,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				52737675,
				"Mutual Fund"
			],
			[
				"F00000PRFP",
				"Winslow Capital U.S. Large Cap Growth Fund",
				43535664,
				"Pooled Separate Account"
			],
			[
				"FOUSA05HQN",
				"MFS Value Fund Class R6",
				43019049,
				"Mutual Fund"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Fund Admiral Shares",
				37169846,
				"Mutual Fund"
			],
			[
				"F00000VE8C",
				"Victory Integrity Small/Mid-Cap Value CF C",
				19765131,
				"Collective Trust Fund"
			],
			[
				"F000002P1T",
				"Capital Group EuroPacific Growth Fund",
				18107664,
				"Pooled Separate Account"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Fund Admiral Shares",
				5563028,
				"Mutual Fund"
			],
			[
				"F00000JTEF",
				"Vanguard Total International Stock Index Fund Admiral Shares",
				4295373,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I",
				93070463,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I",
				90894048,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I",
				77432034,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I",
				74714651,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I",
				69196441,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				51619429,
				"Collective Trust Fund"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I",
				36124707,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I",
				21130019,
				"Collective Trust Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I",
				14311477,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I",
				8867621,
				"Collective Trust Fund"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I",
				2735972,
				"Collective Trust Fund"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				51619429,
				"Collective Trust Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I",
				93070463,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I",
				90894048,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I",
				77432034,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I",
				74714651,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I",
				69196441,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I",
				51619429,
				"Collective Trust Fund"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I",
				36124707,
				"Collective Trust Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I",
				21130019,
				"Collective Trust Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I",
				14311477,
				"Collective Trust Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I",
				8867621,
				"Collective Trust Fund"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I",
				2735972,
				"Collective Trust Fund"
			]
		],
		"screen_results": {
			"fff": [
				18019606,
				34980452,
				0,
				34980452
			],
			"dff": [
				253629,
				2209875,
				0,
				2209875
			],
			"gff": [
				589612,
				341804,
				0,
				341804
			],
			"pff": [
				5378034,
				4740020,
				0,
				4740020
			],
			"wff": [
				12600279,
				14021900,
				0,
				14021900
			],
			"tff": [
				661851,
				2396986,
				0,
				2396986
			]
		}
	},
	"duke-university": {
		"path": "duke_university",
		"employer": "duke-university",
		"year": 2021,
		"updated": " October 2022",
		"filing_received": " 10/13/2022",
		"participants": 62676,
		"short_name": "Duke University",
		"plan_short_name": "Duke University's 403(b)",
		"primary_plan_name": "The Duke University Faculty and Staff Retirement Plan",
		"chart_plan_title": "The Duke University Faculty\nand Staff Retirement Plan",
		"primary_plan_logo": "duke_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"The Duke University Faculty and Staff Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"The Duke University Faculty and Staff Retirement Plan Form 5500 Filing 2021",
				"the-duke-university-faculty-and-staff-retirement-plan-form-5500-filing-2021.pdf"
			]
		],
		"plan_assets": 8414524601,
		"plan_option_count": 40,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 3049080884,
			"equity": 2843212255,
			"bond": 382148097,
			"other": 2140083365,
			"sri": 62000486,
			"cref": 0,
			"vanguard_target": 2975188140
		},
		"other_plan_options": [
			[
				"",
				"Annuity contracts",
				1822001478,
				""
			],
			[
				"",
				"Vanguard Vmmr – Fed MMKT",
				186163345,
				"Mutual fund"
			],
			[
				"",
				"VALIC Fixed Interest",
				131918542,
				"Mutual fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000MN7G",
				"Metwest Tot Rtn BD P",
				142347103,
				"Mutual fund"
			],
			[
				"F000004494",
				"Vanguard Total Bond Mk IS Pl",
				124390603,
				"Mutual fund"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Inst",
				115410391,
				"Mutual fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Inst Index Plus",
				732551318,
				"Mutual fund"
			],
			[
				"F00000YI8R",
				"Fidelity Contrafund K6",
				687291328,
				"Mutual fund"
			],
			[
				"F00000JXVS",
				"Vanguard Extended Market Index ISP",
				230891495,
				"Mutual fund"
			],
			[
				"FOUSA05HQN",
				"MFS Value R6",
				157270894,
				"Mutual fund"
			],
			[
				"FOUSA02TID",
				"Vanguard Intl Growth Adm",
				130944715,
				"Mutual fund"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Adm",
				109460274,
				"Mutual fund"
			],
			[
				"F000002P1T",
				"AF Europac Growth R6",
				83958709,
				"Mutual fund"
			],
			[
				"F00000JS7I",
				"MM Sel Mid Cap Gr I",
				83345914,
				"Mutual fund"
			],
			[
				"F00000VWMT",
				"TRP Growth Stock I",
				83102504,
				"Mutual fund"
			],
			[
				"F00000OB8D",
				"J H Triton N",
				83009475,
				"Mutual fund"
			],
			[
				"F00000JTBU",
				"Vanguard Total Intl Stk IS",
				76005008,
				"Mutual fund"
			],
			[
				"FOUSA02SNF",
				"Vanguard FTSE Social Index IS",
				62000486,
				"Mutual fund",
				"sri"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value R6",
				47709595,
				"Mutual fund"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity Income Adm",
				47192579,
				"Mutual fund"
			],
			[
				"FOUSA04BEQ",
				"Vanguard Real Est Idx IS",
				43873485,
				"Mutual fund"
			],
			[
				"FOUSA00P1W",
				"Vanguard Emerging Markets Stock Index IS",
				39754233,
				"Mutual fund"
			],
			[
				"F00000Q7J5",
				"AM Cent MD Cp Val R6",
				35120571,
				"Mutual fund"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth K6",
				33328510,
				"Mutual fund"
			],
			[
				"F00000VYY8",
				"GS SM Cap Value R6",
				27961319,
				"Mutual fund"
			],
			[
				"FOUSA05B4X",
				"Fidelity Small Cap Value",
				26556140,
				"Mutual fund"
			],
			[
				"FOUSA02VJ6",
				"Fidelity Intl Small Cap",
				16128252,
				"Mutual fund"
			],
			[
				"F00000YK7Z",
				"Fidelity Low Priced St K6",
				5755451,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Inst TR 2030",
				509176819,
				"Mutual fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Inst TR 2035",
				483924196,
				"Mutual fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Inst TR 2025",
				458960100,
				"Mutual fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Inst TR 2040",
				424569231,
				"Mutual fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Inst TR 2045",
				361496358,
				"Mutual fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Inst TR 2020",
				278119597,
				"Mutual fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Inst TR 2050",
				244282463,
				"Mutual fund"
			],
			[
				"F00000ISUB",
				"Vanguard Inst TR 2055",
				114139770,
				"Mutual fund"
			],
			[
				"FOUSA04B97",
				"Vanguard Inst TR 2015",
				73892744,
				"Mutual fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Inst TR Income",
				57407154,
				"Mutual fund"
			],
			[
				"F00000N8OD",
				"Vanguard Inst TR 2060",
				33338072,
				"Mutual fund"
			],
			[
				"F00000YE51",
				"Vanguard Inst TR 2065",
				9774380,
				"Mutual fund"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Inst TR 2050",
				244282463,
				"Mutual fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Inst TR 2030",
				509176819,
				"Mutual fund"
			],
			[
				"FOUSA04B99",
				"Vanguard Inst TR 2035",
				483924196,
				"Mutual fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Inst TR 2025",
				458960100,
				"Mutual fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Inst TR 2040",
				424569231,
				"Mutual fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Inst TR 2045",
				361496358,
				"Mutual fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Inst TR 2020",
				278119597,
				"Mutual fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Inst TR 2050",
				244282463,
				"Mutual fund"
			],
			[
				"F00000ISUB",
				"Vanguard Inst TR 2055",
				114139770,
				"Mutual fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Inst TR Income",
				57407154,
				"Mutual fund"
			],
			[
				"F00000N8OD",
				"Vanguard Inst TR 2060",
				33338072,
				"Mutual fund"
			],
			[
				"F00000YE51",
				"Vanguard Inst TR 2065",
				9774380,
				"Mutual fund"
			]
		],
		"screen_results": {
			"fff": [
				256828228,
				182189682,
				0,
				182189682
			],
			"dff": [
				5403630,
				11510955,
				0,
				11510955
			],
			"gff": [
				3583201,
				1780032,
				0,
				1780032
			],
			"pff": [
				43895616,
				24685216,
				0,
				24685216
			],
			"wff": [
				124339196,
				73029247,
				0,
				73029247
			],
			"tff": [
				8541702,
				12483862,
				0,
				12483862
			]
		}
	},
	"etsy": {
		"path": "etsy",
		"employer": "etsy",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/11/2024",
		"participants": 2346,
		"short_name": "Etsy",
		"plan_short_name": "Etsy's 401(k)",
		"primary_plan_name": "Etsy, Inc. 401(k) Plan",
		"chart_plan_title": "Etsy, Inc. 401(k) Plan",
		"primary_plan_logo": "etsy",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Etsy, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Etsy, Inc. 401(k) Plan Form 5500 Filing and Attachment 2023",
				"etsy-inc-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 210614353,
		"plan_option_count": 27,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 157594017,
			"equity": 48236130,
			"bond": 2845214,
			"other": 1938992,
			"sri": 3108325,
			"cref": 0,
			"vanguard_target": 157594017
		},
		"other_plan_options": [
			[
				"",
				"Great Gray MetLife Group Annuity Contract (Class J)",
				1938992,
				"Collective trust fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity US Bond Index Fund",
				1556540,
				"Mutual funds"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund (Institutional Class)",
				945410,
				"Mutual funds"
			],
			[
				"F00000JWHG",
				"PGIM Total Return Bond Fund (Class R6)",
				343264,
				"Mutual funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				25686619,
				"Mutual funds"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				4134393,
				"Mutual funds"
			],
			[
				"F00000WMWX",
				"T. Rowe Price Blue Chip Growth Fund (Class I)",
				3549631,
				"Mutual funds"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund (Admiral Shares)",
				3108325,
				"Mutual funds",
				"sri"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index Fund",
				2941700,
				"Mutual funds"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index Fund",
				2780237,
				"Mutual funds"
			],
			[
				"FOUSA0583Z",
				"DFA Global Equity Portfolio (Institutional Class)",
				1642327,
				"Mutual funds"
			],
			[
				"F00000X539",
				"Delaware Emerging Markets Fund (Class R6)",
				1200464,
				"Mutual funds"
			],
			[
				"F00000WLFU",
				"BlackRock Mid-Cap Growth Equity Portfolio (Class K)",
				1132597,
				"Mutual funds"
			],
			[
				"F00000UH3C",
				"Columbia Select Large Cap Value (Institutional 3 Class)",
				1060696,
				"Mutual funds"
			],
			[
				"F00000TXPJ",
				"Cohen & Steers Real Estate Securities Fund (Class Z)",
				589596,
				"Mutual funds"
			],
			[
				"F00000Z6HF",
				"Carillon Scout Mid Cap Fund (Class R6)",
				409545,
				"Mutual funds"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Institutional Fund",
				46338668,
				"Mutual funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Institutional Fund",
				42537132,
				"Mutual funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Institutional Fund",
				25634921,
				"Mutual funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Institutional Fund",
				17265027,
				"Mutual funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Institutional Fund",
				11978761,
				"Mutual funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Institutional Fund",
				5974691,
				"Mutual funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Institutional Fund",
				3327929,
				"Mutual funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Institutional Fund",
				2181451,
				"Mutual funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Institutional Fund",
				1941398,
				"Mutual funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Institutional Fund",
				213596,
				"Mutual funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Institutional Fund",
				200443,
				"Mutual funds"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Institutional Fund",
				42537132,
				"Mutual funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Institutional Fund",
				46338668,
				"Mutual funds"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Institutional Fund",
				42537132,
				"Mutual funds"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Institutional Fund",
				25634921,
				"Mutual funds"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Institutional Fund",
				17265027,
				"Mutual funds"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Institutional Fund",
				11978761,
				"Mutual funds"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Institutional Fund",
				5974691,
				"Mutual funds"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Institutional Fund",
				3327929,
				"Mutual funds"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Institutional Fund",
				2181451,
				"Mutual funds"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Institutional Fund",
				1941398,
				"Mutual funds"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Institutional Fund",
				213596,
				"Mutual funds"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Institutional Fund",
				200443,
				"Mutual funds"
			]
		],
		"screen_results": {
			"fff": [
				3868085,
				12492438,
				0,
				12492438
			],
			"dff": [
				185524,
				791362,
				0,
				791362
			],
			"gff": [
				40418,
				121708,
				0,
				121708
			],
			"pff": [
				861175,
				1688526,
				0,
				1688526
			],
			"wff": [
				1609939,
				5005042,
				0,
				5005042
			],
			"tff": [
				275252,
				855250,
				0,
				855250
			]
		}
	},
	"fannie-mae": {
		"path": "fannie_mae",
		"employer": "fannie-mae",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/05/2023",
		"participants": 11514,
		"short_name": "Fannie Mae",
		"plan_short_name": "Fannie Mae's 401(k)",
		"primary_plan_name": "Federal National Mortgage Association Retirement Savings Plan for Employees",
		"chart_plan_title": "Federal National Mortgage\nAssociation Retirement\nSavings Plan for Employees",
		"primary_plan_logo": "fannie_mae",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Federal National Mortgage Association Retirement Savings Plan for Employees"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Federal National Mortgage Association Retirement Savings Plan for Employees Form 5500 Filing and Attachment 2022",
				"federal-national-mortgage-association-retirement-savings-plan-for-employees-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 3185112631,
		"plan_option_count": 32,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 497533539,
			"equity": 2094656002,
			"bond": 363046164,
			"other": 229876926,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 497533539
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust III",
				126673207,
				"Common Collective Trust"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				103203719,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Total Bond Market Index Fund Institutional Plus Shares",
				271088140,
				"Common Collective Trust"
			],
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund",
				43843462,
				"Mutual Fund"
			],
			[
				"FOUSA00EH8",
				"PIMCO High Yield Fund Institutional Class",
				23830127,
				"Mutual Fund"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation-Protected Securities Fund Institutional Shares",
				20184294,
				"Mutual Fund"
			],
			[
				"F00000NBIL",
				"Vanguard Total International Bond Index",
				4100141,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				777718639,
				"Common Collective Trust"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Market Index Trust",
				320848341,
				"Common Collective Trust"
			],
			[
				"F00000YI8R",
				"Fidelity ® Contrafund ® Pool",
				195298160,
				"Common Collective Trust"
			],
			[
				"F00000JXVT",
				"Vanguard Mid-Cap Index Fund Institutional Plus Shares",
				194932192,
				"Mutual Fund"
			],
			[
				"F00000JXW4",
				"Vanguard Small-Cap Index Fund Institutional Plus Shares",
				142236490,
				"Mutual Fund"
			],
			[
				"FOUSA06TY5",
				"Fidelity ® OTC Commingled Pool",
				130426528,
				"Common Collective Trust"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				98563097,
				"Mutual Fund"
			],
			[
				"FOUSA02TID",
				"Vanguard International Growth Fund Admiral Shares",
				57914786,
				"Mutual Fund"
			],
			[
				"F00000NDAR",
				"Invesco Global Fund Class R6",
				52346750,
				"Mutual Fund"
			],
			[
				"F00000MTCG",
				"John Hancock Funds Disciplined Value Mid Cap Fund Class R6",
				32475577,
				"Mutual Fund"
			],
			[
				"FOUSA06TXR",
				"Fidelity ® Low-Priced Stock Fund - Class K",
				31828300,
				"Mutual Fund"
			],
			[
				"F00000WLTC",
				"Wasatch Small Cap Growth Fund",
				29384898,
				"Mutual Fund"
			],
			[
				"FOUSA05B54",
				"Fidelity ® Small Cap Value Fund",
				16631013,
				"Mutual Fund"
			],
			[
				"FOUSA00HOD",
				"Vanguard Mid-Cap Growth Fund Investor Shares",
				14051231,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				90578494,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				77024291,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				70618312,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				60152241,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				57138715,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				38038352,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055",
				37512816,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060",
				25171916,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				19519479,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income I",
				15074405,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065",
				6704518,
				"Common Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				57138715,
				"Common Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				90578494,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				77024291,
				"Common Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				70618312,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				60152241,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				57138715,
				"Common Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				38038352,
				"Common Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055",
				37512816,
				"Common Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060",
				25171916,
				"Common Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				19519479,
				"Common Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income I",
				15074405,
				"Common Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065",
				6704518,
				"Common Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				185371474,
				33511848,
				0,
				33511848
			],
			"dff": [
				7845344,
				2118403,
				0,
				2118403
			],
			"gff": [
				1240465,
				327237,
				0,
				327237
			],
			"pff": [
				32640782,
				4538439,
				0,
				4538439
			],
			"wff": [
				81117913,
				13431669,
				0,
				13431669
			],
			"tff": [
				8059400,
				2295882,
				0,
				2295882
			]
		}
	},
	"fedex": {
		"path": "fedex",
		"employer": "fedex",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 192425,
		"short_name": "FedEx",
		"plan_short_name": "The FedEx Retirement Savings Plan",
		"primary_plan_name": "FedEx Corporation Retirement Savings Plan",
		"chart_plan_title": "FedEx Corporation Retirement\nSavings Plan",
		"primary_plan_logo": "fedex",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"FedEx Corporation Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"FedEx Corporation Retirement Savings Plan Form 5500 Filing 2023",
				"fedex-corporation-retirement-savings-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 23431649413,
		"plan_option_count": 27,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 6686515631,
			"equity": 12823133498,
			"bond": 1982288461,
			"other": 1939711823,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 6686515631
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
				1030257276,
				"Registered investment companies"
			],
			[
				"",
				"Vanguard Retirement Savings Trust II",
				699507566,
				"Common/Collective Trust"
			],
			[
				"",
				"FedEx Company Stock Fund",
				209946981,
				"Master Trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard U.S. Bond Index Fund",
				1349791883,
				"Common/Collective Trust"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Instit Shr",
				337332178,
				"Registered investment companies"
			],
			[
				"F00000ONBZ",
				"Vanguard Short-Term Inflation-Protected Sec. Idx Fund: Inst'l Shr",
				196386637,
				"Registered investment companies"
			],
			[
				"",
				"FedEx Diversified Bond Fund",
				79944799,
				"Master Trust"
			],
			[
				"FOUSA06P2Z",
				"BlackRock Multi-Asset Income Portfolio; Institutional Shares",
				18832964,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Fund Admiral Shares",
				4009139820,
				"Registered investment companies"
			],
			[
				"FOUSA04BN7",
				"Vanguard U.S. Large Cap Equity Index Fund",
				3107689357,
				"Common/Collective Trust"
			],
			[
				"F00000JTEF",
				"Vanguard International Equity Index Fund",
				1493637261,
				"Common/Collective Trust"
			],
			[
				"FOUSA00LB6",
				"Vanguard U.S. Small/Mid Cap Equity Index Fund",
				1352625305,
				"Common/Collective Trust"
			],
			[
				"FOUSA02T18",
				"Vanguard Wellington Fund Admiral Shares",
				1291591886,
				"Registered investment companies"
			],
			[
				"FOUSA02TYJ",
				"Vanguard Windsor Fund Admiral Shares",
				1175333825,
				"Registered investment companies"
			],
			[
				"",
				"FedEx International Active Equity Fund",
				393116044,
				"Master Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				1148467548,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				1095910267,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				883031639,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				873066163,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				757678170,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				661933062,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				454798507,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				368416683,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				224891429,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				181089661,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				35383734,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				1848768,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				661933062,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				1148467548,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				1095910267,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				883031639,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				873066163,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				757678170,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				661933062,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				454798507,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				368416683,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				224891429,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				181089661,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				35383734,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				1848768,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				899045466,
				426124201,
				0,
				426124201
			],
			"dff": [
				58748875,
				26921151,
				0,
				26921151
			],
			"gff": [
				5818761,
				4163637,
				0,
				4163637
			],
			"pff": [
				155436489,
				57740046,
				0,
				57740046
			],
			"wff": [
				409350716,
				170810615,
				0,
				170810615
			],
			"tff": [
				49085327,
				29199229,
				0,
				29199229
			]
		}
	},
	"fedex-2": {
		"path": "fedex_2",
		"employer": "fedex",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 126473,
		"short_name": "FedEx",
		"plan_short_name": "The FedEx Retirement Savings Plan II",
		"primary_plan_name": "FedEx Corporation Retirement Savings Plan II",
		"chart_plan_title": "FedEx Corporation Retirement\nSavings Plan II",
		"primary_plan_logo": "fedex",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"FedEx Corporation Retirement Savings Plan II"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"FedEx Corporation Retirement Savings Plan II Form 5500 Filing 2023",
				"fedex-corporation-retirement-savings-plan-ii-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 2491405154,
		"plan_option_count": 27,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1601005832,
			"equity": 753572679,
			"bond": 87028736,
			"other": 49797907,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1601005832
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
				27799119,
				"Registered investment companies"
			],
			[
				"",
				"Vanguard Retirement Savings Trust II",
				20284264,
				"Common/Collective Trust"
			],
			[
				"",
				"FedEx Company Stock Fund",
				1714524,
				"Master Trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard U.S. Bond Index Fund",
				58832481,
				"Common/Collective Trust"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Instit Shr",
				18351473,
				"Registered investment companies"
			],
			[
				"F00000ONBZ",
				"Vanguard Short-Term Inflation-Protected Sec. Idx Fund: Inst'l Shr",
				6267993,
				"Registered investment companies"
			],
			[
				"",
				"FedEx Diversified Bond Fund",
				2491271,
				"Master Trust"
			],
			[
				"FOUSA06P2Z",
				"BlackRock Multi-Asset Income Portfolio; Institutional Shares",
				1085518,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA04BN7",
				"Vanguard U.S. Large Cap Equity Index Fund",
				248292452,
				"Common/Collective Trust"
			],
			[
				"F00000JTEF",
				"Vanguard International Equity Index Fund",
				139912041,
				"Common/Collective Trust"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Fund Admiral Shares",
				138467637,
				"Registered investment companies"
			],
			[
				"FOUSA00LB6",
				"Vanguard U.S. Small/Mid Cap Equity Index Fund",
				116445025,
				"Common/Collective Trust"
			],
			[
				"FOUSA02TYJ",
				"Vanguard Windsor Fund Admiral Shares",
				44115676,
				"Registered investment companies"
			],
			[
				"FOUSA02T18",
				"Vanguard Wellington Fund Admiral Shares",
				42156085,
				"Registered investment companies"
			],
			[
				"",
				"FedEx International Active Equity Fund",
				24183763,
				"Master Trust"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				259359361,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				248066818,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				241078077,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				185191972,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				165438598,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				146543912,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				144751287,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				117706661,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				67963183,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				18375790,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				5982923,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				547250,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				241078077,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				259359361,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				248066818,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				241078077,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				185191972,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				165438598,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				146543912,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				144751287,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				117706661,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				67963183,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				18375790,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				5982923,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				547250,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				56528361,
				120026251,
				0,
				120026251
			],
			"dff": [
				3381475,
				7594409,
				0,
				7594409
			],
			"gff": [
				474568,
				1170849,
				0,
				1170849
			],
			"pff": [
				9108651,
				16240841,
				0,
				16240841
			],
			"wff": [
				25949865,
				48098546,
				0,
				48098546
			],
			"tff": [
				3277093,
				8220385,
				0,
				8220385
			]
		}
	},
	"fedex-3": {
		"path": "fedex_3",
		"employer": "fedex",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 21210,
		"short_name": "FedEx",
		"plan_short_name": "The FedEx Office and Print Services 401(k)",
		"primary_plan_name": "FedEx Office and Print Services, Inc. 401(k) Retirement Savings Plan",
		"chart_plan_title": "FedEx Office and Print Services, Inc.\n401(k) Retirement Savings Plan",
		"primary_plan_logo": "fedex",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"FedEx Office and Print Services, Inc. 401(k) Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"FedEx Office and Print Services, Inc. 401(k) Retirement Savings Plan Form 5500 Filing 2023",
				"fedex-office-and-print-services-inc-401k-retirement-savings-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 1244056482,
		"plan_option_count": 27,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 424611833,
			"equity": 655211450,
			"bond": 88163787,
			"other": 76069412,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 424611833
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
				44714092,
				"Registered Investment Company"
			],
			[
				"",
				"Vanguard Retirement Savings Trust II",
				29640796,
				"Common/Collective Trust"
			],
			[
				"",
				"FedEx Company Stock Fund",
				1714524,
				"Master Trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard U.S. Bond Index Fund",
				56704931,
				"Common/Collective Trust"
			],
			[
				"F00000ONBZ",
				"Vanguard Short-Term Inflation-Protected Sec. Idx Fund: Inst'l Shr",
				12532643,
				"Registered Investment Company"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Instit Shr",
				12159137,
				"Registered Investment Company"
			],
			[
				"",
				"FedEx Diversified Bond Fund",
				5697280,
				"Master Trust"
			],
			[
				"FOUSA06P2Z",
				"BlackRock Multi-Asset Income Portfolio; Institutional Shares",
				1069796,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA04BN7",
				"Vanguard U.S. Large Cap Equity Index Fund",
				235567640,
				"Common/Collective Trust"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Fund Admiral Shares",
				94699376,
				"Registered Investment Company"
			],
			[
				"FOUSA02T18",
				"Vanguard Wellington Fund Admiral Shares",
				85165303,
				"Registered Investment Company"
			],
			[
				"F00000JTEF",
				"Vanguard Institutional Total International Stock Market Index Trust",
				73451431,
				"Common/Collective Trust"
			],
			[
				"FOUSA02TYJ",
				"Vanguard Windsor Fund Admiral Shares",
				68852915,
				"Registered Investment Company"
			],
			[
				"FOUSA00LB6",
				"Vanguard U.S. Small/Mid Cap Equity Index Fund",
				63286727,
				"Common/Collective Trust"
			],
			[
				"",
				"FedEx International Active Equity Fund",
				34188058,
				"Master Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				78641455,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				69548984,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				59566912,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				57740200,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				48525895,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				38262616,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				21951018,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				18604878,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				15799990,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				9240839,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				6335367,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				393679,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				38262616,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust",
				78641455,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust",
				69548984,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust",
				59566912,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust",
				57740200,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust",
				48525895,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust",
				38262616,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust",
				21951018,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust",
				18604878,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				15799990,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust",
				9240839,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust",
				6335367,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust",
				393679,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				48468701,
				27101730,
				0,
				27101730
			],
			"dff": [
				3044574,
				1711797,
				0,
				1711797
			],
			"gff": [
				407341,
				264876,
				0,
				264876
			],
			"pff": [
				7853514,
				3673092,
				0,
				3673092
			],
			"wff": [
				20914446,
				10864122,
				0,
				10864122
			],
			"tff": [
				3296729,
				1857231,
				0,
				1857231
			]
		}
	},
	"fiserv": {
		"path": "fiserv",
		"employer": "fiserv",
		"year": 2022,
		"updated": " July 2023",
		"filing_received": " 07/25/2023",
		"participants": 39389,
		"short_name": "Fiserv",
		"plan_short_name": "Fiserv's 401(k)",
		"primary_plan_name": "Fiserv 401(k) Savings Plan",
		"chart_plan_title": "Fiserv 401(k) Savings Plan",
		"primary_plan_logo": "fiserv",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Fiserv 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Fiserv 401(k) Savings Plan Form 5500 Filing and Attachment 2022",
				"fiserv-401k-savings-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 4144096000,
		"plan_option_count": 22,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 2582155000,
			"equity": 914561000,
			"bond": 238331000,
			"other": 409049000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 2582155000
		},
		"other_plan_options": [
			[
				"",
				"Stable Value Fund",
				292343000,
				"Separately Managed Account"
			],
			[
				"",
				"Fiserv, Inc. common stock",
				113729000,
				"Company Stock Fund"
			],
			[
				"",
				"BlackRock Liquidity Money Market",
				2413000,
				"Money Market"
			],
			[
				"",
				"The Vanguard Group Money Market",
				564000,
				"Money Market"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Institutional Total Bond Market Index Trust",
				144112000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05C3V",
				"The Vanguard Group Inflation-Protection Securities Fund",
				51110000,
				"Registered Investment Companies"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund",
				43109000,
				"Registered Investment Companies"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				663139000,
				"Collective Investment Trusts"
			],
			[
				"F00000WTNQ",
				"Vanguard Institutional Extended Market Index Trust",
				126400000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA00KIR",
				"Vanguard Institutional Total International Stock Market Index Trust",
				125022000,
				"Collective Investment Trusts"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement Trust Select 2030",
				577540000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement Trust Select 2035",
				479771000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement Trust Select 2025",
				393885000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement Trust Select 2040",
				391011000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement Trust Select 2020",
				207709000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement Trust Select 2045",
				207499000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust Select 2050",
				132102000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				82425000,
				"Collective Investment Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement Trust Select 2055",
				63212000,
				"Collective Investment Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement Trust Select 2060",
				31348000,
				"Collective Investment Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement Trust Select 2065",
				15568000,
				"Collective Investment Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement Trust Select 2070",
				85000,
				"Collective Investment Trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust Select 2050",
				132102000,
				"Collective Investment Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement Trust Select 2030",
				577540000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement Trust Select 2035",
				479771000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement Trust Select 2025",
				393885000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement Trust Select 2040",
				391011000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement Trust Select 2020",
				207709000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement Trust Select 2045",
				207499000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust Select 2050",
				132102000,
				"Collective Investment Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				82425000,
				"Collective Investment Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement Trust Select 2055",
				63212000,
				"Collective Investment Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement Trust Select 2060",
				31348000,
				"Collective Investment Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement Trust Select 2065",
				15568000,
				"Collective Investment Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement Trust Select 2070",
				85000,
				"Collective Investment Trusts"
			]
		],
		"screen_results": {
			"fff": [
				76960432,
				153627575,
				0,
				153627575
			],
			"dff": [
				2663142,
				9695712,
				0,
				9695712
			],
			"gff": [
				1037448,
				1502749,
				0,
				1502749
			],
			"pff": [
				14218156,
				20836320,
				0,
				20836320
			],
			"wff": [
				34084462,
				61592938,
				0,
				61592938
			],
			"tff": [
				5892071,
				10530585,
				0,
				10530585
			]
		}
	},
	"fortinet": {
		"path": "fortinet",
		"employer": "fortinet",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/16/2023",
		"participants": 3693,
		"short_name": "Fortinet",
		"plan_short_name": "Fortinet's 401(k)",
		"primary_plan_name": "Fortinet Inc. 401(k) Plan",
		"chart_plan_title": "Fortinet Inc. 401(k) Plan",
		"primary_plan_logo": "fortinet",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Fortinet Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Fortinet Inc. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"fortinet-inc-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 316142701,
		"plan_option_count": 29,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 147749377,
			"equity": 143252959,
			"bond": 12268007,
			"other": 12872358,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 147749377
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Federal Money Market Fund",
				12872358,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity US Bond Index Fund",
				3920876,
				"Mutual Fund"
			],
			[
				"FOUSA00EH8",
				"PIMCO High Yield Fund",
				3782549,
				"Mutual Fund"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund",
				2921212,
				"Mutual Fund"
			],
			[
				"FOUSA05IJD",
				"DFA Inflation Protected Securities Fund",
				1643370,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				44919564,
				"Mutual Fund"
			],
			[
				"FOUSA00F2R",
				"Columbia Seligman Technology and Information Fund",
				19823133,
				"Mutual Fund"
			],
			[
				"F000014VHI",
				"T. Rowe Price Growth Stock Fund",
				17900038,
				"Mutual Fund"
			],
			[
				"FOUSA00B8C",
				"American Funds American Mutual Fund",
				12852198,
				"Mutual Fund"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index Fund",
				10273418,
				"Mutual Fund"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index Fund",
				7609293,
				"Mutual Fund"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund",
				7604641,
				"Mutual Fund"
			],
			[
				"F00000YWTN",
				"T. Rowe Price Diversified Mid Cap Growth Fund",
				6855759,
				"Mutual Fund"
			],
			[
				"F00000PW2C",
				"Franklin Small Cap Growth Fund",
				5323811,
				"Mutual Fund"
			],
			[
				"FOUSA00KDL",
				"Vanguard Selected Value Fund",
				5222090,
				"Mutual Fund"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				3073653,
				"Mutual Fund"
			],
			[
				"FOUSA00E6B",
				"DFA Emerging Markets Fund",
				1174825,
				"Mutual Fund"
			],
			[
				"FOUSA06LBG",
				"Goldman Sachs International Small Cap Fund",
				620536,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement Fund 2035",
				30138302,
				"Mutual Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement Fund 2040",
				25477407,
				"Mutual Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement Fund 2045",
				22374852,
				"Mutual Fund"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement Fund 2030",
				18599630,
				"Mutual Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement Fund 2050",
				15605515,
				"Mutual Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement Fund 2025",
				12232163,
				"Mutual Fund"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement Fund 2055",
				10618360,
				"Mutual Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement Fund 2020",
				4815701,
				"Mutual Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement Fund 2060",
				3538139,
				"Mutual Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				2418656,
				"Mutual Fund"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement Fund 2065",
				1930652,
				"Mutual Fund"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement Fund 2050",
				15605515,
				"Mutual Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement Fund 2035",
				30138302,
				"Mutual Fund"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement Fund 2040",
				25477407,
				"Mutual Fund"
			],
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement Fund 2045",
				22374852,
				"Mutual Fund"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement Fund 2030",
				18599630,
				"Mutual Fund"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement Fund 2050",
				15605515,
				"Mutual Fund"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement Fund 2025",
				12232163,
				"Mutual Fund"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement Fund 2055",
				10618360,
				"Mutual Fund"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement Fund 2020",
				4815701,
				"Mutual Fund"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement Fund 2060",
				3538139,
				"Mutual Fund"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund",
				2418656,
				"Mutual Fund"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement Fund 2065",
				1930652,
				"Mutual Fund"
			]
		],
		"screen_results": {
			"fff": [
				8971915,
				9867706,
				0,
				9867706
			],
			"dff": [
				543509,
				623384,
				0,
				623384
			],
			"gff": [
				202229,
				96421,
				0,
				96421
			],
			"pff": [
				3130079,
				1337128,
				0,
				1337128
			],
			"wff": [
				5674530,
				3955470,
				0,
				3955470
			],
			"tff": [
				815791,
				676172,
				0,
				676172
			]
		}
	},
	"google": {
		"path": "google",
		"employer": "google",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/01/2024",
		"participants": 149762,
		"short_name": "Google",
		"plan_short_name": "Google's 401(k)",
		"primary_plan_name": "Google LLC 401(k) Savings Plan",
		"chart_plan_title": "Google LLC 401(k) Savings\nPlan",
		"primary_plan_logo": "google",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Vanguard Brokerage",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Google LLC 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Google LLC 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"google-llc-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 37609897950,
		"plan_option_count": 30,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 25164390212,
			"equity": 10057987550,
			"bond": 1930920847,
			"other": 456599341,
			"sri": 1131290793,
			"cref": 0,
			"vanguard_target": 25161411719
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust II (at contract value)",
				451445712,
				"Collective Trusts"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				5153629,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Trust",
				843930978,
				"Collective Trusts"
			],
			[
				"FOUSA02T3B",
				"Vanguard Wellesley Income Fund Admiral Shares",
				609785286,
				"Mutual Funds"
			],
			[
				"F00000MN7G",
				"Metropolitan West Funds Total Return Bond Fund Class P",
				334539121,
				"Mutual Funds"
			],
			[
				"F00000NBIN",
				"Vanguard Total Intl Bond Market Index Fund Institutional",
				109835207,
				"Mutual Funds"
			],
			[
				"FOUSA05C3V",
				"Vanguard Inflation Protection Option",
				24561108,
				"Custom Investment Trusts"
			],
			[
				"",
				"Vanguard Income Option",
				8269147,
				"Custom Investment Trusts"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				5595217135,
				"Collective Trusts"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Trust",
				1363674265,
				"Collective Trusts"
			],
			[
				"FOUSA02SN7",
				"Vanguard Developed Markets Index Institutional Plus",
				1088573227,
				"Collective Trusts"
			],
			[
				"FOUSA05HGA",
				"Parnassus US Large Cap",
				710446044,
				"Custom Investment Trusts",
				"sri"
			],
			[
				"FOUSA02VJF",
				"TIAA-CREF Social Choice Equity Fund Institutional Class",
				420844749,
				"Mutual Funds",
				"sri"
			],
			[
				"FOUSA04BEQ",
				"Vanguard REIT Index Fund Institutional Shares",
				365737414,
				"Mutual Funds"
			],
			[
				"",
				"EARNEST Partners Smid Cap Core Fund, Founders Class",
				265844396,
				"Collective Trusts"
			],
			[
				"FOUSA06TXK",
				"Fidelity Diversified Commingled Pool Fund",
				201299094,
				"Collective Trusts"
			],
			[
				"FOUSA00L97",
				"Vanguard Growth Option",
				46351226,
				"Custom Investment Trusts"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust 2050",
				5882752660,
				"Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement Trust 2055",
				5249961909,
				"Collective Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement Trust 2045",
				4723068080,
				"Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement Trust 2040",
				2867167472,
				"Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement Trust 2060",
				2799470216,
				"Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement Trust 2035",
				1701539134,
				"Collective Trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement Trust 2030",
				882469068,
				"Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement Trust 2065",
				475759571,
				"Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement Trust 2025",
				367896350,
				"Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement Trust 2020",
				115759314,
				"Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				89596567,
				"Collective Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement Trust 2070",
				5971378,
				"Collective Trusts"
			],
			[
				"~",
				"Vanguard Target Retirement Income and Growth Trust",
				2978493,
				"Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust 2050",
				5882752660,
				"Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement Trust 2050",
				5882752660,
				"Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement Trust 2055",
				5249961909,
				"Collective Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement Trust 2045",
				4723068080,
				"Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement Trust 2040",
				2867167472,
				"Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement Trust 2060",
				2799470216,
				"Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement Trust 2035",
				1701539134,
				"Collective Trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement Trust 2030",
				882469068,
				"Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement Trust 2065",
				475759571,
				"Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement Trust 2025",
				367896350,
				"Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement Trust 2020",
				115759314,
				"Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust",
				89596567,
				"Collective Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement Trust 2070",
				5971378,
				"Collective Trusts"
			]
		],
		"screen_results": {
			"fff": [
				703267664,
				1942657949,
				0,
				1942657949
			],
			"dff": [
				27560791,
				123001371,
				0,
				123001371
			],
			"gff": [
				9006602,
				18936571,
				0,
				18936571
			],
			"pff": [
				129404167,
				262697141,
				0,
				262697141
			],
			"wff": [
				341652327,
				778389351,
				0,
				778389351
			],
			"tff": [
				51222439,
				133019056,
				0,
				133019056
			]
		}
	},
	"harvard-university": {
		"path": "harvard_university",
		"employer": "harvard-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 35923,
		"short_name": "Harvard University",
		"plan_short_name": "The Harvard University Tax Deferred Annuity Plan",
		"primary_plan_name": "Harvard University Tax Deferred Annuity Plan",
		"chart_plan_title": "Harvard University Tax-Deferred\nAnnuity Plan",
		"primary_plan_logo": "harvard_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Harvard University Tax Deferred Annuity Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Harvard University Tax Deferred Annuity Plan Form 5500 Filing and Attachment 2023",
				"harvard-university-tax-deferred-annuity-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3617921375,
		"plan_option_count": 30,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 1758652088,
			"equity": 1054391869,
			"bond": 157670948,
			"other": 647206470,
			"sri": 78484341,
			"cref": 414887453,
			"vanguard_target": 1758652088
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Benefit Responsive - GSRA",
				421809041,
				"Traditional Annuities"
			],
			[
				"",
				"TIAA Traditional Benefit Responsive - SRA",
				122890429,
				"Traditional Annuities"
			],
			[
				"",
				"Vanguard Treasury MoneyMkt Inv",
				61370664,
				"Registered Investment Companies"
			],
			[
				"",
				"TIAA Real Estate Account",
				16504312,
				"Pooled Separate Accounts"
			],
			[
				"",
				"TIAA Traditional Non-Benefit Responsive - RA",
				15640707,
				"Traditional Annuities"
			],
			[
				"",
				"CREF Money Market R3",
				8991317,
				"Registered Investment Companies"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Ttl Bd Mkt Idx InstPl",
				126057164,
				"Registered Investment Companies"
			],
			[
				"FOUSA05GTB",
				"Schwab Treas Infl Prot Sec Idx",
				16931237,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				8785780,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				5896767,
				"Registered Investment Companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000VE7X",
				"Vanguard Total St Mk Ix In Pl",
				453509756,
				"Registered Investment Companies"
			],
			[
				"STIAA00007",
				"CREF Stock R3",
				298872853,
				"Registered Investment Companies"
			],
			[
				"F00000JTBV",
				"Vanguard Total Int St Ix IsPls",
				145254990,
				"Registered Investment Companies"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Idx Instl",
				55422217,
				"Registered Investment Companies",
				"sri"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				34567285,
				"Registered Investment Companies"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				23749715,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				23062124,
				"Registered Investment Companies",
				"sri"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				19952929,
				"Registered Investment Companies"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				288787061,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				272582542,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				236940246,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				224013455,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				204155039,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				151826217,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				149579469,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				130896561,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				69041843,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				24306613,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				6322249,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				200793,
				"Registered Investment Companies"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				130896561,
				"Registered Investment Companies"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				298872853,
				"Registered Investment Companies"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				34567285,
				"Registered Investment Companies"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				23749715,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				23062124,
				"Registered Investment Companies"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				19952929,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				8785780,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				5896767,
				"Registered Investment Companies"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				288787061,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				272582542,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				236940246,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				224013455,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				204155039,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				151826217,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				149579469,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				130896561,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				69041843,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				24306613,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				6322249,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				200793,
				"Registered Investment Companies"
			]
		],
		"screen_results": {
			"fff": [
				83156685,
				104185638,
				30245662,
				104185638
			],
			"dff": [
				4037066,
				6580851,
				1480829,
				6580851
			],
			"gff": [
				949334,
				1018202,
				286892,
				1018202
			],
			"pff": [
				12526346,
				14119696,
				3085650,
				14119696
			],
			"wff": [
				35550440,
				41763990,
				13260893,
				41763990
			],
			"tff": [
				5245726,
				7139546,
				1316610,
				7139546
			]
		}
	},
	"harvard-university-2": {
		"path": "harvard_university_2",
		"employer": "harvard-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 23214,
		"short_name": "Harvard University",
		"plan_short_name": "The Harvard University Defined Contribution Retirement Plan",
		"primary_plan_name": "Harvard University Defined Contribution Retirement Plan",
		"chart_plan_title": "Harvard University Defined\nContribution Retirement Plan",
		"primary_plan_logo": "harvard_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Harvard University Defined Contribution Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Harvard University Defined Contribution Retirement Plan Form 5500 Filing and Attachment 2023",
				"harvard-university-defined-contribution-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1715628280,
		"plan_option_count": 28,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 1158696518,
			"equity": 302255997,
			"bond": 40273334,
			"other": 214402431,
			"sri": 30290573,
			"cref": 93879018,
			"vanguard_target": 1158696518
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Non-Benefit Responsive - GRA",
				146015804,
				"Traditional Annuities"
			],
			[
				"",
				"Vanguard Treasury MoneyMkt Inv",
				44705087,
				"Registered Investment Companies"
			],
			[
				"",
				"CREF Money Market R3",
				20604427,
				"Registered Investment Companies"
			],
			[
				"",
				"TIAA Real Estate",
				3077113,
				"Pooled Separate Accounts"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Ttl Bd Mkt Idx InstPl",
				33190207,
				"Registered Investment Companies"
			],
			[
				"FOUSA05GTB",
				"Schwab Treas Infl Prot Sec Idx",
				4792514,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				1265456,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				1025157,
				"Registered Investment Companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000VE7X",
				"Vanguard Total St Mk Ix In Pl",
				144368338,
				"Registered Investment Companies"
			],
			[
				"STIAA00007",
				"CREF Stock R3",
				58902758,
				"Registered Investment Companies"
			],
			[
				"F00000JTBV",
				"Vanguard Total Int St Ix IsPls",
				45040606,
				"Registered Investment Companies"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Idx Instl",
				21258648,
				"Registered Investment Companies",
				"sri"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				12513973,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				9031925,
				"Registered Investment Companies",
				"sri"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				7132483,
				"Registered Investment Companies"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				4007266,
				"Registered Investment Companies"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				223149045,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				197887528,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				189708669,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				148773882,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				136276073,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				86234408,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				67373369,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				53130020,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				34301767,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				17556285,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				4069225,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				236247,
				"Registered Investment Companies"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				86234408,
				"Registered Investment Companies"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				58902758,
				"Registered Investment Companies"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				12513973,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				9031925,
				"Registered Investment Companies"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				7132483,
				"Registered Investment Companies"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				4007266,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				1265456,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				1025157,
				"Registered Investment Companies"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				223149045,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				197887528,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				189708669,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				148773882,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				136276073,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				86234408,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				67373369,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				53130020,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				34301767,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				17556285,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				4069225,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				236247,
				"Registered Investment Companies"
			]
		],
		"screen_results": {
			"fff": [
				22992671,
				72771161,
				6262984,
				72771161
			],
			"dff": [
				1117083,
				4595304,
				310082,
				4595304
			],
			"gff": [
				270531,
				711400,
				59898,
				711400
			],
			"pff": [
				3685746,
				9864760,
				649949,
				9864760
			],
			"wff": [
				9924263,
				29172632,
				2865052,
				29172632
			],
			"tff": [
				1515055,
				4987255,
				270938,
				4987255
			]
		}
	},
	"harvard-university-3": {
		"path": "harvard_university_3",
		"employer": "harvard-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 8298,
		"short_name": "Harvard University",
		"plan_short_name": "The Retirement Income Plan for Teaching Faculty of Harvard University",
		"primary_plan_name": "Retirement Income Plan for Teaching Faculty of Harvard University",
		"chart_plan_title": "Retirement Income Plan\nfor Teaching Faculty\nof Harvard University",
		"primary_plan_logo": "harvard_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Retirement Income Plan for Teaching Faculty of Harvard University"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Retirement Income Plan for Teaching Faculty of Harvard University Form 5500 Filing and Attachment 2023",
				"retirement-income-plan-for-teaching-faculty-of-harvard-university-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 2079618140,
		"plan_option_count": 31,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 612589609,
			"equity": 853605300,
			"bond": 99748295,
			"other": 513674936,
			"sri": 37602374,
			"cref": 529509092,
			"vanguard_target": 612589609
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Non-Benefit Responsive - RA",
				384115392,
				"Annuity Contracts"
			],
			[
				"",
				"TIAA Traditional Non-Benefit Responsive - GRA",
				41764395,
				"Annuity Contracts"
			],
			[
				"",
				"Vanguard Treasury MoneyMkt Inv",
				39077471,
				"Registered Investment Companies"
			],
			[
				"",
				"CREF Money Market R3",
				19298573,
				"Registered Investment Companies"
			],
			[
				"",
				"TIAA Traditional Non-Benefit Responsive- Transfer Payout Annuities",
				16834149,
				"Annuity Contracts"
			],
			[
				"",
				"TIAA Real Estate Account",
				11958097,
				"Pooled Separate Accounts"
			],
			[
				"",
				"TIAA Traditional Non-Benefit Responsive - Interest Only Contracts",
				626859,
				"Annuity Contracts"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Ttl Bd Mkt Idx InstPl",
				75139235,
				"Registered Investment Companies"
			],
			[
				"FOUSA05GTB",
				"Schwab Treas Infl Prot Sec Idx",
				10970135,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				8193218,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				5445707,
				"Registered Investment Companies"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				426305509,
				"Registered Investment Companies"
			],
			[
				"F00000VE7X",
				"Vanguard Total St Mk Ix In Pl",
				237403745,
				"Registered Investment Companies"
			],
			[
				"F00000JTBV",
				"Vanguard Total Int St Ix IsPls",
				75407478,
				"Registered Investment Companies"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				27610620,
				"Registered Investment Companies"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				26457239,
				"Registered Investment Companies"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Idx Instl",
				24923910,
				"Registered Investment Companies",
				"sri"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				22818335,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				12678464,
				"Registered Investment Companies",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				107477060,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				101249579,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				95251964,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				81326858,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				77125678,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				63066334,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				50680480,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				24571753,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				7412866,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				2661409,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				1505519,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				260109,
				"Registered Investment Companies"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				24571753,
				"Registered Investment Companies"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				426305509,
				"Registered Investment Companies"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				27610620,
				"Registered Investment Companies"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				26457239,
				"Registered Investment Companies"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				22818335,
				"Registered Investment Companies"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				12678464,
				"Registered Investment Companies"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				8193218,
				"Registered Investment Companies"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				5445707,
				"Registered Investment Companies"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030",
				107477060,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025",
				101249579,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035",
				95251964,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040",
				81326858,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Income",
				77125678,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020",
				63066334,
				"Registered Investment Companies"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045",
				50680480,
				"Registered Investment Companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050",
				24571753,
				"Registered Investment Companies"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055",
				7412866,
				"Registered Investment Companies"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060",
				2661409,
				"Registered Investment Companies"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065",
				1505519,
				"Registered Investment Companies"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070",
				260109,
				"Registered Investment Companies"
			]
		],
		"screen_results": {
			"fff": [
				69612034,
				33614972,
				41999571,
				33614972
			],
			"dff": [
				3349586,
				2122002,
				2027479,
				2122002
			],
			"gff": [
				745000,
				328730,
				398353,
				328730
			],
			"pff": [
				9161705,
				4558167,
				4263187,
				4558167
			],
			"wff": [
				29498474,
				13476447,
				17863112,
				13476447
			],
			"tff": [
				3894814,
				2303997,
				1841499,
				2303997
			]
		}
	},
	"hilton": {
		"path": "hilton",
		"employer": "hilton",
		"year": 2022,
		"updated": " August 2023",
		"filing_received": " 08/02/2023",
		"participants": 32924,
		"short_name": "Hilton",
		"plan_short_name": "Hilton's 401(k)",
		"primary_plan_name": "Hilton 401(k) Plan",
		"chart_plan_title": "Hilton 401(k) Plan",
		"primary_plan_logo": "hilton",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Hilton 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Hilton 401(k) Plan Form 5500 Filing and Attachment 2022",
				"hilton-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 1682135283,
		"plan_option_count": 24,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1048642985,
			"equity": 401073810,
			"bond": 41990505,
			"other": 190427983,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"T. Rowe Price Hilton Stable Value Fund",
				189711705,
				""
			],
			[
				"",
				"T. Rowe Price U.S. Treasury Money Fund",
				716278,
				""
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Institutional Fund",
				29678688,
				""
			],
			[
				"F00000MN7G",
				"Metropolitan West Total Return Bond Plan",
				12311817,
				""
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GQ7",
				"Vanguard Total Institutional Stock Index Fund",
				134207529,
				""
			],
			[
				"FOUSA04BJY",
				"William Blair Small-Mid Cap Growth Institutional Fund",
				78664087,
				""
			],
			[
				"F00000VWMT",
				"T. Rowe Price Growth Stock Fund",
				68536081,
				""
			],
			[
				"FOUSA00C3O",
				"Dodge and Cox Stock Fund",
				58756201,
				""
			],
			[
				"F00000NQI4",
				"Invesco International Growth Fund",
				21930166,
				""
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund",
				21491236,
				""
			],
			[
				"FOUSA02VN9",
				"T. Rowe Price Retirement Balanced Fund",
				17488510,
				""
			]
		],
		"default_plan_options": [
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025 Fund",
				192334765,
				""
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030 Fund",
				183185696,
				""
			],
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035 Fund",
				159675335,
				""
			],
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040 Fund",
				130711276,
				""
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020 Fund",
				99842485,
				""
			],
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045 Fund",
				99763391,
				""
			],
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Fund",
				73757430,
				""
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055 Fund",
				44112389,
				""
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015 Fund",
				41230823,
				""
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060 Fund",
				15372213,
				""
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005 Fund",
				3980419,
				""
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010 Fund",
				2426726,
				""
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065 Fund",
				2250037,
				""
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Fund",
				73757430,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				24042812,
				82656310,
				0,
				0
			],
			"dff": [
				514160,
				5613126,
				0,
				0
			],
			"gff": [
				202518,
				1048109,
				0,
				0
			],
			"pff": [
				7451282,
				7381666,
				0,
				0
			],
			"wff": [
				18741803,
				36208522,
				0,
				0
			],
			"tff": [
				1063105,
				1951473,
				0,
				0
			]
		}
	},
	"intuit": {
		"path": "intuit",
		"employer": "intuit",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/12/2023",
		"participants": 27786,
		"short_name": "Intuit",
		"plan_short_name": "Intuit's 401(k)",
		"primary_plan_name": "Intuit Inc. 401(k) Plan",
		"chart_plan_title": "Intuit Inc. 401(k) Plan",
		"primary_plan_logo": "intuit",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Schwab Self-Directed Brokerage Fund",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Intuit Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Intuit Inc. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"intuit-inc-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 2306603590,
		"plan_option_count": 19,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1740390981,
			"equity": 462115247,
			"bond": 39117494,
			"other": 64979868,
			"sri": 33025493,
			"cref": 0,
			"vanguard_target": 1740390981
		},
		"other_plan_options": [
			[
				"",
				"Putnam Stable Value Fund",
				64979868,
				"Common/Collective Trust"
			]
		],
		"bond_plan_options": [
			[
				"F00000QT2G",
				"State Street US Bond Index SL CL XIV",
				39117494,
				"Common/Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00F0N",
				"State Street S&P 500 Index SL CL II",
				258288011,
				"Common/Collective Trust"
			],
			[
				"F00000J3JX",
				"State Street S&P Midcap Index SL CL XIV",
				78275232,
				"Common/Collective Trust"
			],
			[
				"F00000J3KF",
				"State Street Russell Small Cap Index II",
				54110994,
				"Common/Collective Trust"
			],
			[
				"F00000QT2A",
				"State Street Global All Cap Equity Ex-US Index",
				38415517,
				"Common/Collective Trust"
			],
			[
				"FOUSA02SNF",
				"Vanguard FTSE Social Index I",
				33025493,
				"Mutual Fund",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035 Trust Select Fund",
				302936487,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040 Trust Select Fund",
				289229518,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045 Trust Select Fund",
				254579413,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050 Trust Select Fund",
				232973968,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030 Trust Select Fund",
				208181515,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055 Trust Select Fund",
				158293987,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025 Trust Select Fund",
				143827275,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060 Trust Select Fund",
				57176630,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020 Trust Select Fund",
				43497666,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Inc Trust Select",
				31096343,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065 Trust Select Fund",
				17840395,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070 Trust Select Fund",
				757784,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050 Trust Select Fund",
				232973968,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retire 2035 Trust Select Fund",
				302936487,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retire 2040 Trust Select Fund",
				289229518,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retire 2045 Trust Select Fund",
				254579413,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retire 2050 Trust Select Fund",
				232973968,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retire 2030 Trust Select Fund",
				208181515,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retire 2055 Trust Select Fund",
				158293987,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retire 2025 Trust Select Fund",
				143827275,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retire 2060 Trust Select Fund",
				57176630,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retire 2020 Trust Select Fund",
				43497666,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retire Inc Trust Select",
				31096343,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retire 2065 Trust Select Fund",
				17840395,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retire 2070 Trust Select Fund",
				757784,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				34417891,
				118334808,
				0,
				118334808
			],
			"dff": [
				937342,
				7478237,
				0,
				7478237
			],
			"gff": [
				472496,
				1155872,
				0,
				1155872
			],
			"pff": [
				6439821,
				16030032,
				0,
				16030032
			],
			"wff": [
				15565243,
				47431527,
				0,
				47431527
			],
			"tff": [
				2244743,
				8107833,
				0,
				8107833
			]
		}
	},
	"keurig-dr-pepper": {
		"path": "keurig_dr_pepper",
		"employer": "keurig-dr-pepper",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/12/2023",
		"participants": 26144,
		"short_name": "Keurig Dr Pepper",
		"plan_short_name": "Keurig Dr Pepper's 401(k)",
		"primary_plan_name": "Keurig Dr Pepper 401(k) Plan",
		"chart_plan_title": "Keurig Dr Pepper 401(k) Plan",
		"primary_plan_logo": "keurig_dr_pepper",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Keurig Dr Pepper 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Keurig Dr Pepper 401(k) Plan Form 5500 Filing and Attachment 2022",
				"keurig-dr-pepper-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 1404477500,
		"plan_option_count": 24,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1044655335,
			"equity": 245497676,
			"bond": 24577875,
			"other": 89746614,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1044655335
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Managed Income Portfolio II Class 3",
				89664691,
				"Common / Collective Trust"
			],
			[
				"",
				"Fidelity Government Money Market Fund",
				81923,
				"Mutual Funds"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				13965851,
				"Mutual Funds"
			],
			[
				"",
				"WTC-CIF II Core Bond Plus Series 4",
				10612024,
				"Common / Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"F000013FUR",
				"Fidelity Growth Company Pool",
				84648881,
				"Common / Collective Trust"
			],
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				64996098,
				"Mutual Funds"
			],
			[
				"FOUSA02T2O",
				"Vanguard Windsor II Fund, Admiral Shares",
				24849650,
				"Mutual Funds"
			],
			[
				"F000013ARA",
				"William Blair Small Mid Cap Growth CIT",
				20094715,
				"Common / Collective Trust"
			],
			[
				"FOUSA00C2O",
				"DFA U.S. Small Cap Value Portfolio Institutional Class",
				17829480,
				"Mutual Funds"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				13821107,
				"Mutual Funds"
			],
			[
				"F00000WZVM",
				"Fidelity Total International Index Fund",
				9673537,
				"Mutual Funds"
			],
			[
				"F000002P1T",
				"Capital Group EuroPacific Growth Trust Class U4",
				9584208,
				"Common / Collective Trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target 2035",
				200482325,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030",
				183852727,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025",
				146765456,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target 2040",
				138737773,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045",
				126222765,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				96511387,
				"Common / Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055",
				60595534,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020",
				46020121,
				"Common / Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060",
				20999643,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Inc.",
				18188057,
				"Common / Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065",
				6271579,
				"Common / Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070",
				7968,
				"Common / Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				96511387,
				"Common / Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target 2035",
				200482325,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030",
				183852727,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025",
				146765456,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target 2040",
				138737773,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045",
				126222765,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				96511387,
				"Common / Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055",
				60595534,
				"Common / Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020",
				46020121,
				"Common / Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060",
				20999643,
				"Common / Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Inc.",
				18188057,
				"Common / Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065",
				6271579,
				"Common / Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070",
				7968,
				"Common / Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				13641409,
				66544124,
				0,
				66544124
			],
			"dff": [
				311721,
				4203094,
				0,
				4203094
			],
			"gff": [
				327985,
				650357,
				0,
				650357
			],
			"pff": [
				2989576,
				9018635,
				0,
				9018635
			],
			"wff": [
				8305602,
				26675133,
				0,
				26675133
			],
			"tff": [
				1562459,
				4560132,
				0,
				4560132
			]
		}
	},
	"mastercard": {
		"path": "mastercard",
		"employer": "mastercard",
		"year": 2021,
		"updated": " July 2022",
		"filing_received": " 07/26/2022",
		"participants": 9962,
		"short_name": "Mastercard",
		"plan_short_name": "Mastercard's 401(k)",
		"primary_plan_name": "Mastercard Savings Plan",
		"chart_plan_title": "Mastercard Savings Plan",
		"primary_plan_logo": "mastercard",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "State Street Global Advisors",
		"default_fund_manager_path": "state_street_global_advisors",
		"default_fund_name": "State Street Target Retirement Series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Mastercard Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Mastercard Savings Plan Form 5500 Filing and Attachment 2021 ",
				"mastercard-savings-plan-form-5500-filing-and-attachment-2021.pdf"
			]
		],
		"plan_assets": 2913803000,
		"plan_option_count": 24,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 849727000,
			"equity": 1718063000,
			"bond": 197900000,
			"other": 148113000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Invesco - Invesco Stable Value Trust Class B1",
				148113000,
				"Collective Trusts"
			]
		],
		"bond_plan_options": [
			[
				"F00000V503",
				"Prudential Trust Company - Core Plus Bond Fund",
				177431000,
				"Collective Trusts"
			],
			[
				"FOUSA00K6F",
				"MacKay Shields - High Yield Collective Investment Trust",
				20469000,
				"Collective Trusts"
			]
		],
		"equity_plan_options": [
			[
				"F00000QT2D",
				"State Street Bank and Trust Company - S&P 500 Index Non-Lending Series Fund - Class K",
				528859000,
				"Collective Trusts"
			],
			[
				"FOUSA02VIY",
				"T. Rowe Price Associates, Inc. - Large Cap Growth Trust Class D",
				259475000,
				"Collective Trusts"
			],
			[
				"F00000VV1B",
				"State Street Bank and Trust Company - Russell Small/Mid Cap Index Non-Lending Series Fund - Class K",
				255927000,
				"Collective Trusts"
			],
			[
				"F00000TIA0",
				"Alliance Bernstein - AB Discovery Growth Fund Class Z",
				139101000,
				"Mutual funds"
			],
			[
				"FEUSA0002W",
				"State Street Bank and Trust Company - International Index Non-Lending Series Fund - Class C",
				129633000,
				"Collective Trusts"
			],
			[
				"F00000W7A4",
				"Aristotle Capital Management - Value Equity Collective Trust",
				119822000,
				"Collective Trusts"
			],
			[
				"FOUSA00K3X",
				"Artisan Partners - International Growth Trust",
				97674000,
				"Collective Trusts"
			],
			[
				"F00000W4VL",
				"Goldman Sachs Asset Management L.P. - Small/Mid Cap Value Fund Class R6",
				81863000,
				"Mutual funds"
			],
			[
				"F00000NBB3",
				"BlackRock - BlackRock Strategic Completion Non-Lendable Fund M CIT",
				75792000,
				"Collective Trusts"
			],
			[
				"FOUSA06NSW",
				"William Blair - Emerging Markets Leaders Fund Institutional Class 3",
				29917000,
				"Collective Trusts"
			]
		],
		"default_plan_options": [
			[
				"F00000T8YW",
				"State Street Bank and Trust Company - Target Retirement 2035 Non-Lending Series Fund - Class W",
				143914000,
				"Collective Trusts"
			],
			[
				"F00000T8Z0",
				"State Street Bank and Trust Company - Target Retirement 2040 Non-Lending Series Fund - Class W",
				130190000,
				"Collective Trusts"
			],
			[
				"F00000T8Z4",
				"State Street Bank and Trust Company - Target Retirement 2045 Non-Lending Series Fund - Class W",
				126028000,
				"Collective Trusts"
			],
			[
				"F00000T8YS",
				"State Street Bank and Trust Company - Target Retirement 2030 Non-Lending Series Fund - Class W",
				108002000,
				"Collective Trusts"
			],
			[
				"F00000T8XK",
				"State Street Bank and Trust Company - Target Retirement 2050 Non-Lending Series Fund - Class W",
				97627000,
				"Collective Trusts"
			],
			[
				"F00000T8YO",
				"State Street Bank and Trust Company - Target Retirement 2025 Non-Lending Series Fund - Class W",
				86426000,
				"Collective Trusts"
			],
			[
				"F00000T8XO",
				"State Street Bank and Trust Company - Target Retirement 2055 Non-Lending Series Fund - Class W",
				61630000,
				"Collective Trusts"
			],
			[
				"F00000T8XS",
				"State Street Bank and Trust Company - Target Retirement 2060 Non-Lending Series Fund - Class W",
				37513000,
				"Collective Trusts"
			],
			[
				"F00000T8YK",
				"State Street Bank and Trust Company - Target Retirement 2020 Non-Lending Series Fund - Class W",
				34147000,
				"Collective Trusts"
			],
			[
				"F00000T8YC",
				"State Street Bank and Trust Company - State Street Target Retirement Funds - Class W",
				19592000,
				"Collective Trusts"
			],
			[
				"F000014AX4",
				"State Street Bank and Trust Company - Target Retirement 2065 Non-Lending Series Fund - Class W",
				4658000,
				"Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"F00000T8XK",
				"State Street Bank and Trust Company - Target Retirement 2050 Non-Lending Series Fund - Class W",
				97627000,
				"Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				110579711,
				49939174,
				0,
				0
			],
			"dff": [
				2942330,
				2990613,
				0,
				0
			],
			"gff": [
				972721,
				445942,
				0,
				0
			],
			"pff": [
				21785388,
				6557272,
				0,
				0
			],
			"wff": [
				90596913,
				20709588,
				0,
				0
			],
			"tff": [
				7915816,
				3345922,
				0,
				0
			]
		}
	},
	"meta": {
		"path": "meta",
		"employer": "meta",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 06/27/2023",
		"participants": 82353,
		"short_name": "Meta",
		"plan_short_name": "Meta's 401(k)",
		"primary_plan_name": "Meta Platforms, Inc 401(k) Plan",
		"chart_plan_title": "Meta Platforms, Inc. 401(k)\nPlan",
		"primary_plan_logo": "meta",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Meta Platforms, Inc 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Meta Platforms, Inc 401(k) Plan Form 5500 Filing and Attachment 2023",
				"meta-platforms-inc-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 11031270042,
		"plan_option_count": 19,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 8021202046,
			"equity": 2709699302,
			"bond": 202144694,
			"other": 98224000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 8021202046
		},
		"other_plan_options": [
			[
				"",
				"Invesco Stable Value Trust Class B1",
				97061214,
				"Common/Collective Trust"
			],
			[
				"",
				"Fidelity Investments Money Market Government Portfolio - Institutional Class",
				1162786,
				"Interest-Bearing Cash"
			]
		],
		"bond_plan_options": [
			[
				"F00000QT2G",
				"State Street U.S. Bond Index Securities Lending Series Fund Class XIV",
				145758167,
				"Common/Collective Trust"
			],
			[
				"FOUSA05C3V",
				"State Street U.S. Inflation Protected Bond Index Fund",
				36676691,
				"Common/Collective Trust"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Institutional Shares",
				19709836,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000MJS0",
				"State Street U.S. Total Market Index Securities Lending Series Fund Class I",
				2406342794,
				"Common/Collective Trust"
			],
			[
				"F00000QT2A",
				"State Street Global All Cap Equity Ex-U.S. Index Securities Lending Series Fund Class II",
				303356508,
				"Common/Collective Trust"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select",
				1843829146,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				1755582055,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select",
				1191378938,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select",
				1165228980,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select",
				717725744,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select",
				627950041,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select",
				369926539,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select",
				171707999,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select",
				78847077,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				45183072,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select",
				30290667,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select",
				23551788,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				1755582055,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select",
				1843829146,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				1755582055,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select",
				1191378938,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select",
				1165228980,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select",
				717725744,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select",
				627950041,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select",
				369926539,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select",
				171707999,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select",
				78847077,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				45183072,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select",
				30290667,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select",
				23551788,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				227225647,
				631525188,
				0,
				631525188
			],
			"dff": [
				6936829,
				39992258,
				0,
				39992258
			],
			"gff": [
				3218658,
				6154860,
				0,
				6154860
			],
			"pff": [
				44045015,
				85385367,
				0,
				85385367
			],
			"wff": [
				99609751,
				253033405,
				0,
				253033405
			],
			"tff": [
				18208325,
				43239868,
				0,
				43239868
			]
		}
	},
	"microsoft": {
		"path": "microsoft",
		"employer": "microsoft",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 07/30/2024",
		"participants": 173630,
		"short_name": "Microsoft",
		"plan_short_name": "Microsoft's 401(k)",
		"primary_plan_name": "Microsoft Corporation Savings Plus 401(k) Plan",
		"chart_plan_title": "Microsoft Corporation\nSavings Plus 401(k) Plan",
		"primary_plan_logo": "microsoft",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock LifePath Index series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "carbon negative by 2030",
		"proposal_title": "Proposal 9 - Report on Climate Risks to Retirement Plan Beneficiaries",
		"proposal_url": "2023/06/28-microsoft-protect-retirement-beneficiaries-portfolio-climate-risk",
		"plan_names": [
			"Microsoft Corporation Savings Plus 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Microsoft Corporation Savings Plus 401(k) Plan Form 5500 Filing and Attachment 2023",
				"microsoft-corporation-savings-plus-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 49340409417,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 14836204504,
			"equity": 26397918153,
			"bond": 1583936148,
			"other": 6522350612,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Microsoft Common Stock",
				4854442186,
				"EMPLOYER STOCK"
			],
			[
				"",
				"BlackRock Short-term Investment Fund",
				999345283,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"",
				"Vanguard Short-Term Bond Index Fund Institutional Plus Shares",
				668563143,
				"MUTUAL FUNDS"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00EH4",
				"PIMCO Total Return Account",
				1458675904,
				"SEPARATELY MANAGED ACCOUNTS"
			],
			[
				"F00000MISP",
				"PIMCO Inflation Response CIT Class I",
				96942846,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"FOUSA04BAX",
				"PIMCO All Asset All Authority Fund Institutional Class",
				28317398,
				"MUTUAL FUNDS"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard 500 Index Institutional Select Shares",
				6451869820,
				"MUTUAL FUNDS"
			],
			[
				"FOUSA06U0Z",
				"Fidelity Growth Company Pool Class S",
				5220592236,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"FOUSA06TX6",
				"Fidelity Contrafund Pool Class S",
				3301600740,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000J3K7",
				"Vanguard Russell 1000 Growth Index Trust",
				2601229324,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"FOUSA02T5B",
				"Artisan Mid Cap Account",
				1850561392,
				"SEPARATELY MANAGED ACCOUNTS"
			],
			[
				"F00000J3KB",
				"Vanguard Russell 1000 Value Index Trust",
				1774263122,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"",
				"International Growth Account",
				1462923697,
				"SEPARATELY MANAGED ACCOUNTS"
			],
			[
				"F00000J3KD",
				"Vanguard Russell 2000 Growth Index Trust",
				1358201078,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"",
				"International Value Account",
				1319030741,
				"SEPARATELY MANAGED ACCOUNTS"
			],
			[
				"FOUSA00C2O",
				"SMID Cap Value Account",
				1057646003,
				"SEPARATELY MANAGED ACCOUNTS"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPG",
				"BlackRock LifePath Index 2050 Unitized Account M",
				4145724560,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAPI",
				"BlackRock LifePath Index 2040 Unitized Account M ",
				3731163303,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAPK",
				"BlackRock LifePath Index 2030 Unitized Account M",
				1928396559,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000WM8M",
				"BlackRock LifePath Index 2060 Unitized Account M",
				1529081153,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAP0",
				"BlackRock LifePath Index 2055 Unitized Account M",
				1074606754,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAPH",
				"BlackRock LifePath Index 2045 Unitized Account M",
				857604507,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAOX",
				"BlackRock LifePath Index Retirement Unitized Account M",
				570465791,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAPJ",
				"BlackRock LifePath Index 2035 Unitized Account M",
				533615954,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F000013OYO",
				"BlackRock LifePath Index 2065 Unitized Account M",
				286375521,
				"COMMON COLLECTIVE TRUSTS"
			],
			[
				"F00000MAPL",
				"BlackRock LifePath Index 2025 Unitized Account M",
				179170402,
				"COMMON COLLECTIVE TRUSTS"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock LifePath Index 2050 Unitized Account M",
				4145724560,
				"COMMON COLLECTIVE TRUSTS"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				1543854111,
				1112019052,
				0,
				0
			],
			"dff": [
				21910506,
				60703291,
				0,
				0
			],
			"gff": [
				16230780,
				9960290,
				0,
				0
			],
			"pff": [
				219781386,
				147286600,
				0,
				0
			],
			"wff": [
				650669001,
				441406401,
				0,
				0
			],
			"tff": [
				134055905,
				72270785,
				0,
				0
			]
		}
	},
	"monster-energy-company": {
		"path": "monster_energy_company",
		"employer": "monster-energy-company",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/05/2024",
		"participants": 3733,
		"short_name": "Monster Energy Company",
		"plan_short_name": "Monster Energy Company's 401(k)",
		"primary_plan_name": "Monster Energy Company 401(k) Plan",
		"chart_plan_title": "Monster Energy Company\n401(k) Plan",
		"primary_plan_logo": "monster_energy_company",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Index series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Monster Energy Company 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Monster Energy Company 401(k) Plan Form 5500 Filing and Attachment 2023",
				"monster-energy-company-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 207753687,
		"plan_option_count": 43,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 992155,
			"equity": 160958918,
			"bond": 36813675,
			"other": 8988939,
			"sri": 11182473,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Goldman Sachs Stable Value Fund",
				8962563,
				"Common/Collective Trust"
			],
			[
				"",
				"State Street Bank & Trust Co. Cash Reserve Account",
				26376,
				"Interest-Bearing Cash"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Inc I",
				9669400,
				"Mutual Funds"
			],
			[
				"FOUSA05GP1",
				"Vanguard Interm-Term Bd Idx Inst",
				8348918,
				"Mutual Funds"
			],
			[
				"F00000U60O",
				"Hartford World Bd R6",
				6705755,
				"Mutual Funds"
			],
			[
				"FOUSA00IC5",
				"Victory Fund for Inc A",
				5360848,
				"Mutual Funds"
			],
			[
				"FOUSA00J7A",
				"PIMCO Real Return A",
				3405388,
				"Mutual Funds"
			],
			[
				"FOUSA02TY8",
				"Vanguard High-Yield Corporate Adm",
				1797007,
				"Mutual Funds"
			],
			[
				"FOUSA056SA",
				"Eaton Vance High Inc Opp A",
				1526359,
				"Mutual Funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				20627007,
				"Mutual Funds"
			],
			[
				"FOUSA05BT9",
				"MFS Val R3",
				19350249,
				"Mutual Funds"
			],
			[
				"F00000VVAG",
				"Columbia Disciplined Gr Inst3",
				19307154,
				"Mutual Funds"
			],
			[
				"FOUSA06B5B",
				"Vanguard FTSE All-World ex-US ldx I",
				15869774,
				"Mutual Funds"
			],
			[
				"F00000QHZ6",
				"JPMorgan Emerging Mkts Eq R6",
				13300627,
				"Mutual Funds"
			],
			[
				"F00000XRY0",
				"Principal Real Estate Securities R6",
				12846235,
				"Mutual Funds"
			],
			[
				"FOUSA08635",
				"MFS Intl Val R3",
				11250348,
				"Mutual Funds"
			],
			[
				"FOUSA00BJQ",
				"Calvert Eq A",
				11182473,
				"Mutual Funds",
				"sri"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Gr R6",
				8139668,
				"Mutual Funds"
			],
			[
				"FOUSA00L7W",
				"Vanguard Small Cap Index Adm",
				4489590,
				"Mutual Funds"
			],
			[
				"FOUSA00JW9",
				"Victory Sycamore Est Val A",
				4361067,
				"Mutual Funds"
			],
			[
				"F00000MT9D",
				"JPMorgan Mid Cap Gr R6",
				4241115,
				"Mutual Funds"
			],
			[
				"FOUSA02TYC",
				"Vanguard Mid Cap Index Adm",
				3585198,
				"Mutual Funds"
			],
			[
				"FOUSA06J7M",
				"Victory Sycamore Small Co Opp I",
				3083965,
				"Mutual Funds"
			],
			[
				"FOUSA06SU9",
				"Legg Mason ClearBridge Small Cap Gr IS",
				2820176,
				"Mutual Funds"
			],
			[
				"F00000W208",
				"Hartford Schroders US S/M-cp Opps SDR",
				1859774,
				"Mutual Funds"
			],
			[
				"FOUSA04BNE",
				"Vanguard Information Tech Index Adm",
				1315641,
				"Mutual Funds"
			],
			[
				"FOUSA02SV3",
				"BlackRock Health Sciences Opp Instl",
				952429,
				"Mutual Funds"
			],
			[
				"FOUSA02V3O",
				"American Funds American Balanced R4",
				732748,
				"Mutual Funds"
			],
			[
				"FOUSA00ESV",
				"Davis Financial A",
				678835,
				"Mutual Funds"
			],
			[
				"FOUSA00CIK",
				"Fidelity Select Energy",
				562104,
				"Mutual Funds"
			],
			[
				"FOUSA00J8E",
				"Franklin Templeton Utilities Adv",
				402741,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"F0000154LW",
				"Fidelity Freedom Index 2050 Premier",
				185801,
				"Mutual Funds"
			],
			[
				"F0000154M2",
				"Fidelity Freedom Index 2025 Premier",
				163254,
				"Mutual Funds"
			],
			[
				"F0000154M6",
				"Fidelity Freedom Index 2055 Premier",
				129192,
				"Mutual Funds"
			],
			[
				"F0000154M5",
				"Fidelity Freedom Index 2040 Premier",
				115972,
				"Mutual Funds"
			],
			[
				"F0000154M4",
				"Fidelity Freedom Index 2035 Premier",
				111080,
				"Mutual Funds"
			],
			[
				"F0000154M3",
				"Fidelity Freedom Index 2030 Premier",
				97860,
				"Mutual Funds"
			],
			[
				"F0000154M0",
				"Fidelity Freedom Index 2015 Premier",
				63058,
				"Mutual Funds"
			],
			[
				"F0000154M7",
				"Fidelity Freedom Index 2060 Premier",
				55518,
				"Mutual Funds"
			],
			[
				"F0000154M1",
				"Fidelity Freedom Index 2020 Premier",
				39352,
				"Mutual Funds"
			],
			[
				"F0000154LV",
				"Fidelity Freedom Index 2045 Premier",
				30955,
				"Mutual Funds"
			],
			[
				"F0000154LX",
				"Fidelity Freedom Index Inc Premier",
				89,
				"Mutual Funds"
			],
			[
				"F0000154M8",
				"Fidelity Freedom Index 2065 Premier",
				24,
				"Mutual Funds"
			]
		],
		"rated_as_option": [
			[
				"F0000154LW",
				"Fidelity Freedom Index 2050 Premier",
				185801,
				"Mutual Funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				12057416,
				67115,
				0,
				0
			],
			"dff": [
				427632,
				4063,
				0,
				0
			],
			"gff": [
				265791,
				552,
				0,
				0
			],
			"pff": [
				2395779,
				9049,
				0,
				0
			],
			"wff": [
				7111935,
				27168,
				0,
				0
			],
			"tff": [
				513444,
				4768,
				0,
				0
			]
		}
	},
	"netflix": {
		"path": "netflix",
		"employer": "netflix",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/13/2024",
		"participants": 10070,
		"short_name": "Netflix",
		"plan_short_name": "Netflix's 401(k)",
		"primary_plan_name": "Netflix 401(k) Plan",
		"chart_plan_title": "Netflix 401(k) Plan",
		"primary_plan_logo": "netflix",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Netflix 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Netflix 401(k) Plan Form 5500 Filing and Attachment 2022",
				"netflix-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 1222448278,
		"plan_option_count": 30,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 716402560,
			"equity": 456025918,
			"bond": 34706313,
			"other": 15313487,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 716402560
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Government Money Market Fund",
				11783795,
				"Money Market Fund"
			],
			[
				"",
				"Fidelity Managed Income Portfolio Fund",
				3529692,
				"Common/Collective Trust"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				20657588,
				"Mutual Fund"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Institutional Fund",
				14048725,
				"Common/Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"F00000MJS0",
				"Fidelity Total Market Index Fund",
				119739964,
				"Mutual Fund"
			],
			[
				"FOUSA04BCT",
				"Fidelity Nasdaq Composite Index Fund",
				81775143,
				"Mutual Fund"
			],
			[
				"FOUSA06TX6",
				"Fidelity Contrafund",
				54161940,
				"Common/Collective Trust"
			],
			[
				"FOUSA06J7K",
				"Victory Sycamore Established Value Fund",
				29934455,
				"Mutual Fund"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				28969042,
				"Mutual Fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				24069532,
				"Mutual Fund"
			],
			[
				"FOUSA05BPL",
				"MainStay Large-Cap Growth Fund",
				23644718,
				"Mutual Fund"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced Fund",
				20554304,
				"Mutual Fund"
			],
			[
				"FOUSA06U11",
				"Fidelity International Capital Appreciation Fund",
				16790866,
				"Mutual Fund"
			],
			[
				"F00000PBOJ",
				"MFS Mid Cap Growth R6",
				15556824,
				"Mutual Fund"
			],
			[
				"F000002YE3",
				"American Beacon Large-Cap Value Institutional Fund",
				14474283,
				"Mutual Fund"
			],
			[
				"F000002YE4",
				"American Beacon Small-Cap Value Institutional Fund",
				14075901,
				"Mutual Fund"
			],
			[
				"F00000PW2C",
				"Franklin Small-Cap Growth Fund",
				9127626,
				"Mutual Fund"
			],
			[
				"FOUSA05B3E",
				"MFS International Diversification Fund",
				3151320,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				179431649,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045",
				151393674,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055",
				123380748,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target 2040",
				102712240,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target 2035",
				68162772,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060",
				33587201,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030",
				24888558,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025",
				12071818,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065",
				9007458,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				6556372,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020",
				5183379,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070",
				26691,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				179431649,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target 2050",
				179431649,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target 2045",
				151393674,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target 2055",
				123380748,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target 2040",
				102712240,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target 2035",
				68162772,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target 2060",
				33587201,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target 2030",
				24888558,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target 2025",
				12071818,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target 2065",
				9007458,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				6556372,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target 2020",
				5183379,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target 2070",
				26691,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				33125712,
				54130315,
				0,
				54130315
			],
			"dff": [
				791382,
				3426372,
				0,
				3426372
			],
			"gff": [
				373991,
				527806,
				0,
				527806
			],
			"pff": [
				6208215,
				7321667,
				0,
				7321667
			],
			"wff": [
				15782834,
				21690191,
				0,
				21690191
			],
			"tff": [
				1315532,
				3706788,
				0,
				3706788
			]
		}
	},
	"new-york-times": {
		"path": "new_york_times",
		"employer": "new-york-times",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 8592,
		"short_name": "The New York Times",
		"plan_short_name": "The New York Times' 401(k)",
		"primary_plan_name": "The New York Times Savings Plan",
		"chart_plan_title": "The New York Times\nSavings Plan",
		"primary_plan_logo": "new_york_times",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"The New York Times Savings Plan",
			"The New York Times Companies Supplemental Retirement and Investment Plan",
			"The New York Times Company Payroll Investment Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"The New York Times Savings Plan Form 5500 Filing and Attachment 2023",
				"the-new-york-times-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			],
			[
				"The New York Times Companies Supplemental Retirement and Investment Plan Form 5500 Filing and Attachment 2023",
				"the-new-york-times-companies-supplemental-retirement-and-investment-plan-form-5500-filing-and-attachment-2023.pdf"
			],
			[
				"The New York Times Company Payroll Investment Plan Form 5500 Filing and Attachment 2023",
				"the-new-york-times-company-payroll-investment-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1748410416,
		"plan_option_count": 27,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 601475149,
			"equity": 857579106,
			"bond": 148622627,
			"other": 140733534,
			"sri": 14675043,
			"cref": 0,
			"vanguard_target": 601475149
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust III ",
				139806213,
				"Common/collective trusts "
			],
			[
				"",
				"Vanguard Cash Res Federal MM Adm ",
				927321,
				"Registered Investment Companies "
			]
		],
		"bond_plan_options": [
			[
				"FOUSA02TYI",
				"Vanguard Institutional Total Bond Market Index Trust ",
				95369862,
				"Common/collective trusts "
			],
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund ",
				53252765,
				"Registered Investment Companies "
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust ",
				431467704,
				"Common/collective trusts "
			],
			[
				"F00000JTEF",
				"Vanguard Institutional Total International Stock Market Index Trust ",
				83360659,
				"Common/collective trusts "
			],
			[
				"FOUSA04BCR",
				"T. Rowe Price Institutional Large Cap Core Growth Fund ",
				65016763,
				"Registered Investment Companies "
			],
			[
				"FOUSA02TID",
				"Vanguard International Growth Fund ",
				55532804,
				"Registered Investment Companies "
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund ",
				49740765,
				"Registered Investment Companies "
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust ",
				49720732,
				"Common/collective trusts "
			],
			[
				"F00000VOGS",
				"Loomis Sayles & Company Small Mid Cap Growth CIT Class C ",
				47104323,
				"Common/collective trusts "
			],
			[
				"FOUSA05BKA",
				"Alliance Bernstein AB US Small and Mid Cap Value CIT (W Series); Class P2 ",
				46812106,
				"Common/collective trusts "
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund ",
				14675043,
				"Registered Investment Companies ",
				"sri"
			],
			[
				"FOUSA05IBW",
				"Vanguard Emerging Markets Stock Index Fund ",
				14022153,
				"Registered Investment Companies "
			],
			[
				"FOUSA06JNJ",
				"Deutsche DWS RREEF Real Assets CIT Class B ",
				126054,
				"Common/collective trusts "
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I ",
				79769299,
				"Common/collective trusts "
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I ",
				74655620,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I ",
				74054107,
				"Common/collective trusts "
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I ",
				73075655,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I ",
				69938294,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I ",
				69687198,
				"Common/collective trusts "
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I ",
				55572768,
				"Common/collective trusts "
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I ",
				37050783,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I ",
				36876686,
				"Common/collective trusts "
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I ",
				21344029,
				"Common/collective trusts "
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I ",
				9166349,
				"Common/collective trusts "
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I ",
				284361,
				"Common/collective trusts "
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I ",
				74054107,
				"Common/collective trusts "
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust I ",
				79769299,
				"Common/collective trusts "
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust I ",
				74655620,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust I ",
				74054107,
				"Common/collective trusts "
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust I ",
				73075655,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust I ",
				69938294,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust I ",
				69687198,
				"Common/collective trusts "
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust I ",
				55572768,
				"Common/collective trusts "
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust I ",
				37050783,
				"Common/collective trusts "
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust I ",
				36876686,
				"Common/collective trusts "
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust I ",
				21344029,
				"Common/collective trusts "
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust I ",
				9166349,
				"Common/collective trusts "
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust I ",
				284361,
				"Common/collective trusts "
			]
		],
		"screen_results": {
			"fff": [
				60803310,
				38582108,
				0,
				38582108
			],
			"dff": [
				2141831,
				2439322,
				0,
				2439322
			],
			"gff": [
				655033,
				376679,
				0,
				376679
			],
			"pff": [
				11716153,
				5224284,
				0,
				5224284
			],
			"wff": [
				31497246,
				15463364,
				0,
				15463364
			],
			"tff": [
				3867725,
				2643096,
				0,
				2643096
			]
		}
	},
	"northwestern-university": {
		"path": "northwestern_university",
		"employer": "northwestern-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/07/2024",
		"participants": 25445,
		"short_name": "Northwestern University",
		"plan_short_name": "The Northwestern University Retirement Plan",
		"primary_plan_name": "Northwestern University Retirement Plan",
		"chart_plan_title": "Northwestern University\nRetirement Plan",
		"primary_plan_logo": "northwestern_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock LifePath Index series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Northwestern University Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Northwestern University Retirement Plan Form 5500 Filing and Attachment 2023",
				"northwestern-university-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3406904782,
		"plan_option_count": 39,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 790264021,
			"equity": 1550533026,
			"bond": 169069803,
			"other": 897037932,
			"sri": 63008054,
			"cref": 655756224,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Annuity",
				693035102,
				"Traditional annuities"
			],
			[
				"",
				"TIAA Real Estate",
				95655037,
				"Pooled separate account"
			],
			[
				"",
				"Vanguard Federal Money Mkt Inv",
				64698412,
				"Mutual fund"
			],
			[
				"",
				"CREF Money Market R3",
				28755015,
				"Variable annuity contract"
			],
			[
				"",
				"METLIFE Fixed",
				14894366,
				"Guaranteed income contract (GIC)"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Ttl Bd Mkt Idx Inst",
				52635065,
				"Mutual fund"
			],
			[
				"F00000MN7G",
				"Metropolitan W Tot Ret Bd Pln",
				45668412,
				"Mutual fund"
			],
			[
				"F00000MPYO",
				"Vanguard Short-Trm Bd Idx Inst",
				39958701,
				"Mutual fund"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				20527046,
				"Variable annuity contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				10280579,
				"Variable annuity contract"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				431113041,
				"Variable annuity contract"
			],
			[
				"FOUSA00GPG",
				"Vanguard Inst Idx Inst Plus",
				334959673,
				"Mutual fund"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Adm",
				200484092,
				"Mutual fund"
			],
			[
				"F00000JXVS",
				"Vanguard Extend Mk Idx Inst Pl",
				78871588,
				"Mutual fund"
			],
			[
				"F00000JTBV",
				"Vanguard Total Int St Ix IsPls",
				74658051,
				"Mutual fund"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				61491897,
				"Variable annuity contract"
			],
			[
				"F00000MNDY",
				"John Hancock Disciplnd Val R6",
				61349234,
				"Mutual fund"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				54443026,
				"Variable annuity contract",
				"sri"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Class R6",
				48110342,
				"Mutual fund"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				40088895,
				"Variable annuity contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				37811740,
				"Variable annuity contract"
			],
			[
				"F000002P1T",
				"American EuroPac Growth R6",
				37215843,
				"Mutual fund"
			],
			[
				"F00000JS7I",
				"MassMutual Mid Cap Growth I",
				25599610,
				"Mutual fund"
			],
			[
				"F000002PJ9",
				"American Funds New World R6",
				13571269,
				"Mutual fund"
			],
			[
				"F00000YK7W",
				"Fidelity Diversified Intl K6",
				13552001,
				"Mutual fund"
			],
			[
				"F00000PHFU",
				"Loomis Sayles Sm Cap Growth N",
				9416157,
				"Mutual fund"
			],
			[
				"F00000VYY8",
				"Goldman Sachs Sm Cap Val R6",
				9223537,
				"Mutual fund"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Idx Adm",
				8565028,
				"Mutual fund",
				"sri"
			],
			[
				"F00000XRY0",
				"Principal Real Estate Securities R6",
				6144487,
				"Mutual fund"
			],
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth R6",
				3863515,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPI",
				"BlackRock Lifepath Idx 2040 K",
				149948758,
				"Mutual fund"
			],
			[
				"F00000MAPH",
				"BlackRock Lifepath Idx 2045 K",
				130763889,
				"Mutual fund"
			],
			[
				"F00000MAPJ",
				"BlackRock Lifepath Idx 2035 K",
				118445428,
				"Mutual fund"
			],
			[
				"F00000MAPK",
				"BlackRock Lifepath Idx 2030 K",
				103913780,
				"Mutual fund"
			],
			[
				"F00000MAPG",
				"BlackRock Lifepath Idx 2050 K",
				89286254,
				"Mutual fund"
			],
			[
				"F00000MAOX",
				"BlackRock Lifepath Idx Ret K",
				85039476,
				"Mutual fund"
			],
			[
				"F00000MAPL",
				"BlackRock Lifepath Idx 2025 K",
				75445607,
				"Mutual fund"
			],
			[
				"F00000MAP0",
				"BlackRock Lifepath Idx 2055 K",
				31706437,
				"Mutual fund"
			],
			[
				"F00000WM8M",
				"BlackRock Lifepath Idx 2060 K",
				5714392,
				"Mutual fund"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock Lifepath Idx 2050 K",
				89286254,
				"Mutual fund"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				431113041,
				"Variable annuity contract"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				61491897,
				"Variable annuity contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				54443026,
				"Variable annuity contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				40088895,
				"Variable annuity contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				37811740,
				"Variable annuity contract"
			],
			[
				"STIAA00023",
				"CREF Core Bond R3",
				20527046,
				"Variable annuity contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				10280579,
				"Variable annuity contract"
			]
		],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				119366941,
				48691416,
				45383367,
				0
			],
			"dff": [
				4960605,
				2554643,
				2279178,
				0
			],
			"gff": [
				968786,
				424176,
				432822,
				0
			],
			"pff": [
				20420390,
				6277979,
				4624077,
				0
			],
			"wff": [
				60755431,
				18673360,
				20220400,
				0
			],
			"tff": [
				7347172,
				3071734,
				1960320,
				0
			]
		}
	},
	"northwestern-university-2": {
		"path": "northwestern_university_2",
		"employer": "northwestern-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/07/2024",
		"participants": 19021,
		"short_name": "Northwestern University",
		"plan_short_name": "The Northwestern University Voluntary Savings Plan",
		"primary_plan_name": "Northwestern University Voluntary Savings Plan",
		"chart_plan_title": "Northwestern University\nVoluntary Savings Plan",
		"primary_plan_logo": "northwestern_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock LifePath Index series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Northwestern University Voluntary Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Northwestern University Voluntary Savings Plan Form 5500 Filing and Attachment 2023",
				"northwestern-university-voluntary-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1070848159,
		"plan_option_count": 39,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 244513532,
			"equity": 505071729,
			"bond": 47897176,
			"other": 273365722,
			"sri": 25296093,
			"cref": 159078852,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Annuity",
				221647640,
				"Traditional annuities"
			],
			[
				"",
				"TIAA Real Estate",
				22905123,
				"Pooled separate account"
			],
			[
				"",
				"Vanguard Federal Money Mkt Inv",
				14500832,
				"Mutual fund"
			],
			[
				"",
				"CREF Money Market R3",
				10378022,
				"Variable annuity contract"
			],
			[
				"",
				"METLIFE Fixed",
				3934105,
				"Guaranteed income contract (GIC)"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Ttl Bd Mkt Idx Inst",
				16103642,
				"Mutual fund"
			],
			[
				"F00000MN7G",
				"Metropolitan W Tot Ret Bd Pin",
				12272491,
				"Mutual fund"
			],
			[
				"F00000MPYO",
				"Vanguard Short-Trm Bd Idx Inst",
				11932130,
				"Mutual fund"
			],
			[
				"STIAA00023",
				"CREF Core Bond 3",
				4933706,
				"Variable annuity contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				2655207,
				"Variable annuity contract"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Inst Idx Inst Plus",
				123340989,
				"Mutual fund"
			],
			[
				"STIAA00007",
				"CREF Stock R3",
				90456765,
				"Variable annuity contract"
			],
			[
				"FOUSA02TYD",
				"Vanguard PRIMECAP Adm",
				88850065,
				"Mutual fund"
			],
			[
				"F00000JTBV",
				"Vanguard Total Int St Ix IsPls",
				32576804,
				"Mutual fund"
			],
			[
				"F00000JXVS",
				"Vanguard Extend Mk Idx Inst Pl",
				24026993,
				"Mutual fund"
			],
			[
				"F00000MNDY",
				"John Hancock Disciplnd Val R6",
				22231855,
				"Mutual fund"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				19676200,
				"Variable annuity contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				18394381,
				"Variable annuity contract",
				"sri"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Class R6",
				13025365,
				"Mutual fund"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				12327725,
				"Variable annuity contract"
			],
			[
				"F000002P1T",
				"American EuroPac Growth R6",
				11839563,
				"Mutual fund"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				10634868,
				"Variable annuity contract"
			],
			[
				"F00000JS7I",
				"MassMutual Sel Mid Cap Gr Eq II I",
				9273460,
				"Mutual fund"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Idx Adm",
				6901712,
				"Mutual fund",
				"sri"
			],
			[
				"F00000YK7W",
				"Fidelity Diversified Intl K6",
				4709924,
				"Mutual fund"
			],
			[
				"F000002PJ9",
				"American Funds New World R6",
				4586917,
				"Mutual fund"
			],
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth R6",
				3675833,
				"Mutual fund"
			],
			[
				"F00000PHFU",
				"Loomis Sayles Sm Cap Growth N",
				3489984,
				"Mutual fund"
			],
			[
				"F00000MPYG",
				"Vanguard Small-Cap Val Idx Adm",
				3079006,
				"Mutual fund"
			],
			[
				"F00000XRY0",
				"Principal Real Estate Securities R6",
				1973320,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPI",
				"BlackRock Lifepath Idx 2040 K",
				39753179,
				"Mutual fund"
			],
			[
				"F00000MAPJ",
				"BlackRock Lifepath Idx 2035 K",
				39238031,
				"Mutual fund"
			],
			[
				"F00000MAPK",
				"BlackRock Lifepath Idx 2030 K",
				35696362,
				"Mutual fund"
			],
			[
				"F00000MAPH",
				"BlackRock Lifepath Idx 2045 K",
				31976343,
				"Mutual fund"
			],
			[
				"F00000MAOX",
				"BlackRock Lifepath Idx Ret K",
				29201855,
				"Mutual fund"
			],
			[
				"F00000MAPL",
				"BlackRock Lifepath Idx 2025 K",
				27581845,
				"Mutual fund"
			],
			[
				"F00000MAPG",
				"BlackRock Lifepath Idx 2050 K",
				22840580,
				"Mutual fund"
			],
			[
				"F00000MAP0",
				"BlackRock Lifepath Idx 2055 K",
				12016689,
				"Mutual fund"
			],
			[
				"F00000WM8M",
				"BlackRock Lifepath Idx 2060 K",
				6208648,
				"Mutual fund"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock Lifepath Idx 2050 K",
				22840580,
				"Mutual fund"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock R3",
				90456765,
				"Variable annuity contract"
			],
			[
				"STIAA00011",
				"CREF Growth R3",
				19676200,
				"Variable annuity contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice R3",
				18394381,
				"Variable annuity contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index R3",
				12327725,
				"Variable annuity contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities R3",
				10634868,
				"Variable annuity contract"
			],
			[
				"STIAA00023",
				"CREF Core Bond 3",
				4933706,
				"Variable annuity contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond R3",
				2655207,
				"Variable annuity contract"
			]
		],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				37536340,
				14570228,
				10225066,
				0
			],
			"dff": [
				1575019,
				761685,
				521173,
				0
			],
			"gff": [
				297320,
				126761,
				99466,
				0
			],
			"pff": [
				6894400,
				1875969,
				1058834,
				0
			],
			"wff": [
				19474108,
				5574071,
				4700725,
				0
			],
			"tff": [
				2460625,
				917383,
				440160,
				0
			]
		}
	},
	"nvidia": {
		"path": "nvidia",
		"employer": "nvidia",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 14581,
		"short_name": "Nvidia",
		"plan_short_name": "Nvidia's 401(k)",
		"primary_plan_name": "Nvidia Corporation 401(k) Plan",
		"chart_plan_title": "Nvidia Corporation 401(k) Plan",
		"primary_plan_logo": "nvidia",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Nvidia Corporation 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Nvidia Corporation 401(k) Plan Form 5500 Filing and Attachment 2023",
				"nvidia-corporation-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3065768865,
		"plan_option_count": 27,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1218739825,
			"equity": 1666542278,
			"bond": 102319382,
			"other": 78167380,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Management Trust Company Fidelity Managed Income Portfolio Class 4",
				76869606,
				"Collective Trusts"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				1297771,
				"Mutual Funds"
			],
			[
				"",
				"Fidelity Management Trust Company Fidelity Managed Income Portfolio Class 2",
				3,
				"Collective Trusts"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund",
				97377672,
				"Mutual Funds"
			],
			[
				"F00000T8Y7",
				"State Street U.S. Bond Index Securities Lending Series Fund",
				4941710,
				"Collective Trusts"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index TR Fund",
				518072230,
				"Collective Trusts"
			],
			[
				"FOUSA00CEO",
				"Fidelity Investments Contrafund",
				411495552,
				"Collective Trusts"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Fund",
				286185880,
				"Collective Trusts"
			],
			[
				"F00000JSDA",
				"JPMorgan U.S. Active Core Equity Fund",
				144886724,
				"Collective Trusts"
			],
			[
				"F00000WLTB",
				"Wasatch International Opps Investment Fund",
				93744274,
				"Collective Trusts"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity Income Admiral Fund",
				92029110,
				"Mutual Funds"
			],
			[
				"FOUSA00BNG",
				"Vanguard Strategic Equity Fund",
				63581156,
				"Mutual Funds"
			],
			[
				"FOUSA00KIR",
				"Vanguard Total International Stock Index Fund",
				56547081,
				"Collective Trusts"
			],
			[
				"FOUSA02UZS",
				"American Funds EuroPacific Growth Fund R5",
				271,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040 Trust Class C Fund",
				203058529,
				"Collective Trusts"
			],
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045 Trust Class C Fund",
				188745639,
				"Collective Trusts"
			],
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust Class C Fund",
				182537695,
				"Collective Trusts"
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055 Trust Class C Fund",
				164259213,
				"Collective Trusts"
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030 Trust Class C Fund",
				144613510,
				"Collective Trusts"
			],
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035 Trust Class C Fund",
				128380014,
				"Collective Trusts"
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060 Trust Class C Fund",
				90242093,
				"Collective Trusts"
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020 Trust Class C Fund",
				57709555,
				"Collective Trusts"
			],
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025 Trust Class C Fund",
				31736780,
				"Collective Trusts"
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065 Trust Class C Fund",
				16728963,
				"Collective Trusts"
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010 Trust Class C Fund",
				4171503,
				"Collective Trusts"
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005 Trust Class C Fund",
				3495022,
				"Collective Trusts"
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015 Trust Class C Fund",
				3061309,
				"Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust Class C Fund",
				182537695,
				"Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				160423547,
				112932351,
				0,
				0
			],
			"dff": [
				2996333,
				7782917,
				0,
				0
			],
			"gff": [
				4274173,
				1368471,
				0,
				0
			],
			"pff": [
				20753247,
				9914695,
				0,
				0
			],
			"wff": [
				67423615,
				49654872,
				0,
				0
			],
			"tff": [
				6189641,
				2552920,
				0,
				0
			]
		}
	},
	"oracle": {
		"path": "oracle",
		"employer": "oracle",
		"year": 2024,
		"updated": " April 2025",
		"filing_received": " 04/25/2025",
		"participants": 103417,
		"short_name": "Oracle",
		"plan_short_name": "Oracle's 401(k)",
		"primary_plan_name": "Oracle Corporation 401(k) Savings and Investment Plan",
		"chart_plan_title": "Oracle Corporation 401(k)\nSavings and Investment Plan",
		"primary_plan_logo": "oracle",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Oracle Corporation 401(k) Savings and Investment Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Oracle Corporation 401(k) Savings and Investment Plan Form 5500 Filing and Attachment 2024",
				"oracle-corporation-401k-savings-and-investment-plan-form-5500-filing-and-attachment-2024.pdf"
			]
		],
		"plan_assets": 28048270000,
		"plan_option_count": 31,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 6856078000,
			"equity": 16870254000,
			"bond": 1232792000,
			"other": 3089146000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 6856078000
		},
		"other_plan_options": [
			[
				"",
				"Oracle Corporation Common Stock Fund",
				1907147000,
				"Common Stock Fund"
			],
			[
				"",
				"Galliard Stable Value Fund",
				1181999000,
				"Separately Managed Account"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Institutional Total Bond Market Index Trust",
				735010000,
				"Common/Collective Trust"
			],
			[
				"",
				"Broad Market Bond I",
				456546000,
				"Common/Collective Trust"
			],
			[
				"F00000MISP",
				"PIMCO Inflation Response Multi‐Asset Fund Institutional",
				41236000,
				"Registered Investment Companies"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				4580197000,
				"Common/Collective Trust"
			],
			[
				"FOUSA06U0Z",
				"Fidelity Growth Company Commingled Pool—Class S",
				3611479000,
				"Common/Collective Trust"
			],
			[
				"FOUSA06TX6",
				"Fidelity Contrafund Commingled Pool—Class S",
				2752362000,
				"Common/Collective Trust"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				1125095000,
				"Registered Investment Companies"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced Fund—Class K",
				835275000,
				"Registered Investment Companies"
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust",
				785249000,
				"Common/Collective Trust"
			],
			[
				"F00000JTBU",
				"Vanguard Institutional Total International Stock Market Index Trust",
				723493000,
				"Common/Collective Trust"
			],
			[
				"FOUSA06TXR",
				"Fidelity Low‐Priced Stock Commingled Pool—Class O",
				566516000,
				"Common/Collective Trust"
			],
			[
				"FOUSA00C2O",
				"US Small Mid Cap Value Fund",
				550836000,
				"Separately Managed Account"
			],
			[
				"FOUSA08MX0",
				"Fidelity Worldwide Fund",
				397709000,
				"Registered Investment Companies"
			],
			[
				"FOUSA02TGA",
				"Dodge & Cox International Stock Fund",
				317618000,
				"Registered Investment Companies"
			],
			[
				"FOUSA04BJY",
				"William Blair Small Mid Cap Growth Separate Account",
				305265000,
				"Separately Managed Account"
			],
			[
				"FOUSA00E6B",
				"Emerging Markets Stock Fund",
				169051000,
				"Separately Managed Account"
			],
			[
				"FOUSA00K3X",
				"Artisan International Separate Account",
				150109000,
				"Separately Managed Account"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select",
				1052974000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select",
				1045528000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select",
				1027208000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select",
				861070000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				724773000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select",
				623468000,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select",
				571215000,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select",
				381099000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select",
				292479000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				151131000,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select",
				113668000,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select",
				11465000,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				724773000,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select",
				1052974000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select",
				1045528000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select",
				1027208000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select",
				861070000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select",
				724773000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select",
				623468000,
				"Common/Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select",
				571215000,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select",
				381099000,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select",
				292479000,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select",
				151131000,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select",
				113668000,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select",
				11465000,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				1227632812,
				456056709,
				0,
				456056709
			],
			"dff": [
				32591106,
				28817124,
				0,
				28817124
			],
			"gff": [
				10602757,
				4455285,
				0,
				4455285
			],
			"pff": [
				164585230,
				61786178,
				0,
				61786178
			],
			"wff": [
				551329192,
				182803150,
				0,
				182803150
			],
			"tff": [
				98623599,
				31248514,
				0,
				31248514
			]
		}
	},
	"oreilly-automotive": {
		"path": "oreilly_automotive",
		"employer": "oreilly-automotive",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/14/2024",
		"participants": 85057,
		"short_name": "O'Reilly Automotive",
		"plan_short_name": "O'Reilly Automotive's 401(k)",
		"primary_plan_name": "O'Reilly Automotive, Inc. Profit Sharing and Savings Plan",
		"chart_plan_title": "O'Reilly Automotive, Inc. Profit\nSharing and Savings Plan",
		"primary_plan_logo": "oreilly_automotive",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"O'Reilly Automotive, Inc. Profit Sharing and Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"O'Reilly Automotive, Inc. Profit Sharing and Savings Plan Form 5500 Filing and Attachment 2023",
				"oreilly-automotive-inc-profit-sharing-and-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1546045000,
		"plan_option_count": 30,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 895582000,
			"equity": 93692000,
			"bond": 31886000,
			"other": 524885000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"O’Reilly Automotive, Inc. common stock",
				518193000,
				"Registered investment company mutual funds"
			],
			[
				"",
				"T. Rowe Price Stable Value Common Trust Fund, N",
				3732000,
				"Common and collective trusts"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				2960000,
				"Registered investment company mutual funds"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA05C3V",
				"Vanguard Inflation-Protected Securities Fund, Admiral",
				15970000,
				"Registered investment company mutual funds"
			],
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				9935000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund Institutional Class",
				3942000,
				"Registered investment company mutual funds"
			],
			[
				"F00000LZX3",
				"Fidelity Total Bond Fund",
				2039000,
				"Registered investment company mutual funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				40704000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA00D2I",
				"Harbor Capital Appreciation Fund, R",
				10824000,
				"Common and collective trusts"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				8939000,
				"Registered investment company mutual funds"
			],
			[
				"F00000WZOY",
				"T. Rowe Price QM U.S. Small-Cap Growth Equity Fund",
				7033000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA00KWE",
				"T. Rowe Price Institutional Mid Cap Equity Growth",
				6355000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA00ID5",
				"JPMorgan Mid Cap Value Fund, L",
				5656000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA02TID",
				"Vanguard International Growth Fund",
				4754000,
				"Registered investment company mutual funds"
			],
			[
				"FOUSA00DTN",
				"BlackRock Equity Dividend Fund, I",
				4426000,
				"Registered investment company mutual funds"
			],
			[
				"F000002YE4",
				"American Beacon Small Cap Value Fund, Institutional",
				4022000,
				"Registered investment company mutual funds"
			],
			[
				"F00000XOSV",
				"Oakmark International Fund, I",
				979000,
				"Registered investment company mutual funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035 Trust, K",
				131682000,
				"Common and collective trusts"
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030 Trust, K",
				125481000,
				"Common and collective trusts"
			],
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040 Trust, K",
				111852000,
				"Common and collective trusts"
			],
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045 Trust, K",
				103634000,
				"Common and collective trusts"
			],
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025 Trust, K",
				102073000,
				"Common and collective trusts"
			],
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust, K",
				95883000,
				"Common and collective trusts"
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055 Trust, K",
				83199000,
				"Common and collective trusts"
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020 Trust, K",
				47908000,
				"Common and collective trusts"
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060 Trust, K",
				45918000,
				"Common and collective trusts"
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015 Trust, K",
				24301000,
				"Common and collective trusts"
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065 Trust, K",
				11684000,
				"Common and collective trusts"
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010 Trust, K",
				8788000,
				"Common and collective trusts"
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005 Trust, K",
				3179000,
				"Common and collective trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050 Trust, K",
				95883000,
				"Common and collective trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				6652256,
				76626967,
				0,
				0
			],
			"dff": [
				176424,
				5245509,
				0,
				0
			],
			"gff": [
				95879,
				948428,
				0,
				0
			],
			"pff": [
				1408729,
				6780971,
				0,
				0
			],
			"wff": [
				3728805,
				33636306,
				0,
				0
			],
			"tff": [
				366362,
				1767384,
				0,
				0
			]
		}
	},
	"palo-alto-networks": {
		"path": "palo_alto_networks",
		"employer": "palo-alto-networks",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/18/2023",
		"participants": 8298,
		"short_name": "Palo Alto Networks",
		"plan_short_name": "Palo Alto Networks's 401(k)",
		"primary_plan_name": "Palo Alto Networks, Inc. 401(k) Plan",
		"chart_plan_title": "Palo Alto Networks, Inc.\n401(k) Plan",
		"primary_plan_logo": "palo_alto_networks",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Index series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Palo Alto Networks, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Palo Alto Networks, Inc. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"palo-alto-networks-inc-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 642849216,
		"plan_option_count": 31,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 343199441,
			"equity": 265324564,
			"bond": 18312248,
			"other": 16012963,
			"sri": 2536585,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"T. Rowe Price Stable Value Fund",
				15826099,
				"Common Trust"
			],
			[
				"",
				"Fidelity Government Money Market Fund",
				186864,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00CFP",
				"Fidelity Investment Grade Bond Fund",
				9270446,
				"Mutual Fund"
			],
			[
				"FOUSA00H9T",
				"Metwest Total Return Bond Fund",
				9041802,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000YI8R",
				"Fidelity Contrafund K6",
				61746171,
				"Mutual Fund"
			],
			[
				"F00000MJS0",
				"Fidelity Total Market Index Fund",
				49687393,
				"Mutual Fund"
			],
			[
				"F00000YI8J",
				"Fidelity Blue Chip Growth K6",
				37525989,
				"Mutual Fund"
			],
			[
				"FOUSA00CID",
				"Fidelity OTC Portfolio Fund",
				27502149,
				"Mutual Fund"
			],
			[
				"FOUSA00BZK",
				"Fidelity Mid-Cap Stock Fund",
				12258752,
				"Mutual Fund"
			],
			[
				"FOUSA00CHY",
				"Fidelity Overseas Fund",
				10589394,
				"Mutual Fund"
			],
			[
				"FOUSA00CI3",
				"Fidelity Puritan Fund",
				9787830,
				"Mutual Fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				9508634,
				"Mutual Fund"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Administrative Fund",
				9132463,
				"Mutual Fund"
			],
			[
				"F00000SCG4",
				"Victory Sycamore Established Value Fund R6",
				8093249,
				"Mutual Fund"
			],
			[
				"F00000N6WT",
				"Diamond Hill Large Cap Y Fund",
				7427698,
				"Mutual Fund"
			],
			[
				"FOUSA00B74",
				"Fidelity International Capital Appreciation K6",
				7297147,
				"Mutual Fund"
			],
			[
				"FOUSA05B4X",
				"Fidelity Small Cap Value Fund",
				7164115,
				"Mutual Fund"
			],
			[
				"F00000TXPJ",
				"Cohen & Steers Real Estate Securities Z",
				5066995,
				"Mutual Fund"
			],
			[
				"F00000YJ0A",
				"Fidelity U.S. Sustainability Index Fund",
				2536585,
				"Mutual Fund",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"F0000154M5",
				"Fidelity Freedom Index 2040 Fund - Premier Class",
				65400003,
				"Mutual Fund"
			],
			[
				"F0000154M4",
				"Fidelity Freedom Index 2035 Fund - Premier Class",
				56084320,
				"Mutual Fund"
			],
			[
				"F0000154LV",
				"Fidelity Freedom Index 2045 Fund - Premier Class",
				55041759,
				"Mutual Fund"
			],
			[
				"F0000154LW",
				"Fidelity Freedom Index 2050 Fund - Premier Class",
				52177687,
				"Mutual Fund"
			],
			[
				"F0000154M6",
				"Fidelity Freedom Index 2055 Fund - Premier Class",
				37259149,
				"Mutual Fund"
			],
			[
				"F0000154M3",
				"Fidelity Freedom Index 2030 Fund - Premier Class",
				32160532,
				"Mutual Fund"
			],
			[
				"F0000154M2",
				"Fidelity Freedom Index 2025 Fund - Premier Class",
				19535170,
				"Mutual Fund"
			],
			[
				"F0000154M7",
				"Fidelity Freedom Index 2060 Fund - Premier Class",
				14812922,
				"Mutual Fund"
			],
			[
				"F0000154M1",
				"Fidelity Freedom Index 2020 Fund - Premier Class",
				4499537,
				"Mutual Fund"
			],
			[
				"F0000154M8",
				"Fidelity Freedom Index 2065 Fund - Premier Class",
				3444877,
				"Mutual Fund"
			],
			[
				"F0000154LX",
				"Fidelity Freedom Index Income Fund - Premier Class",
				1599903,
				"Mutual Fund"
			],
			[
				"F0000154M0",
				"Fidelity Freedom Index 2015 Fund - Premier Class",
				1183582,
				"Mutual Fund"
			]
		],
		"rated_as_option": [
			[
				"F0000154LW",
				"Fidelity Freedom Index 2050 Fund - Premier Class",
				52177687,
				"Mutual Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				18330234,
				25409638,
				0,
				0
			],
			"dff": [
				328286,
				1538316,
				0,
				0
			],
			"gff": [
				75542,
				209234,
				0,
				0
			],
			"pff": [
				2045490,
				3426107,
				0,
				0
			],
			"wff": [
				9638545,
				10285753,
				0,
				0
			],
			"tff": [
				620502,
				1805477,
				0,
				0
			]
		}
	},
	"petsmart": {
		"path": "petsmart",
		"employer": "petsmart",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 07/22/2024",
		"participants": 52167,
		"short_name": "PetSmart",
		"plan_short_name": "PetSmart's 401(k)",
		"primary_plan_name": "PetSmart, Inc. SaveSmart 401(k) Plan",
		"chart_plan_title": "PetSmart, Inc. SaveSmart\n401(k) Plan",
		"primary_plan_logo": "petsmart",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"PetSmart, Inc. SaveSmart 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"PetSmart, Inc. SaveSmart 401(k) Plan Form 5500 Filing and Attachment 2023",
				"petsmart-inc-savesmart-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 564003493,
		"plan_option_count": 23,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 327336852,
			"equity": 202467182,
			"bond": 18535115,
			"other": 15664344,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Managed Income Portfolio",
				15664344,
				"Common collective trust"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund",
				18535115,
				"Mutual fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00CEO",
				"Fidelity Contrafund Pool",
				81735686,
				"Common collective trust"
			],
			[
				"F00000LZSI",
				"Fidelity 500 Index FDInstitutional",
				41623881,
				"Mutual fund"
			],
			[
				"F00000SCG4",
				"Victory Sycamore Established Value R6",
				19549657,
				"Mutual fund"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity Income Fund Admiral Shares",
				17220946,
				"Mutual fund"
			],
			[
				"F00000ZJYS",
				"MFS Intl Diversification R6",
				14571924,
				"Mutual fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				13408975,
				"Mutual fund"
			],
			[
				"F00000WLFX",
				"Black Rock Advantage Small-Cap Core Fund Class K",
				10806133,
				"Mutual fund"
			],
			[
				"F00000MJRI",
				"Fidelity Global ex US Index Fund",
				3549980,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050",
				60833569,
				"Common collective trust"
			],
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040",
				57682115,
				"Common collective trust"
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030",
				46823372,
				"Common collective trust"
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055",
				44673810,
				"Common collective trust"
			],
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045",
				31681047,
				"Common collective trust"
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060",
				31124882,
				"Common collective trust"
			],
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035",
				19486978,
				"Common collective trust"
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020",
				14033976,
				"Common collective trust"
			],
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025",
				10861352,
				"Common collective trust"
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065",
				4474462,
				"Common collective trust"
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010",
				3866215,
				"Common collective trust"
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015",
				1110618,
				"Common collective trust"
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005",
				684456,
				"Common collective trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050",
				60833569,
				"Common collective trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				22706619,
				30188944,
				0,
				0
			],
			"dff": [
				474107,
				2078634,
				0,
				0
			],
			"gff": [
				207025,
				367218,
				0,
				0
			],
			"pff": [
				2142127,
				2654093,
				0,
				0
			],
			"wff": [
				8155733,
				13272309,
				0,
				0
			],
			"tff": [
				864448,
				684323,
				0,
				0
			]
		}
	},
	"pinterest": {
		"path": "pinterest",
		"employer": "pinterest",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/15/2024",
		"participants": 4171,
		"short_name": "Pinterest",
		"plan_short_name": "Pinterest's 401(k)",
		"primary_plan_name": "Pinterest 401(k) Plan",
		"chart_plan_title": "Pinterest 401(k) Plan",
		"primary_plan_logo": "pinterest",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Vanguard Brokerage",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Pinterest 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Pinterest 401(k) Plan Form 5500 Filing and Attachment 2023",
				"pinterest-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 407846172,
		"plan_option_count": 26,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 291499386,
			"equity": 104556600,
			"bond": 7024213,
			"other": 4765973,
			"sri": 3162643,
			"cref": 0,
			"vanguard_target": 291473819
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Federal Money Market Fund",
				4765973,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Total Bond Market Index Fund Inst'l",
				7024213,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index Fund",
				56805962,
				"Mutual Fund"
			],
			[
				"FOUSA00L5B",
				"Vanguard Developed Markets Index Fund",
				12932504,
				"Mutual Fund"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Fund Inst'l",
				11948043,
				"Mutual Fund"
			],
			[
				"F00000MMTN",
				"MFS Growth Equity Fund Class S",
				6973114,
				"Common/Collective Trust"
			],
			[
				"FOUSA05IBW",
				"Vanguard Emerging Markets Stock Index Fund",
				4379895,
				"Mutual Fund"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund",
				3162643,
				"Mutual Fund",
				"sri"
			],
			[
				"FOUSA04AXL",
				"BlackRock Equity Dividend Fund",
				2504939,
				"Mutual Fund"
			],
			[
				"F000002PIY",
				"American Funds New Perspective Fund",
				2227227,
				"Mutual Fund"
			],
			[
				"FOUSA04BEQ",
				"Vanguard Real Estate Index Fund",
				2199376,
				"Mutual Fund"
			],
			[
				"F00000X3MB",
				"Federated MDT Small Cap Core Fund",
				734906,
				"Mutual Fund"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund",
				687991,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust II",
				87084272,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				79111879,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust II",
				43060686,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust II",
				42306367,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust II",
				19701983,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust II",
				8943764,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust II",
				6664404,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust II",
				2492835,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust II",
				962259,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust II",
				658600,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust II",
				410912,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust II",
				75858,
				"Common/Collective Trust"
			],
			[
				"",
				"Vanguard Target Retirement Income and Growth Trust II",
				25567,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				79111879,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust II",
				87084272,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				79111879,
				"Common/Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust II",
				43060686,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust II",
				42306367,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust II",
				19701983,
				"Common/Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust II",
				8943764,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust II",
				6664404,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust II",
				2492835,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust II",
				962259,
				"Common/Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust II",
				658600,
				"Common/Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust II",
				410912,
				"Common/Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust II",
				75858,
				"Common/Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				8222948,
				23460096,
				0,
				23460096
			],
			"dff": [
				329525,
				1486345,
				0,
				1486345
			],
			"gff": [
				100278,
				228526,
				0,
				228526
			],
			"pff": [
				1468509,
				3170539,
				0,
				3170539
			],
			"wff": [
				3990987,
				9398937,
				0,
				9398937
			],
			"tff": [
				740721,
				1606036,
				0,
				1606036
			]
		}
	},
	"princeton-university": {
		"path": "princeton_university",
		"employer": "princeton-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/07/2024",
		"participants": 16578,
		"short_name": "Princeton University",
		"plan_short_name": "The Princeton University Retirement Plan",
		"primary_plan_name": "Princeton University Retirement Plan",
		"chart_plan_title": "Princeton University\nRetirement Plan",
		"primary_plan_logo": "princeton_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Princeton University Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Princeton University Retirement Plan Form 5500 Filing and Attachment 2023",
				"princeton-university-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 2126741370,
		"plan_option_count": 42,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 428230040,
			"equity": 1109695076,
			"bond": 98464340,
			"other": 490351914,
			"sri": 57783087,
			"cref": 668150383,
			"vanguard_target": 428230040
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Non Benefit Responsive - GRA",
				355822890,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"TIAA Real Estate Account",
				71280548,
				"Pooled Separate Account"
			],
			[
				"",
				"CREF Money Market Account",
				30559716,
				"Variable Annuity Contract"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				24660998,
				"Registered Investment Company"
			],
			[
				"",
				"TIAA Traditional Non Benefit Responsive - RC",
				6297663,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"TIAA Traditional Benefit Responsive - RCP",
				1730099,
				"Unallocated Insurance Contract"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00FQH",
				"Vanguard Total Bond Market Index Fund Investor Shares",
				38156879,
				"Registered Investment Company"
			],
			[
				"FOUSA06LDU",
				"BlackRock Total Return Bond T",
				23031494,
				"Registered Investment Company"
			],
			[
				"STIAA00023",
				"CREF Core Bond Account",
				22011882,
				"Variable Annuity Contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond Account",
				15264085,
				"Variable Annuity Contract"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF Stock Account",
				305675054,
				"Variable Annuity Contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities Account",
				111459155,
				"Variable Annuity Contract"
			],
			[
				"STIAA00011",
				"CREF Growth Account",
				90564186,
				"Variable Annuity Contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index Account",
				68965302,
				"Variable Annuity Contract"
			],
			[
				"FOUSA00FVS",
				"Vanguard Windsor II Fund Investor Shares",
				68932613,
				"Registered Investment Company"
			],
			[
				"FOUSA00FQU",
				"Vanguard Total Stock Market Index Fund Investor Shares",
				67718596,
				"Registered Investment Company"
			],
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index Fund",
				59904536,
				"Registered Investment Company"
			],
			[
				"FOUSA00FTH",
				"Vanguard PRIMECAP Fund Investor Shares",
				54717590,
				"Registered Investment Company"
			],
			[
				"STIAA00019",
				"CREF Social Choice Account",
				54210719,
				"Variable Annuity Contract",
				"sri"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund",
				53184070,
				"Registered Investment Company"
			],
			[
				"FOUSA00FVM",
				"Vanguard Wellington Fund Investor Shares",
				33241452,
				"Registered Investment Company"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Equity CL2",
				28710950,
				"Registered Investment Company"
			],
			[
				"FOUSA00FQR",
				"Vanguard Extended Market Index Fund Investor Shares",
				28147862,
				"Registered Investment Company"
			],
			[
				"FOUSA00FIG",
				"Vanguard International Value Fund",
				22855282,
				"Registered Investment Company"
			],
			[
				"FOUSA00FU3",
				"Vanguard International Growth Fund Investor Shares",
				21428378,
				"Registered Investment Company"
			],
			[
				"F00000UHR4",
				"Principal Small Cap Grwth I R6",
				16085265,
				"Registered Investment Company"
			],
			[
				"F00000MMWN",
				"Eagle Mid Cap Growth CIT C1",
				8192859,
				"Registered Investment Company"
			],
			[
				"F00000MPYG",
				"Vanguard Small-Cap Val Idx Adm",
				6494279,
				"Registered Investment Company"
			],
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth R6",
				5634560,
				"Registered Investment Company"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Adm",
				3572368,
				"Registered Investment Company",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				85361105,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				67103841,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				62867390,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				59726433,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				47802623,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				38838880,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				32243622,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				12604368,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				11738398,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				7616288,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				2263006,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Inv Fund",
				64086,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				67103841,
				"Registered Investment Company"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock Account",
				305675054,
				"Variable Annuity Contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities Account",
				111459155,
				"Variable Annuity Contract"
			],
			[
				"STIAA00011",
				"CREF Growth Account",
				90564186,
				"Variable Annuity Contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index Account",
				68965302,
				"Variable Annuity Contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice Account",
				54210719,
				"Variable Annuity Contract"
			],
			[
				"STIAA00023",
				"CREF Core Bond Account",
				22011882,
				"Variable Annuity Contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond Account",
				15264085,
				"Variable Annuity Contract"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				85361105,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				67103841,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				62867390,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				59726433,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				47802623,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				38838880,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				32243622,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				12604368,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				11738398,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				7616288,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				2263006,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Inv Fund",
				64086,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				80260701,
				29494335,
				43607470,
				29494335
			],
			"dff": [
				3818524,
				1865006,
				2272087,
				1865006
			],
			"gff": [
				1230851,
				287913,
				467709,
				287913
			],
			"pff": [
				12422615,
				3993241,
				4511468,
				3993241
			],
			"wff": [
				38991695,
				11820770,
				20033888,
				11820770
			],
			"tff": [
				3666652,
				2020441,
				1912135,
				2020441
			]
		}
	},
	"princeton-university-2": {
		"path": "princeton_university_2",
		"employer": "princeton-university",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/07/2024",
		"participants": 13601,
		"short_name": "Princeton University",
		"plan_short_name": "The Princeton University Retirement Savings Plan",
		"primary_plan_name": "Princeton University Retirement Savings Plan",
		"chart_plan_title": "Princeton University\nRetirement Savings Plan",
		"primary_plan_logo": "princeton_university",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Princeton University Retirement Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Princeton University Retirement Savings Plan Form 5500 Filing and Attachment 2023",
				"princeton-university-retirement-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1522536752,
		"plan_option_count": 43,
		"plan_option_sri_count": 2,
		"allocations": {
			"default": 323315556,
			"equity": 770565907,
			"bond": 77660778,
			"other": 350994511,
			"sri": 33950953,
			"cref": 382974135,
			"vanguard_target": 323315556
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Benefit Responsive - GSRA",
				189904435,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"TIAA Traditional Benefit Responsive - SRA",
				60228399,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"TIAA Real Estate Account",
				50186487,
				"Pooled Separate Account"
			],
			[
				"",
				"TIAA Traditional Non Benefit Responsive - RA",
				15901168,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"Vanguard Federal Money Mkt",
				15642630,
				"Registered Investment Company"
			],
			[
				"",
				"TIAA Traditional Benefit Responsive - RCP",
				12577094,
				"Unallocated Insurance Contract"
			],
			[
				"",
				"CREF Money market account",
				6554298,
				"Variable Annuity Contract"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00FQH",
				"Vanguard Total Bd Mkt Indx Inv",
				35772286,
				"Registered Investment Company"
			],
			[
				"FOUSA06LDU",
				"BlackRock Total Return K",
				18389074,
				"Registered Investment Company"
			],
			[
				"STIAA00023",
				"CREF Core bond account",
				12751512,
				"Variable Annuity Contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-linked bond account",
				10747906,
				"Variable Annuity Contract"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF Stock account",
				170903280,
				"Variable Annuity Contract"
			],
			[
				"FOUSA00FQU",
				"Vanguard Total Stock Mkt Inv",
				67441401,
				"Registered Investment Company"
			],
			[
				"STIAA00015",
				"CREF Global equities account",
				65289600,
				"Variable Annuity Contract"
			],
			[
				"FOUSA00FVS",
				"Vanguard Windsor II Fund Inv",
				52925076,
				"Registered Investment Company"
			],
			[
				"FOUSA00FR3",
				"Vanguard Inst Index Inst",
				50337850,
				"Registered Investment Company"
			],
			[
				"STIAA00011",
				"CREF Growth account",
				47702261,
				"Variable Annuity Contract"
			],
			[
				"FOUSA00FTH",
				"Vanguard PRIMECAP Fund Inv",
				45367640,
				"Registered Investment Company"
			],
			[
				"STIAA00003",
				"CREF Equity index account",
				45135711,
				"Variable Annuity Contract"
			],
			[
				"F00000JTBU",
				"Vanguard Total Int'l Stock Idx",
				39612425,
				"Registered Investment Company"
			],
			[
				"FOUSA00FVM",
				"Vanguard Wellington Inv",
				33395448,
				"Registered Investment Company"
			],
			[
				"STIAA00019",
				"CREF Social choice account",
				30443865,
				"Variable Annuity Contract",
				"sri"
			],
			[
				"FOUSA00FQR",
				"Vanguard Extend Mkt Index Inv",
				28207920,
				"Registered Investment Company"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Class R6",
				22842800,
				"Registered Investment Company"
			],
			[
				"FOUSA00FIG",
				"Vanguard Int'l Value Fund",
				20989963,
				"Registered Investment Company"
			],
			[
				"FOUSA00FU3",
				"Vanguard Int'l Growth Fund Inv",
				16617153,
				"Registered Investment Company"
			],
			[
				"F00000UHR4",
				"Principal Small Cap Grwth I R6",
				12572715,
				"Registered Investment Company"
			],
			[
				"F00000MMWN",
				"Carillon Eagle Mid Cap Grw R6",
				6403686,
				"Registered Investment Company"
			],
			[
				"F00000MPYG",
				"Vanguard Small-Cap Val Idx Adm",
				5744338,
				"Registered Investment Company"
			],
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth R6",
				5125687,
				"Registered Investment Company"
			],
			[
				"FOUSA02SNF",
				"Vanguard FTSE Social Index Inv",
				3507088,
				"Registered Investment Company",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Tgt Retirement 2045",
				53168757,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Tgt Retirement 2040",
				44707419,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Tgt Retirement 2035",
				44568783,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Tgt Retirement 2030",
				41723157,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retirement 2050",
				40520716,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Tgt Retirement 2025",
				32848029,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Tgt Retirement 2055",
				25993248,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Tgt Retirement 2020",
				15459791,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Inc",
				12373035,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Tgt Retirement 2060",
				9707932,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Tgt Retirement 2065",
				2137062,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Tgt Retirement 2070",
				107627,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retirement 2050",
				40520716,
				"Registered Investment Company"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock account",
				170903280,
				"Variable Annuity Contract"
			],
			[
				"STIAA00015",
				"CREF Global equities account",
				65289600,
				"Variable Annuity Contract"
			],
			[
				"STIAA00011",
				"CREF Growth account",
				47702261,
				"Variable Annuity Contract"
			],
			[
				"STIAA00003",
				"CREF Equity index account",
				45135711,
				"Variable Annuity Contract"
			],
			[
				"STIAA00019",
				"CREF Social choice account",
				30443865,
				"Variable Annuity Contract"
			],
			[
				"STIAA00023",
				"CREF Core bond account",
				12751512,
				"Variable Annuity Contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-linked bond account",
				10747906,
				"Variable Annuity Contract"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Tgt Retirement 2045",
				53168757,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Tgt Retirement 2040",
				44707419,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Tgt Retirement 2035",
				44568783,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZE",
				"Vanguard Tgt Retirement 2030",
				41723157,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retirement 2050",
				40520716,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Tgt Retirement 2025",
				32848029,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Tgt Retirement 2055",
				25993248,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Tgt Retirement 2020",
				15459791,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Inc",
				12373035,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Tgt Retirement 2060",
				9707932,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Tgt Retirement 2065",
				2137062,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Tgt Retirement 2070",
				107627,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				56279925,
				21269140,
				25164421,
				21269140
			],
			"dff": [
				2566072,
				1344550,
				1301214,
				1344550
			],
			"gff": [
				892288,
				207680,
				273997,
				207680
			],
			"pff": [
				9259175,
				2880330,
				2632067,
				2880330
			],
			"wff": [
				27541326,
				8524685,
				11490696,
				8524685
			],
			"tff": [
				2704091,
				1457120,
				1110837,
				1457120
			]
		}
	},
	"progressive": {
		"path": "progressive",
		"employer": "progressive",
		"year": 2023,
		"updated": " May 2024",
		"filing_received": " 05/21/2024",
		"participants": 63252,
		"short_name": "Progressive",
		"plan_short_name": "Progressive's 401(k)",
		"primary_plan_name": "The Progressive 401(k) Plan",
		"chart_plan_title": "The Progressive 401(k) Plan",
		"primary_plan_logo": "progressive",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"The Progressive 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"The Progressive 401(k) Plan Form 5500 Filing and Attachment 2023",
				"the-progressive-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 8764370164,
		"plan_option_count": 25,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 2952647133,
			"equity": 2346560170,
			"bond": 195419525,
			"other": 3269743336,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 2952647133
		},
		"other_plan_options": [
			[
				"",
				"The Progressive Corporation Common Shares",
				2903052491,
				""
			],
			[
				"",
				"Fidelity Managed Income Portfolio II Class 3",
				256133147,
				""
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				110532696,
				""
			],
			[
				"",
				"Fidelity Cash Reserves",
				25002,
				""
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Total Bond Market Fund Institutional Plus Shares",
				128924697,
				""
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund Institutional Class",
				66494828,
				""
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund Institutional Plus Shares",
				795482307,
				""
			],
			[
				"FOUSA00JGS",
				"Vanguard Growth Index Fund Institutional Shares",
				445521407,
				""
			],
			[
				"F00000JXVT",
				"Vanguard Mid-Cap Index Fund Institutional Plus Shares",
				351576920,
				""
			],
			[
				"F00000JXW4",
				"Vanguard Small Cap Index Fund Institutional Plus Shares",
				273548219,
				""
			],
			[
				"F00000YI8R",
				"Fidelity Diversified International Fund - Class K6",
				205247524,
				""
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Fund Institutional Shares",
				192291652,
				""
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund Institutional Shares",
				82892141,
				""
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund Investor Shares",
				477796202,
				""
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund Investor Shares",
				467054403,
				""
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund Investor Shares",
				464431922,
				""
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund Investor Shares",
				457623635,
				""
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund Investor Shares",
				337280023,
				""
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund Investor Shares",
				233285669,
				""
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund Investor Shares",
				222314372,
				""
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund Investor Shares",
				113774060,
				""
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund Investor Shares",
				79512663,
				""
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund Investor Shares",
				63479386,
				""
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund Investor Shares",
				33367442,
				""
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund Investor Shares",
				2727356,
				""
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund Investor Shares",
				337280023,
				""
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund Investor Shares",
				477796202,
				""
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund Investor Shares",
				467054403,
				""
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund Investor Shares",
				464431922,
				""
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund Investor Shares",
				457623635,
				""
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund Investor Shares",
				337280023,
				""
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund Investor Shares",
				233285669,
				""
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund Investor Shares",
				222314372,
				""
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund Investor Shares",
				113774060,
				""
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund Investor Shares",
				79512663,
				""
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund Investor Shares",
				63479386,
				""
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund Investor Shares",
				33367442,
				""
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund Investor Shares",
				2727356,
				""
			]
		],
		"screen_results": {
			"fff": [
				212848907,
				198121845,
				0,
				198121845
			],
			"dff": [
				6932959,
				12517180,
				0,
				12517180
			],
			"gff": [
				1931497,
				1935758,
				0,
				1935758
			],
			"pff": [
				40988782,
				26844661,
				0,
				26844661
			],
			"wff": [
				94641803,
				79415983,
				0,
				79415983
			],
			"tff": [
				10152636,
				13575693,
				0,
				13575693
			]
		}
	},
	"prologis": {
		"path": "prologis",
		"employer": "prologis",
		"year": 2023,
		"updated": " June 2024",
		"filing_received": " 06/07/2024",
		"participants": 2314,
		"short_name": "Prologis",
		"plan_short_name": "Prologis' 401(k)",
		"primary_plan_name": "Prologis 401(k) Savings Plan",
		"chart_plan_title": "Prologis 401(k) Savings Plan",
		"primary_plan_logo": "prologis",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Prologis 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Prologis 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"prologis-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 447196000,
		"plan_option_count": 29,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 140111000,
			"equity": 214674000,
			"bond": 16169000,
			"other": 76242000,
			"sri": 1786000,
			"cref": 0,
			"vanguard_target": 140111000
		},
		"other_plan_options": [
			[
				"",
				"Prologis common stock - approximately 400,000 shares",
				53443000,
				"Common stock"
			],
			[
				"",
				"Vanguard Treasury Money Market",
				19677000,
				"Mutual funds"
			],
			[
				"",
				"Fidelity Short-Term Bond",
				3122000,
				"Mutual funds"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index",
				10774000,
				"Mutual funds"
			],
			[
				"FOUSA02VB5",
				"Metropolitan West High Yield Bond",
				3465000,
				"Mutual funds"
			],
			[
				"FOUSA00G06",
				"PIMCO Real Return",
				1890000,
				"Mutual funds"
			],
			[
				"F00000NBIL",
				"Vanguard Total International Bond Index",
				40000,
				"Mutual funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				90918000,
				"Mutual funds"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index",
				41725000,
				"Mutual funds"
			],
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth",
				27327000,
				"Mutual funds"
			],
			[
				"F000002PIZ",
				"American Funds Washington Mutual",
				21500000,
				"Mutual funds"
			],
			[
				"FOUSA00K3X",
				"Artisan International Growth",
				10047000,
				"Common/collective investment trusts"
			],
			[
				"F00000WZVM",
				"Fidelity Total International Index",
				9916000,
				"Mutual funds"
			],
			[
				"F00000YDJB",
				"American Beacon Small Cap Value",
				7798000,
				"Mutual funds"
			],
			[
				"FOUSA00GII",
				"Cohen & Steers Global Realty",
				3288000,
				"Mutual funds"
			],
			[
				"FOUSA06BX6",
				"Impax Sustainable Allocation",
				1786000,
				"Mutual funds",
				"sri"
			],
			[
				"F00000Q5TH",
				"Baron Discovery Fund Institutional Shares",
				369000,
				"Mutual funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				25423000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				23093000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				17913000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				14932000,
				"Common/collective investment trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				14921000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				14812000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				13048000,
				"Common/collective investment trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				7164000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				4317000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				2602000,
				"Common/collective investment trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				1675000,
				"Common/collective investment trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				211000,
				"Common/collective investment trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				17913000,
				"Common/collective investment trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				25423000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				23093000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				17913000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				14932000,
				"Common/collective investment trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				14921000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				14812000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				13048000,
				"Common/collective investment trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				7164000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				4317000,
				"Common/collective investment trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				2602000,
				"Common/collective investment trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				1675000,
				"Common/collective investment trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				211000,
				"Common/collective investment trusts"
			]
		],
		"screen_results": {
			"fff": [
				15542982,
				9570022,
				0,
				9570022
			],
			"dff": [
				351705,
				605250,
				0,
				605250
			],
			"gff": [
				413079,
				93400,
				0,
				93400
			],
			"pff": [
				3071558,
				1295464,
				0,
				1295464
			],
			"wff": [
				8873881,
				3835350,
				0,
				3835350
			],
			"tff": [
				2665820,
				655531,
				0,
				655531
			]
		}
	},
	"qualcomm": {
		"path": "qualcomm",
		"employer": "qualcomm",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/16/2023",
		"participants": 22493,
		"short_name": "Qualcomm",
		"plan_short_name": "Qualcomm's 401(k)",
		"primary_plan_name": "Qualcomm Incorporated Employee Savings and Retirement Plan",
		"chart_plan_title": "Qualcomm Incorporated Employee\nSavings and Retirement Plan",
		"primary_plan_logo": "qualcomm",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Qualcomm Incorporated Employee Savings and Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Qualcomm Incorporated Employee Savings and Retirement Plan Form 5500 Filing and Attachment 2022",
				"qualcomm-incorporated-employee-savings-retirement-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 5821238169,
		"plan_option_count": 28,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1696988821,
			"equity": 3465749412,
			"bond": 337239178,
			"other": 321260758,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1696988821
		},
		"other_plan_options": [
			[
				"",
				"Synthetic Guaranteed Investment Contracts",
				303498695,
				"Separate Investment Trust"
			],
			[
				"",
				"Short-Term Investment Fund A S (formerly \"Wells Fargo/BlackRock Short Term Investment Fund (Class S)\")",
				16936869,
				"Collective Trust"
			],
			[
				"",
				"Noninterest-bearing cash",
				503577,
				"Cash"
			],
			[
				"",
				"Vanguard Federal Money Market Fund Investor",
				321617,
				"Mutual fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00H9T",
				"MetWest Total Return Bond Fund (Class B)",
				264788871,
				"Collective Trust"
			],
			[
				"FOUSA00DIL",
				"Vanguard Institutional Total Bond Market Index Trust",
				72450307,
				"Collective Trust"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				993199747,
				"Collective Trust"
			],
			[
				"FOUSA06TX6",
				"Fidelity® Contrafund® Commingled Pool",
				725571218,
				"Collective Trust"
			],
			[
				"FOUSA06TY5",
				"Fidelity® OTC Portfolio",
				718235959,
				"Collective Trust"
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust",
				295162304,
				"Collective Trust"
			],
			[
				"FOUSA009MW",
				"American Beacon Small Cap Value CIT Fund Class II",
				227249831,
				"Collective Trust"
			],
			[
				"FOUSA02T2O",
				"Vanguard Windsor™ II Fund Admiral™ Shares",
				181220416,
				"Mutual fund"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Fund Admiral Shares",
				140457265,
				"Mutual fund"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund® Class R-6",
				126663308,
				"Mutual fund"
			],
			[
				"F00000JTBU",
				"Vanguard Institutional Total International Stock Market Index Trust",
				47497793,
				"Collective Trust"
			],
			[
				"F00000PA0N",
				"DFA World ex US Core Equity Portfolio",
				10491571,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				352162621,
				"Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				342334631,
				"Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				245005879,
				"Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				177043933,
				"Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				151454663,
				"Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				128269081,
				"Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				99533431,
				"Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				88677005,
				"Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				59835515,
				"Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				38907092,
				"Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				13472646,
				"Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				292324,
				"Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				128269081,
				"Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				352162621,
				"Collective Trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				342334631,
				"Collective Trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				245005879,
				"Collective Trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				177043933,
				"Collective Trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				151454663,
				"Collective Trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				128269081,
				"Collective Trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				99533431,
				"Collective Trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				88677005,
				"Collective Trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				59835515,
				"Collective Trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				38907092,
				"Collective Trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				13472646,
				"Collective Trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				292324,
				"Collective Trust"
			]
		],
		"screen_results": {
			"fff": [
				276210322,
				109544685,
				0,
				109544685
			],
			"dff": [
				3674256,
				6924728,
				0,
				6924728
			],
			"gff": [
				4252898,
				1069681,
				0,
				1069681
			],
			"pff": [
				35111582,
				14835367,
				0,
				14835367
			],
			"wff": [
				120948801,
				43905881,
				0,
				43905881
			],
			"tff": [
				9965456,
				7504853,
				0,
				7504853
			]
		}
	},
	"quanta-services": {
		"path": "quanta_services",
		"employer": "quanta-services",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/11/2024",
		"participants": 37773,
		"short_name": "Quanta Services",
		"plan_short_name": "Quanta Services' 401(k)",
		"primary_plan_name": "Quanta Services, Inc. 401(k) Savings Plan",
		"chart_plan_title": "Quanta Services, Inc.\n401(k) Savings Plan",
		"primary_plan_logo": "quanta_services",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Blend series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Quanta Services, Inc. 401(k) Savings Plan",
			"Nova Shimmick 401(k)",
			"Vector Force 401(k)"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Quanta Services, Inc. 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"quanta-services-inc-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1729902315,
		"plan_option_count": 31,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 812326267,
			"equity": 740330938,
			"bond": 94056678,
			"other": 83188432,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Managed Income Portfolio Fund",
				39398805,
				"Common/Collective Trust Funds"
			],
			[
				"",
				"Fidelity Investments Money Market Government Portfolio Fund",
				36871265,
				"Money Market Fund"
			],
			[
				"",
				"Fidelity Managed Income II Portfolio Fund",
				6918362,
				"Common/Collective Trust Funds"
			]
		],
		"bond_plan_options": [
			[
				"F00000YK7Y",
				"Fidelity Total Bond Fund",
				70451504,
				"Mutual Funds"
			],
			[
				"FOUSA02SMJ",
				"Vanguard GNMA Admiral Fund",
				23605174,
				"Mutual Funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000JSGY",
				"JJPMorgan Large Cap Growth Fund",
				145296960,
				"Mutual Funds"
			],
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				130058085,
				"Mutual Funds"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock Fund",
				104723907,
				"Mutual Funds"
			],
			[
				"F00000YK7W",
				"Fidelity Diversified International Fund",
				83138230,
				"Mutual Funds"
			],
			[
				"FOUSA00JGS",
				"Vanguard Growth Index Institutional Fund",
				83093344,
				"Mutual Funds"
			],
			[
				"FOUSA06TXR",
				"Fidelity Low Priced Stock Fund",
				41335278,
				"Mutual Funds"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund ",
				38037946,
				"Mutual Funds"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth Fund",
				35998793,
				"Mutual Funds"
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Institutional Fund",
				30991154,
				"Mutual Funds"
			],
			[
				"F00000YDJB",
				"American Beacon Small Cap Value Fund",
				26186365,
				"Mutual Funds"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced Fund",
				15608014,
				"Mutual Funds"
			],
			[
				"FOUSA00B1V",
				"Dimensional Fund Advisors International Small Cap Value Fund",
				5862862,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"F000010OKR",
				"Fidelity Freedom Blend 2040 Commingled Pool",
				146556789,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OK9",
				"Fidelity Freedom Blend 2030 Commingled Pool",
				128884345,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OFI",
				"Fidelity Freedom Blend 2050 Commingled Pool",
				118430214,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OKI",
				"Fidelity Freedom Blend 2035 Commingled Pool",
				74825544,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OF5",
				"Fidelity Freedom Blend 2045 Commingled Pool",
				72877597,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OFR",
				"Fidelity Freedom Blend 2055 Commingled Pool",
				68108078,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OFV",
				"Fidelity Freedom Blend 2060 Commingled Pool",
				57541333,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OJR",
				"Fidelity Freedom Blend 2020 Commingled Pool",
				55064202,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OK0",
				"Fidelity Freedom Blend 2025 Commingled Pool",
				46822339,
				"Common/Collective Trust Funds"
			],
			[
				"F000013DJ9",
				"Fidelity Freedom Blend 2065 Commingled Pool",
				23533497,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OGE",
				"Fidelity Freedom Blend 2010 Commingled Pool",
				11711718,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OEU",
				"Fidelity Freedom Blend Income Commingled Pool",
				3770099,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OJI",
				"Fidelity Freedom Blend 2015 Commingled Pool",
				3034188,
				"Common/Collective Trust Funds"
			],
			[
				"F000010OG5",
				"Fidelity Freedom Blend 2005 Commingled Pool",
				1166324,
				"Common/Collective Trust Funds"
			]
		],
		"rated_as_option": [
			[
				"F000010OFI",
				"Fidelity Freedom Blend 2050 Commingled Pool",
				118430214,
				"Common/Collective Trust Funds"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				47515067,
				55693007,
				0,
				0
			],
			"dff": [
				1514728,
				2217440,
				0,
				0
			],
			"gff": [
				467703,
				533356,
				0,
				0
			],
			"pff": [
				10336310,
				6391567,
				0,
				0
			],
			"wff": [
				31648348,
				36761009,
				0,
				0
			],
			"tff": [
				4598997,
				3510587,
				0,
				0
			]
		}
	},
	"regeneron-pharmaceuticals": {
		"path": "regeneron_pharmaceuticals",
		"employer": "regeneron-pharmaceuticals",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/20/2024",
		"participants": 11675,
		"short_name": "Regeneron Pharmaceuticals",
		"plan_short_name": "Regeneron Pharmaceuticals' 401(k)",
		"primary_plan_name": "Regeneron Pharmaceuticals, Inc. 401(k) Savings Plan",
		"chart_plan_title": "Regeneron Pharmaceuticals, Inc.\n401(k) Savings Plan",
		"primary_plan_logo": "regeneron_pharmaceuticals",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Regeneron Pharmaceuticals, Inc. 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Regeneron Pharmaceuticals, Inc. 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"regeneron-pharmaceuticals-inc-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 2183034269,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 727595836,
			"equity": 690336208,
			"bond": 57087565,
			"other": 708014660,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 727595836
		},
		"other_plan_options": [
			[
				"",
				"Regeneron Pharmaceuticals, Inc. Common Stock",
				660289551,
				"Common Stock"
			],
			[
				"",
				"Morley Capital Management Stable Value Fund",
				28972720,
				"Collective Trusts"
			],
			[
				"",
				"Fidelity Money Market Fund",
				18752389,
				"Mutual Funds"
			]
		],
		"bond_plan_options": [
			[
				"F00000MN7G",
				"Metropolitan West Funds Total Return Bond Fund Plan Class",
				31443468,
				"Mutual Funds"
			],
			[
				"FOUSA02TYI",
				"Vanguard Total Bond Market Index Fund Admiral",
				25644097,
				"Mutual Funds"
			]
		],
		"equity_plan_options": [
			[
				"F00000JSGY",
				"JPMorgan Large Cap Growth Fund Class R6",
				202640115,
				"Collective Trusts"
			],
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index Fund Institutional",
				185509504,
				"Mutual Funds"
			],
			[
				"F00000MNDY",
				"John Hancock Disciplined Value Fund Class R6",
				60936814,
				"Mutual Funds"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund Class R-6",
				48426529,
				"Mutual Funds"
			],
			[
				"FOUSA00LB6",
				"Vanguard Extended Market Index Fund Admiral",
				47783375,
				"Mutual Funds"
			],
			[
				"F000002PJF",
				"American Funds Small Cap World Fund Class R-6",
				42795877,
				"Mutual Funds"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Fund Class R6",
				33820550,
				"Mutual Funds"
			],
			[
				"F00000JTEF",
				"Vanguard Total International Stock Index Fund",
				28993034,
				"Mutual Funds"
			],
			[
				"FOUSA00DUZ",
				"Delaware Funds by Macquarie Small Cap Value Fund Institutional",
				21531565,
				"Mutual Funds"
			],
			[
				"F00000WZOY",
				"T. Rowe Price QM U.S. Small-Cap Growth I",
				17898845,
				"Mutual Funds"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust II",
				116389179,
				"Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust II",
				107920860,
				"Collective Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				100673665,
				"Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust II",
				98504195,
				"Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust II",
				94425702,
				"Collective Trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust II",
				77046963,
				"Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust II",
				62124157,
				"Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust II",
				41312175,
				"Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust II",
				14095283,
				"Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust II",
				10468527,
				"Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust II",
				4635130,
				"Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				100673665,
				"Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust II",
				116389179,
				"Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust II",
				107920860,
				"Collective Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust II",
				100673665,
				"Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust II",
				98504195,
				"Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust II",
				94425702,
				"Collective Trusts"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust II",
				77046963,
				"Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust II",
				62124157,
				"Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust II",
				41312175,
				"Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust II",
				14095283,
				"Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust II",
				10468527,
				"Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust II",
				4635130,
				"Collective Trusts"
			]
		],
		"screen_results": {
			"fff": [
				49213382,
				51965569,
				0,
				51965569
			],
			"dff": [
				1177096,
				3285858,
				0,
				3285858
			],
			"gff": [
				328531,
				507279,
				0,
				507279
			],
			"pff": [
				9238609,
				7035751,
				0,
				7035751
			],
			"wff": [
				29485254,
				20826889,
				0,
				20826889
			],
			"tff": [
				7643974,
				3559804,
				0,
				3559804
			]
		}
	},
	"sap-america": {
		"path": "sap_america",
		"employer": "sap-america",
		"year": 2022,
		"updated": " September 2023",
		"filing_received": " 09/25/2023",
		"participants": 27026,
		"short_name": "SAP America",
		"plan_short_name": "SAP America's 401(k)",
		"primary_plan_name": "SAP America, Inc. 401(k) Plan",
		"chart_plan_title": "SAP America, Inc. 401(k) Plan",
		"primary_plan_logo": "sap_america",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"SAP America, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"SAP America, Inc. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"sap-america-inc-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 6212383771,
		"plan_option_count": 34,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1188645293,
			"equity": 4145231378,
			"bond": 460887606,
			"other": 417619494,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1188645293
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust III",
				354238632,
				"Common collective trust"
			],
			[
				"",
				"SAP ADR Stock Fund",
				58641511,
				"American depository receipts"
			],
			[
				"",
				"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
				4739351,
				"Interest-bearing cash account"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Institutional Total Bond Market Index Trust",
				347561345,
				"Common collective trust"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund",
				43961075,
				"Registered investment company"
			],
			[
				"FOUSA00H9T",
				"Metropolitan West Total Return Bond Fund: Class I Shares",
				33026190,
				"Registered investment company"
			],
			[
				"FOUSA02VWI",
				"Federated Inst. High Yield Bond Fund",
				27759527,
				"Registered investment company"
			],
			[
				"F00000NB39",
				"PGIM Global Total Return; Class R6",
				8579469,
				"Registered investment company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA02T18",
				"Vanguard Wellington",
				1376347516,
				"Registered investment company"
			],
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				975078851,
				"Common collective trust"
			],
			[
				"F00000JTBU",
				"Vanguard Institutional Total International Stock Market Index Trust",
				359718273,
				"Common collective trust"
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust",
				311140926,
				"Common collective trust"
			],
			[
				"FOUSA02VN6",
				"T.Rowe Price Blue Chip Growth Trust; Class T4",
				259700776,
				"Common collective trust"
			],
			[
				"FOUSA02T2O",
				"Vanguard Windsor II",
				190703402,
				"Registered investment company"
			],
			[
				"FOUSA02TID",
				"Vanguard International Growth",
				179115423,
				"Registered investment company"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer",
				138023540,
				"Registered investment company"
			],
			[
				"FOUSA00CSM",
				"Vanguard Global Equity",
				129171939,
				"Registered investment company"
			],
			[
				"FOUSA00GQ5",
				"Vanguard Small-Cap Index",
				91334246,
				"Registered investment company"
			],
			[
				"FOUSA00P1W",
				"Vanguard Emerging Markets Stock Index",
				47690270,
				"Registered investment company"
			],
			[
				"F00000Q0L5",
				"Allspring Special Mid Cap Value Fund; Class R6",
				41212858,
				"Registered investment company"
			],
			[
				"FOUSA00L29",
				"BR MidCap Growth Equity T",
				29070105,
				"Common collective trust"
			],
			[
				"F00000J8KQ",
				"Allspring SP Small Cap Value E",
				16923253,
				"Common collective trust"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				225716057,
				"Common collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				198623604,
				"Common collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				181539729,
				"Common collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				135149147,
				"Common collective trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				130945881,
				"Common collective trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				103491123,
				"Common collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				67349178,
				"Common collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				61636962,
				"Common collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				39252149,
				"Common collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				33505180,
				"Common collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				10682354,
				"Common collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				753929,
				"Common collective trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				103491123,
				"Common collective trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035",
				225716057,
				"Common collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030",
				198623604,
				"Common collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040",
				181539729,
				"Common collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025",
				135149147,
				"Common collective trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045",
				130945881,
				"Common collective trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050",
				103491123,
				"Common collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055",
				67349178,
				"Common collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020",
				61636962,
				"Common collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				39252149,
				"Common collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060",
				33505180,
				"Common collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065",
				10682354,
				"Common collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070",
				753929,
				"Common collective trust"
			]
		],
		"screen_results": {
			"fff": [
				277228466,
				75482311,
				0,
				75482311
			],
			"dff": [
				8142218,
				4766877,
				0,
				4766877
			],
			"gff": [
				3212619,
				737841,
				0,
				737841
			],
			"pff": [
				36509729,
				10231546,
				0,
				10231546
			],
			"wff": [
				121903734,
				30259044,
				0,
				30259044
			],
			"tff": [
				26392757,
				5172926,
				0,
				5172926
			]
		}
	},
	"state-farm": {
		"path": "state_farm",
		"employer": "state-farm",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/12/2024",
		"participants": 96717,
		"short_name": "State Farm",
		"plan_short_name": "State Farm's 401(k)",
		"primary_plan_name": "State Farm 401(k) Savings Plan",
		"chart_plan_title": "State Farm 401(k)\nSavings Plan",
		"primary_plan_logo": "state_farm",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"State Farm 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"State Farm 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"state-farm-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 16761091075,
		"plan_option_count": 20,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 3990059502,
			"equity": 9988186316,
			"bond": 2281290206,
			"other": 501555051,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 3978635408
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust II Common",
				496827485,
				"Collective Trust Portfolio"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				4727566,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Institutional Total Bond Market Index Trust Common",
				1502732612,
				"Collective Trust Portfolio"
			],
			[
				"F00000MPYP",
				"Vanguard Short-Term Bond Index Fund",
				778557594,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Employee Benefit Index Fund Common",
				9696940196,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA00LB6",
				"Vanguard Institutional Extended Market Index Trust Common",
				185883155,
				"Collective Trust Portfolio"
			],
			[
				"F00000JTEF",
				"Vanguard Institutional Total International Stock Market Index Trust Common",
				105362965,
				"Collective Trust Portfolio"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select Common",
				676621329,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select Common",
				580099956,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select Common",
				576265628,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select Common",
				441663117,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select Common",
				439606191,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select Common",
				365517312,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select Common",
				280984712,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select Common",
				269175265,
				"Collective Trust Portfolio"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select Common",
				199719304,
				"Collective Trust Portfolio"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select Common",
				111893842,
				"Collective Trust Portfolio"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select Common",
				33690452,
				"Collective Trust Portfolio"
			],
			[
				"",
				"Vanguard Target Retirement Income and Growth Trust Select Common",
				11424094,
				"Collective Trust Portfolio"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select Common",
				3398300,
				"Collective Trust Portfolio"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select Common",
				441663117,
				"Collective Trust Portfolio"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Select Common",
				676621329,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Select Common",
				580099956,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Select Common",
				576265628,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Select Common",
				441663117,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Select Common",
				439606191,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Select Common",
				365517312,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Select Common",
				280984712,
				"Collective Trust Portfolio"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Select Common",
				269175265,
				"Collective Trust Portfolio"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Select Common",
				199719304,
				"Collective Trust Portfolio"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Select Common",
				111893842,
				"Collective Trust Portfolio"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Select Common",
				33690452,
				"Collective Trust Portfolio"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Select Common",
				3398300,
				"Collective Trust Portfolio"
			]
		],
		"screen_results": {
			"fff": [
				845353093,
				242821317,
				0,
				242821317
			],
			"dff": [
				18429536,
				15340804,
				0,
				15340804
			],
			"gff": [
				13733756,
				2372571,
				0,
				2372571
			],
			"pff": [
				185660241,
				32902141,
				0,
				32902141
			],
			"wff": [
				355988632,
				97334039,
				0,
				97334039
			],
			"tff": [
				75939468,
				16638750,
				0,
				16638750
			]
		}
	},
	"stryker": {
		"path": "stryker",
		"employer": "stryker",
		"year": 2023,
		"updated": " September 2024",
		"filing_received": " 09/30/2024",
		"participants": 33563,
		"short_name": "Stryker",
		"plan_short_name": "Stryker's 401(k)",
		"primary_plan_name": "Stryker Corporation 401(k) Savings and Retirement Plan",
		"chart_plan_title": "Stryker Corporation 401(k)\nSavings and Retirement Plan",
		"primary_plan_logo": "stryker",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Stryker Corporation 401(k) Savings and Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Stryker Corporation 401(k) Savings and Retirement Plan Form 5500 Filing and Attachment 2023",
				"stryker-corporation-401k-savings-and-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 5328567317,
		"plan_option_count": 25,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 2793153494,
			"equity": 2032520503,
			"bond": 293850035,
			"other": 209043285,
			"sri": 17291460,
			"cref": 0,
			"vanguard_target": 2792922607
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
				209043285,
				"Registered investment company"
			]
		],
		"bond_plan_options": [
			[
				"F000004494",
				"Vanguard Total Bond Mkt InstP",
				219750412,
				"Common/collective trust"
			],
			[
				"FOUSA00H6E",
				"Vanguard Short-Term Invest-Gr Inst",
				45738105,
				"Registered investment company"
			],
			[
				"FOUSA00G06",
				"Pimco Real Return Fund – Inst",
				28361518,
				"Registered investment company"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"Vanguard Inst 500 Index Trust",
				783821869,
				"Common/collective trust"
			],
			[
				"FOUSA00CEO",
				"Fidelity Contrafund Commingled Pool",
				314754562,
				"Common/collective trust"
			],
			[
				"F00000JXW4",
				"Vanguard Small-Cap Index InstP",
				279575400,
				"Registered investment company"
			],
			[
				"FOUSA00KIR",
				"Vanguard Inst Total Int’l Stk Mkt Index",
				219238247,
				"Common/collective trust"
			],
			[
				"FOUSA00J83",
				"Vanguard Mid-Cap Index Fund Ins",
				164261350,
				"Registered investment company"
			],
			[
				"FOUSA00L7S",
				"Vanguard Balanced Index Fund Inst",
				130552063,
				"Registered investment company"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund; Class R-6",
				123025552,
				"Registered investment company"
			],
			[
				"FOUSA02SNF",
				"Vanguard FTSE Social Index Ins",
				17291460,
				"Registered investment company",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Tgt Retire 2045 Tr Sel",
				682314445,
				"Common/collective trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retire 2050 Tr Sel",
				412545212,
				"Common/collective trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Tgt Retire 2035 Tr Sel",
				397222889,
				"Common/collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Tgt Retire 2055 Tr Sel",
				352285748,
				"Common/collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Tgt Retire 2040 Tr Sel",
				278805003,
				"Common/collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Tgt Retire 2030 Tr Sel",
				203734075,
				"Common/collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Tgt Retire 2025 Tr Sel",
				176472462,
				"Common/collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Tgt Retire 2060 Tr Sel",
				168278846,
				"Common/collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Tgt Retire 2020 Tr Sel",
				51906204,
				"Common/collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Tgt Retire Income Tr Sel",
				37044983,
				"Common/collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Tgt Retire 2065 Tr Sel",
				31821723,
				"Common/collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Tgt Retire 2070 Tr Sel",
				491017,
				"Common/collective trust"
			],
			[
				"",
				"Vanguard Tgt Retire Income & Gr Tr Sel",
				230887,
				"Common/collective trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retire 2050 Tr Sel",
				412545212,
				"Common/collective trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Tgt Retire 2045 Tr Sel",
				682314445,
				"Common/collective trust"
			],
			[
				"FOUSA05HZH",
				"Vanguard Tgt Retire 2050 Tr Sel",
				412545212,
				"Common/collective trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Tgt Retire 2035 Tr Sel",
				397222889,
				"Common/collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Tgt Retire 2055 Tr Sel",
				352285748,
				"Common/collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Tgt Retire 2040 Tr Sel",
				278805003,
				"Common/collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Tgt Retire 2030 Tr Sel",
				203734075,
				"Common/collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Tgt Retire 2025 Tr Sel",
				176472462,
				"Common/collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Tgt Retire 2060 Tr Sel",
				168278846,
				"Common/collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Tgt Retire 2020 Tr Sel",
				51906204,
				"Common/collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Tgt Retire Income Tr Sel",
				37044983,
				"Common/collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Tgt Retire 2065 Tr Sel",
				31821723,
				"Common/collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Tgt Retire 2070 Tr Sel",
				491017,
				"Common/collective trust"
			]
		],
		"screen_results": {
			"fff": [
				193274990,
				199541584,
				0,
				199541584
			],
			"dff": [
				7135183,
				12625879,
				0,
				12625879
			],
			"gff": [
				1416490,
				1946466,
				0,
				1946466
			],
			"pff": [
				30349397,
				26999518,
				0,
				26999518
			],
			"wff": [
				86906054,
				79962648,
				0,
				79962648
			],
			"tff": [
				9477666,
				13666139,
				0,
				13666139
			]
		}
	},
	"sutter-health": {
		"path": "sutter_health",
		"employer": "sutter-health",
		"year": 2023,
		"updated": " Setember 2024",
		"filing_received": " 09/20/2024",
		"participants": 69618,
		"short_name": "Sutter Health",
		"plan_short_name": "Sutter Health's 403(b)",
		"primary_plan_name": "Sutter Health 403(b) Savings Plan",
		"chart_plan_title": "Sutter Health 403(b)\nSavings Plan",
		"primary_plan_logo": "sutter_health",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Blend series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Sutter Health 403(b) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Sutter Health 403(b) Savings Plan Form 5500 Filing 2023",
				"sutter-health-403b-savings-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 6394084707,
		"plan_option_count": 31,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 4513287686,
			"equity": 1533162680,
			"bond": 110379616,
			"other": 237254725,
			"sri": 66061768,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Investments Money Market Funds Government Portfolio Inst",
				217837687,
				"Registered investment companies"
			],
			[
				"",
				"Baird Asset Management Baird Short-Term Bond IS",
				19417038,
				"Registered investment companies"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income",
				49155408,
				"Registered investment companies"
			],
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index",
				47988149,
				"Registered investment companies"
			],
			[
				"F00000NZ8Q",
				"Fidelity Inflation-Protected Bond Index",
				13236059,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				586119819,
				"Registered investment companies"
			],
			[
				"FOUSA04BCR",
				"T. Rowe Price Institutional Large Cap Core Growth",
				260942144,
				"Registered investment companies"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced K",
				165892560,
				"Registered investment companies"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index",
				134302669,
				"Registered investment companies"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock",
				95963661,
				"Registered investment companies"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth K6",
				69242824,
				"Registered investment companies"
			],
			[
				"FOUSA05HGA",
				"Parnassus Core Equity Inst",
				66061768,
				"Registered investment companies",
				"sri"
			],
			[
				"F00000MJRI",
				"Fidelity Global ex US Index",
				41653845,
				"Registered investment companies"
			],
			[
				"F000002P1T",
				"American Funds Europacific Growth R6",
				41578335,
				"Registered investment companies"
			],
			[
				"FOUSA00CLE",
				"Northern Small Cap Value",
				27138885,
				"Registered investment companies"
			],
			[
				"FOUSA00CXH",
				"Lazard Emerging Markets Equity Inst",
				25795790,
				"Registered investment companies"
			],
			[
				"FOUSA00IMT",
				"Cohen & Steers Real Estate Securities Inst",
				18470380,
				"Registered investment companies"
			]
		],
		"default_plan_options": [
			[
				"F000010OKH",
				"Fidelity Freedom Blend 2035 PR",
				761500826,
				"Registered investment companies"
			],
			[
				"F000010OKQ",
				"Fidelity Freedom Blend 2040 PR",
				687607058,
				"Registered investment companies"
			],
			[
				"F000010OK8",
				"Fidelity Freedom Blend 2030 PR",
				657114034,
				"Registered investment companies"
			],
			[
				"F000010OF4",
				"Fidelity Freedom Blend 2045 PR",
				636112253,
				"Registered investment companies"
			],
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				521815317,
				"Registered investment companies"
			],
			[
				"F000010OJZ",
				"Fidelity Freedom Blend 2025 PR",
				500378450,
				"Registered investment companies"
			],
			[
				"F000010OFS",
				"Fidelity Freedom Blend 2055 PR",
				275263919,
				"Registered investment companies"
			],
			[
				"F000010OJQ",
				"Fidelity Freedom Blend 2020 PR",
				231635436,
				"Registered investment companies"
			],
			[
				"F000010OFU",
				"Fidelity Freedom Blend 2060 PR",
				98709576,
				"Registered investment companies"
			],
			[
				"F000010OJH",
				"Fidelity Freedom Blend 2015 PR",
				75092106,
				"Registered investment companies"
			],
			[
				"F000010OGD",
				"Fidelity Freedom Blend 2010 PR",
				24877789,
				"Registered investment companies"
			],
			[
				"F000010OET",
				"Fidelity Freedom Blend Income PR",
				18985303,
				"Registered investment companies"
			],
			[
				"F000013DJA",
				"Fidelity Freedom Blend 2065 PR",
				15946397,
				"Registered investment companies"
			],
			[
				"F000010OG4",
				"Fidelity Freedom Blend 2005 PR",
				8249222,
				"Registered investment companies"
			]
		],
		"rated_as_option": [
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				521815317,
				"Registered investment companies"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				89877360,
				299293194,
				0,
				0
			],
			"dff": [
				2198232,
				11931497,
				0,
				0
			],
			"gff": [
				1143266,
				2861644,
				0,
				0
			],
			"pff": [
				19382580,
				34295154,
				0,
				0
			],
			"wff": [
				51923102,
				197543216,
				0,
				0
			],
			"tff": [
				5950367,
				18864137,
				0,
				0
			]
		}
	},
	"sutter-health-2": {
		"path": "sutter_health_2",
		"employer": "sutter-health",
		"year": 2023,
		"updated": " Setember 2024",
		"filing_received": " 09/20/2024",
		"participants": 14533,
		"short_name": "Sutter Health",
		"plan_short_name": "The Sutter Health Retirement Income Plan",
		"primary_plan_name": "Sutter Health Retirement Income Plan",
		"chart_plan_title": "Sutter Health Retirement\nIncome Plan",
		"primary_plan_logo": "sutter_health",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Blend series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Sutter Health Retirement Income Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Sutter Health Retirement Income Plan Form 5500 Filing 2023",
				"sutter-health-retirement-income-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 703376073,
		"plan_option_count": 31,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 561749185,
			"equity": 114183431,
			"bond": 7951913,
			"other": 19491544,
			"sri": 3190938,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Investments Money Market Funds Government Portfolio Inst",
				18412922,
				"Registered investment companies"
			],
			[
				"",
				"Baird Short Term Bond IS",
				1078622,
				"Registered investment companies"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income",
				4045568,
				"Registered investment companies"
			],
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index",
				3152662,
				"Registered investment companies"
			],
			[
				"F00000NZ8Q",
				"Fidelity Inflation-Protected Bond Index",
				753683,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				35083974,
				"Registered investment companies"
			],
			[
				"FOUSA04BCR",
				"T. Rowe Price Institutional Large Cap Core Growth",
				30468889,
				"Registered investment companies"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced K",
				11174693,
				"Registered investment companies"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock",
				10755984,
				"Registered investment companies"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index",
				10660964,
				"Registered investment companies"
			],
			[
				"F000002P1T",
				"American Funds Europacific Growth R6",
				5118023,
				"Registered investment companies"
			],
			[
				"FOUSA05HGA",
				"Parnassus Core Equity Inst",
				3190938,
				"Registered investment companies",
				"sri"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth PR",
				2799577,
				"Registered investment companies"
			],
			[
				"F00000MJRI",
				"Fidelity Global ex US Index",
				1946455,
				"Registered investment companies"
			],
			[
				"FOUSA00CLE",
				"Northern Small Cap Value",
				1524714,
				"Registered investment companies"
			],
			[
				"FOUSA00IMT",
				"Cohen & Steers Real Estate Securities Inst",
				766126,
				"Registered investment companies"
			],
			[
				"FOUSA00CXH",
				"Lazard Emerging Markets Equity Inst",
				693094,
				"Registered investment companies"
			]
		],
		"default_plan_options": [
			[
				"F000010OF4",
				"Fidelity Freedom Blend 2045 PR",
				90792027,
				"Registered investment companies"
			],
			[
				"F000010OKQ",
				"Fidelity Freedom Blend 2040 PR",
				90594196,
				"Registered investment companies"
			],
			[
				"F000010OK8",
				"Fidelity Freedom Blend 2030 PR",
				87499192,
				"Registered investment companies"
			],
			[
				"F000010OKH",
				"Fidelity Freedom Blend 2035 PR",
				81589502,
				"Registered investment companies"
			],
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				70330298,
				"Registered investment companies"
			],
			[
				"F000010OJZ",
				"Fidelity Freedom Blend 2025 PR",
				47052431,
				"Registered investment companies"
			],
			[
				"F000010OFS",
				"Fidelity Freedom Blend 2055 PR",
				36712637,
				"Registered investment companies"
			],
			[
				"F000010OJQ",
				"Fidelity Freedom Blend 2020 PR",
				31177864,
				"Registered investment companies"
			],
			[
				"F000010OFU",
				"Fidelity Freedom Blend 2060 PR",
				13195611,
				"Registered investment companies"
			],
			[
				"F000010OJH",
				"Fidelity Freedom Blend 2015 PR",
				7294243,
				"Registered investment companies"
			],
			[
				"F000010OGD",
				"Fidelity Freedom Blend 2010 PR",
				2601843,
				"Registered investment companies"
			],
			[
				"F000013DJA",
				"Fidelity Freedom Blend 2065 PR",
				1648782,
				"Registered investment companies"
			],
			[
				"F000010OET",
				"Fidelity Freedom Blend Income PR",
				931663,
				"Registered investment companies"
			],
			[
				"F000010OG4",
				"Fidelity Freedom Blend 2005 PR",
				328896,
				"Registered investment companies"
			]
		],
		"rated_as_option": [
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				70330298,
				"Registered investment companies"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				6133178,
				38025461,
				0,
				0
			],
			"dff": [
				133174,
				1515081,
				0,
				0
			],
			"gff": [
				71892,
				363896,
				0,
				0
			],
			"pff": [
				1406682,
				4360712,
				0,
				0
			],
			"wff": [
				3906600,
				25097710,
				0,
				0
			],
			"tff": [
				376254,
				2396931,
				0,
				0
			]
		}
	},
	"sutter-health-3": {
		"path": "sutter_health_3",
		"employer": "sutter-health",
		"year": 2023,
		"updated": " Setember 2024",
		"filing_received": " 09/20/2024",
		"participants": 4596,
		"short_name": "Sutter Health",
		"plan_short_name": "The Sutter Health 401(K) Savings Plan",
		"primary_plan_name": "Sutter Health 401(K) Savings Plan",
		"chart_plan_title": "Sutter Health 401(K)\nSavings Plan",
		"primary_plan_logo": "sutter_health",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Blend series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Sutter Health 401(K) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Sutter Health 401(K) Savings Plan Form 5500 Filing 2023",
				"sutter-health-401k-savings-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 166262365,
		"plan_option_count": 33,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 57811488,
			"equity": 82828658,
			"bond": 5110616,
			"other": 20511603,
			"sri": 2737440,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Investments Money Market Funds Government Portfolio Inst",
				19549487,
				"Registered investment companies"
			],
			[
				"",
				"Baird SH TM Bond IS",
				938831,
				"Registered investment companies"
			],
			[
				"",
				"Variable Annuity Life Insurance Company Fixed Account Plus",
				22417,
				"Investment contracts"
			],
			[
				"",
				"Variable Annuity Life Insurance Company Short Term Fixed Account",
				868,
				"Investment contracts"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income X",
				2788903,
				"Registered investment companies"
			],
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index",
				1929634,
				"Registered investment companies"
			],
			[
				"F00000NZ8Q",
				"Fidelity Inflation-Prot Bd Index",
				392079,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index",
				26758414,
				"Registered investment companies"
			],
			[
				"FOUSA04BCR",
				"T. Rowe Price Institutional Large Cap Core Growth",
				18260388,
				"Registered investment companies"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced K",
				9954125,
				"Registered investment companies"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index",
				9180698,
				"Registered investment companies"
			],
			[
				"FOUSA00C3O",
				"Dodge & Cox Stock X",
				5118690,
				"Registered investment companies"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth K6",
				2848973,
				"Registered investment companies"
			],
			[
				"FOUSA05HGA",
				"Parnassus Equity Inc Inst",
				2737440,
				"Registered investment companies",
				"sri"
			],
			[
				"F00000MJRI",
				"Fidelity Global ex US Index",
				2519203,
				"Registered investment companies"
			],
			[
				"FOUSA00CLE",
				"Northern Small Cap Value",
				2109881,
				"Registered investment companies"
			],
			[
				"F000002P1T",
				"American Funds Europacific Growth R6",
				1893221,
				"Registered investment companies"
			],
			[
				"FOUSA00CXH",
				"Lazard Emerging Markets Equity Inst",
				867407,
				"Registered investment companies"
			],
			[
				"FOUSA00IMT",
				"Cohen & Steers Real Estate Securities Inst",
				580218,
				"Registered investment companies"
			]
		],
		"default_plan_options": [
			[
				"F000010OK8",
				"Fidelity Freedom Blend 2030 PR",
				11307460,
				"Registered investment companies"
			],
			[
				"F000010OKH",
				"Fidelity Freedom Blend 2035 PR",
				10145159,
				"Registered investment companies"
			],
			[
				"F000010OJZ",
				"Fidelity Freedom Blend 2025 PR",
				8554108,
				"Registered investment companies"
			],
			[
				"F000010OKQ",
				"Fidelity Freedom Blend 2040 PR",
				8190498,
				"Registered investment companies"
			],
			[
				"F000010OF4",
				"Fidelity Freedom Blend 2045 PR",
				6182186,
				"Registered investment companies"
			],
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				4037780,
				"Registered investment companies"
			],
			[
				"F000010OJQ",
				"Fidelity Freedom Blend 2020 PR",
				3885630,
				"Registered investment companies"
			],
			[
				"F000010OFS",
				"Fidelity Freedom Blend 2055 PR",
				1909203,
				"Registered investment companies"
			],
			[
				"F000010OJH",
				"Fidelity Freedom Blend 2015 PR",
				1788575,
				"Registered investment companies"
			],
			[
				"F000010OFU",
				"Fidelity Freedom Blend 2060 PR",
				588728,
				"Registered investment companies"
			],
			[
				"F000010OET",
				"Fidelity Freedom Blend Income PR",
				569697,
				"Registered investment companies"
			],
			[
				"F000010OGD",
				"Fidelity Freedom Blend 2010 PR",
				484772,
				"Registered investment companies"
			],
			[
				"F000013DJA",
				"Fidelity Freedom Blend 2065 PR",
				97850,
				"Registered investment companies"
			],
			[
				"F000010OG4",
				"Fidelity Freedom Blend 2005 PR",
				69842,
				"Registered investment companies"
			]
		],
		"rated_as_option": [
			[
				"F000010OFJ",
				"Fidelity Freedom Blend 2050 PR",
				4037780,
				"Registered investment companies"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				4631965,
				3566751,
				0,
				0
			],
			"dff": [
				106927,
				142491,
				0,
				0
			],
			"gff": [
				57616,
				33978,
				0,
				0
			],
			"pff": [
				951560,
				407420,
				0,
				0
			],
			"wff": [
				2735770,
				2354414,
				0,
				0
			],
			"tff": [
				276974,
				224726,
				0,
				0
			]
		}
	},
	"t-mobile-usa": {
		"path": "t_mobile_usa",
		"employer": "t-mobile-usa",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/01/2024",
		"participants": 99687,
		"short_name": "T-Mobile USA",
		"plan_short_name": "T-Mobile USA's 401(k)",
		"primary_plan_name": "T-Mobile USA, Inc. 401(k) Retirement Savings Plan & Trust",
		"chart_plan_title": "T-Mobile USA, Inc. 401(k) Retirement\nSavings Plan & Trust",
		"primary_plan_logo": "t_mobile_usa",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"T-Mobile USA, Inc. 401(k) Retirement Savings Plan & Trust"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"T-Mobile USA, Inc. 401(k) Retirement Savings Plan & Trust Form 5500 Filing and Attachment 2023",
				"t-mobile-usa-inc-401k-retirement-savings-plan-trust-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 7900239088,
		"plan_option_count": 32,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 4074809316,
			"equity": 3197204190,
			"bond": 263461742,
			"other": 364763840,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"T. Rowe Price Stable Value",
				361763882,
				"Collective Trust Fund"
			],
			[
				"",
				"Vanguard Treasury Money Market",
				2999958,
				"Money Market Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00CZR",
				"Loomis Sayles Core Plus Fixed Income",
				123467070,
				"Collective Trust Fund"
			],
			[
				"FOUSA02TYI",
				"Vanguard Inst. Total Bond Market Index",
				72593540,
				"Collective Trust Fund"
			],
			[
				"FOUSA05C3V",
				"Vanguard Inflation-Protected Securities",
				37246537,
				"Mutual Fund"
			],
			[
				"FOUSA06SN8",
				"Neuberger Berman High Income",
				30154595,
				"Collective Trust Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index",
				994267702,
				"Collective Trust Fund"
			],
			[
				"F00000U3BB",
				"AB Global Core Equity",
				549330711,
				"Collective Trust Fund"
			],
			[
				"F000014VHI",
				"T. Rowe Price Growth Stock",
				470443703,
				"Collective Trust Fund"
			],
			[
				"F00000WTNQ",
				"Vanguard Inst. Extended Market Index",
				231326550,
				"Collective Trust Fund"
			],
			[
				"FOUSA05C7A",
				"AMG TimesSquare Mid Cap Growth",
				150684081,
				"Collective Trust Fund"
			],
			[
				"FOUSA00EIV",
				"T. Rowe Price Equity Income",
				140050934,
				"Collective Trust Fund"
			],
			[
				"F000011IZ6",
				"Global All Cap Equity Index",
				137236112,
				"Collective Trust Fund"
			],
			[
				"F00000VWMW",
				"T. Rowe Price U.S. Mid-Cap Value Equity",
				135665385,
				"Collective Trust Fund"
			],
			[
				"",
				"Conestoga Small Cap Growth",
				113466575,
				"Collective Trust Fund"
			],
			[
				"FOUSA00L5B",
				"Vanguard Developed Markets Index",
				102153004,
				"Mutual Fund"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth",
				80712260,
				"Mutual Fund"
			],
			[
				"FOUSA02TGA",
				"Dodge & Cox International Stock",
				52494616,
				"Mutual Fund"
			],
			[
				"FOUSA05JIX",
				"Westwood Quality SmallCap",
				39372557,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA02VND",
				"T. Rowe Price Retirement 2040",
				1242720191,
				"Collective Trust Fund"
			],
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050",
				832697722,
				"Collective Trust Fund"
			],
			[
				"FOUSA02VNC",
				"T. Rowe Price Retirement 2030",
				728985237,
				"Collective Trust Fund"
			],
			[
				"FOUSA0565C",
				"T. Rowe Price Retirement 2035",
				354263900,
				"Collective Trust Fund"
			],
			[
				"F00000SZHW",
				"T. Rowe Price Retirement 2060",
				207580547,
				"Collective Trust Fund"
			],
			[
				"FOUSA05C00",
				"T. Rowe Price Retirement 2045",
				200688570,
				"Collective Trust Fund"
			],
			[
				"FOUSA0565B",
				"T. Rowe Price Retirement 2025",
				184869002,
				"Collective Trust Fund"
			],
			[
				"FOUSA02VNB",
				"T. Rowe Price Retirement 2020",
				131658388,
				"Collective Trust Fund"
			],
			[
				"FOUSA068A1",
				"T. Rowe Price Retirement 2055",
				110888793,
				"Collective Trust Fund"
			],
			[
				"F0000155P4",
				"T. Rowe Price Retirement 2065",
				34426786,
				"Collective Trust Fund"
			],
			[
				"FOUSA02VNA",
				"T. Rowe Price Retirement 2010",
				22354073,
				"Collective Trust Fund"
			],
			[
				"FOUSA05659",
				"T. Rowe Price Retirement 2005",
				20913296,
				"Collective Trust Fund"
			],
			[
				"FOUSA0565A",
				"T. Rowe Price Retirement 2015",
				2762811,
				"Collective Trust Fund"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A0",
				"T. Rowe Price Retirement 2050",
				832697722,
				"Collective Trust Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				203704908,
				364745486,
				0,
				0
			],
			"dff": [
				10891190,
				25081909,
				0,
				0
			],
			"gff": [
				1688013,
				4443658,
				0,
				0
			],
			"pff": [
				45413680,
				32115289,
				0,
				0
			],
			"wff": [
				109673124,
				160324646,
				0,
				0
			],
			"tff": [
				13659707,
				8302555,
				0,
				0
			]
		}
	},
	"take-two-interactive-software": {
		"path": "take_two_interactive_software",
		"employer": "take-two-interactive-software",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/10/2023",
		"participants": 4595,
		"short_name": "Take-Two Interactive Software",
		"plan_short_name": "Take-Two Interactive Software's 401(k)",
		"primary_plan_name": "Take-Two Interactive Software, Inc. 401(k) Plan",
		"chart_plan_title": "Take-Two Interactive Software,\nInc. 401(k) Plan",
		"primary_plan_logo": "take_two_interactive_software",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Index series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Take-Two Interactive Software, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Take-Two Interactive Software, Inc. 401(k) Plan Form 5500 Filing and Attachment 2022",
				"take-two-interactive-software-inc-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 453741159,
		"plan_option_count": 30,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 278116662,
			"equity": 151252128,
			"bond": 12921172,
			"other": 11451197,
			"sri": 1885516,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Managed Income II - CL 2",
				11215124,
				"Common collective trust"
			],
			[
				"",
				"Fidelity Government Money Market Fund - Premium Class",
				236073,
				"Mutual fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund Inst",
				6544128,
				"Mutual fund"
			],
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund Institutional Shares",
				6377044,
				"Mutual fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00FR3",
				"Vanguard Institutional Index Fund",
				57016337,
				"Mutual fund"
			],
			[
				"FOUSA00CJE",
				"Fidelity Select Technology",
				20831928,
				"Mutual fund"
			],
			[
				"FOUSA00GQ5",
				"Vanguard Small Cap Index Inst",
				16101385,
				"Mutual fund"
			],
			[
				"FOUSA00EI7",
				"T. Rowe Price Blue Chip Growth Fund",
				11250834,
				"Mutual fund"
			],
			[
				"FOUSA00KIR",
				"Vanguard Total Intl Stock Index",
				7934022,
				"Mutual fund"
			],
			[
				"FOUSA00ID5",
				"JP Morgan Mid Cap Value L",
				7703726,
				"Mutual fund"
			],
			[
				"FOUSA05HQN",
				"MFS Value Fund Class R6",
				7597621,
				"Mutual fund"
			],
			[
				"F00000ZJYS",
				"MFS International Diversification Fund R6",
				6313257,
				"Mutual fund"
			],
			[
				"FOUSA02TYE",
				"Vanguard REIT Index",
				5582042,
				"Mutual fund"
			],
			[
				"F00000NB29",
				"Invesco Developing Markets R6",
				4864643,
				"Mutual fund"
			],
			[
				"F00000VWN0",
				"T. Rowe Price Small Cap Stock I",
				4170817,
				"Mutual fund"
			],
			[
				"FOUSA007GA",
				"Calvert US Large-Cap Core Responsible Index Fund (I)",
				1885516,
				"Mutual fund",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"F00000VQAF",
				"Fidelity Freedom Index 2045 Fund Institutional Premium Class",
				61594258,
				"Mutual fund"
			],
			[
				"F00000VQAG",
				"Fidelity Freedom Index 2050 Fund Institutional Premium Class",
				52946841,
				"Mutual fund"
			],
			[
				"F00000VQAE",
				"Fidelity Freedom Index 2040 Fund Institutional Premium Class",
				49731601,
				"Mutual fund"
			],
			[
				"F00000VQAD",
				"Fidelity Freedom Index 2035 Fund Institutional Premium Class",
				37938935,
				"Mutual fund"
			],
			[
				"F00000VQ8F",
				"Fidelity Freedom Index 2055 Fund Institutional Premium Class",
				34017619,
				"Mutual fund"
			],
			[
				"F00000VQAC",
				"Fidelity Freedom Index 2030 Fund Institutional Premium Class",
				18131885,
				"Mutual fund"
			],
			[
				"F00000VQ8G",
				"Fidelity Freedom Index 2060 Fund Institutional Premium Class",
				13326410,
				"Mutual fund"
			],
			[
				"F00000VQAB",
				"Fidelity Freedom Index 2025 Fund Institutional Premium Class",
				6141469,
				"Mutual fund"
			],
			[
				"F000013DKQ",
				"Fidelity Freedom Index 2065 Fund Institutional Premium Class",
				1962130,
				"Mutual fund"
			],
			[
				"F00000VQAA",
				"Fidelity Freedom Index 2020 Fund Institutional Premium Class",
				1429808,
				"Mutual fund"
			],
			[
				"F00000VQA7",
				"Fidelity Freedom Index 2005 Fund Institutional Premium Class",
				350248,
				"Mutual fund"
			],
			[
				"F00000VQA9",
				"Fidelity Freedom Index 2015 Fund Institutional Premium Class",
				330109,
				"Mutual fund"
			],
			[
				"F00000VQAH",
				"Fidelity Freedom Index Income Fund Institutional Premium Class",
				175309,
				"Mutual fund"
			],
			[
				"F00000VQA8",
				"Fidelity Freedom Index 2010 Fund Institutional Premium Class",
				40040,
				"Mutual fund"
			]
		],
		"rated_as_option": [
			[
				"F00000VQAG",
				"Fidelity Freedom Index 2050 Fund Institutional Premium Class",
				52946841,
				"Mutual fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				10561015,
				21528412,
				0,
				0
			],
			"dff": [
				392517,
				1303366,
				0,
				0
			],
			"gff": [
				181466,
				177270,
				0,
				0
			],
			"pff": [
				2125252,
				2902738,
				0,
				0
			],
			"wff": [
				5171480,
				8714618,
				0,
				0
			],
			"tff": [
				565071,
				1529690,
				0,
				0
			]
		}
	},
	"target": {
		"path": "target",
		"employer": "target",
		"year": 2022,
		"updated": " October 2023",
		"filing_received": " 10/06/2023",
		"participants": 460507,
		"short_name": "Target",
		"plan_short_name": "Target's 401(k)",
		"primary_plan_name": "Target Corporation 401(k) Master Trust",
		"chart_plan_title": "Target Corporation 401(k)\nMaster Trust",
		"primary_plan_logo": "target",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "BlackRock",
		"default_fund_manager_path": "blackrock",
		"default_fund_name": "BlackRock LifePath Index series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Target Corporation 401(k) Master Trust",
			"Target Corporation 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Target Corporation 401(k) Master Trust Form 5500 Filing 2022",
				"target-corporation-401k-master-trust-form-5500-filing-2022.pdf"
			],
			[
				"Target Corporation 401(k) Plan Form 5500 Filing 2022",
				"target-corporation-401k-plan-form-5500-filing-2022.pdf"
			],
			[
				"Target Corporation 401(k) Summary Plan Description 2022",
				"target-corporation-401k-summary-plan-description-2022.pdf"
			],
			[
				"Target Corporation 401(k) Annual Fee Disclosure 2022",
				"target-corporation-401k-annual-fee-disclosure-2022.pdf"
			]
		],
		"plan_assets": 11008557248,
		"plan_option_count": 20,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 4116461366,
			"equity": 3881006044,
			"bond": 799576746,
			"other": 2211513092,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"State Street Bank & Trust Company - SSGA TARGET CORPORATION COMMON STOCK FUND",
				1851991011,
				"Common Stock Funds"
			],
			[
				"",
				"State Street Bank & Trust Company - STATE STR BK TR CO INVT MUTUAL FUND",
				323456109,
				"Cash & Cash Equivalents"
			],
			[
				"",
				"State Street Bank & Trust Company - SSGA SHORT TERM INVESTMENT FUND",
				35511464,
				"Cash & Cash Equivalents"
			],
			[
				"",
				"US DOLLAR",
				554508,
				"Cash & Cash Equivalents"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA069X0",
				"State Street Bank & Trust Company - STATE STR BK + TR CO INVT FDS MUTUAL FUND",
				443759776,
				"Common Collective Trusts"
			],
			[
				"FOUSA06B89",
				"State Street Bank & Trust Company - STATE STR BK + TR CO INVT FDS TREASURY INFLATION PROTECTED S",
				355816970,
				"Common Collective Trusts"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00L8W",
				"State Street Bank & Trust Company - SSGA S+P 500 INDEX SER A S+P 500 FLAGSHIP NON LENDING",
				1967182886,
				"Common Collective Trusts"
			],
			[
				"F00000VV1D",
				"State Street Bank & Trust Company - SSGA RUSS SM/MD CAP INDX SER A RUSSELL SMALL CAP COMPLETENESS",
				804454015,
				"Common Collective Trusts"
			],
			[
				"FEUSA0002W",
				"BlackRock Institutional Trust Company, N.A. - EAFE INDEX NON LENDABLE F MUTUAL FUND",
				789237280,
				"Common Collective Trusts"
			],
			[
				"FOUSA00DQS",
				"BlackRock Institutional Trust Company, N.A. - EM NON LENDABLE FUND F MUTUAL FUND",
				320131863,
				"Common Collective Trusts"
			]
		],
		"default_plan_options": [
			[
				"F00000MAPG",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2050 NL FUND F MUTUAL FUND",
				705943266,
				"Common Collective Trusts"
			],
			[
				"F00000MAPH",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2045 NL FUND F MUTUAL FUND",
				574875367,
				"Common Collective Trusts"
			],
			[
				"F00000MAP0",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2055 NL FUND F MUTUAL FUND",
				512555168,
				"Common Collective Trusts"
			],
			[
				"F00000MAOX",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX RETIREMENT NL MUTUAL FUND",
				450391558,
				"Common Collective Trusts"
			],
			[
				"F00000MAPI",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2040 NL FUND F MUTUAL FUND",
				438907644,
				"Common Collective Trusts"
			],
			[
				"F00000MAPJ",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2035 NL FUND F MUTUAL FUND",
				396791210,
				"Common Collective Trusts"
			],
			[
				"F00000MAPK",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2030 NL FUND F MUTUAL FUND",
				367448647,
				"Common Collective Trusts"
			],
			[
				"F00000MAPL",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2025 NL FUND F MUTUAL FUND",
				292273148,
				"Common Collective Trusts"
			],
			[
				"F00000WM8M",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2060 NL FUND F MUTUAL FUND",
				273267741,
				"Common Collective Trusts"
			],
			[
				"F000013OYO",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2065 NL FUND F MUTUAL FUND",
				104007617,
				"Common Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"F00000MAPG",
				"BlackRock Institutional Trust Company, N.A. - LIFEPATH INDEX 2050 NL FUND F MUTUAL FUND",
				705943266,
				"Common Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				314547521,
				278728101,
				0,
				0
			],
			"dff": [
				18172658,
				15239737,
				0,
				0
			],
			"gff": [
				3288005,
				2507476,
				0,
				0
			],
			"pff": [
				49985584,
				37073159,
				0,
				0
			],
			"wff": [
				153946304,
				110975734,
				0,
				0
			],
			"tff": [
				22186314,
				18178912,
				0,
				0
			]
		}
	},
	"tesla": {
		"path": "tesla",
		"employer": "tesla",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/01/2024",
		"participants": 86082,
		"short_name": "Tesla",
		"plan_short_name": "Tesla's 401(k)",
		"primary_plan_name": "Tesla, Inc. 401(k) Plan",
		"chart_plan_title": "Tesla, Inc. 401(k) Plan",
		"primary_plan_logo": "tesla",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Tesla, Inc. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Tesla, Inc. 401(k) Plan Form 5500 Filing 2023",
				"tesla-inc-401k-plan-form-5500-filing-2023.pdf"
			]
		],
		"plan_assets": 1832920351,
		"plan_option_count": 29,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1317747309,
			"equity": 457239431,
			"bond": 37095950,
			"other": 20837661,
			"sri": 14535462,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Government Money Market Fund",
				20837661,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				19984809,
				"Mutual Fund"
			],
			[
				"FOUSA00CG4",
				"Fidelity Government Income Fund",
				11853693,
				"Mutual Fund"
			],
			[
				"F00000NZ8Q",
				"Fidelity Inflation-Protected Bond Fund",
				5257448,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				180390590,
				"Mutual Fund"
			],
			[
				"FOUSA00CEO",
				"Fidelity Contrafund Fund",
				90811211,
				"Mutual Fund"
			],
			[
				"FOUSA00LA4",
				"Vanguard Value Index Fund",
				30280728,
				"Mutual Fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				29146076,
				"Mutual Fund"
			],
			[
				"F00000MJRM",
				"Fidelity International Index Fund",
				22833971,
				"Mutual Fund"
			],
			[
				"F00000MPYG",
				"Vanguard Small-Cap Value Index Fund",
				18984844,
				"Mutual Fund"
			],
			[
				"FOUSA06SU9",
				"ClearBridge Small Cap Growth Fund",
				17485787,
				"Collective Investment Trust"
			],
			[
				"FOUSA00CFE",
				"Fidelity Low-Priced Stock Fund",
				16917440,
				"Mutual Fund"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund",
				14535462,
				"Mutual Fund",
				"sri"
			],
			[
				"FOUSA00B74",
				"Fidelity International Capital Appreciation Fd",
				13684620,
				"Mutual Fund"
			],
			[
				"F000002PJ9",
				"American Funds New World Fund",
				12892010,
				"Mutual Fund"
			],
			[
				"F00000MMWN",
				"Carillon Eagle Mid Cap Growth Fund",
				9276692,
				"Mutual Fund"
			]
		],
		"default_plan_options": [
			[
				"F00001GGJZ",
				"T. Rowe Price Retirement 2055 Fund",
				289306578,
				"Collective Investment Trust"
			],
			[
				"F00001GGK0",
				"T. Rowe Price Retirement 2050 Fund",
				243486090,
				"Collective Investment Trust"
			],
			[
				"F00001GGK2",
				"T. Rowe Price Retirement 2060 Fund",
				234571481,
				"Collective Investment Trust"
			],
			[
				"F00001GGK1",
				"T. Rowe Price Retirement 2045 Fund",
				177003135,
				"Collective Investment Trust"
			],
			[
				"F00001GGK4",
				"T. Rowe Price Retirement 2040 Fund",
				118148197,
				"Collective Investment Trust"
			],
			[
				"F00001GGK3",
				"T. Rowe Price Retirement 2035 Fund",
				93188191,
				"Collective Investment Trust"
			],
			[
				"F00001GGK6",
				"T. Rowe Price Retirement 2030 Fund",
				74316536,
				"Collective Investment Trust"
			],
			[
				"F00001GGK5",
				"T. Rowe Price Retirement 2025 Fund",
				45559165,
				"Collective Investment Trust"
			],
			[
				"F00001GGJY",
				"T. Rowe Price Retirement 2065 Fund",
				23184216,
				"Collective Investment Trust"
			],
			[
				"F00001GGK8",
				"T. Rowe Price Retirement 2020 Fund",
				13473149,
				"Collective Investment Trust"
			],
			[
				"F00001GGK7",
				"T. Rowe Price Retirement 2015 Fund",
				3323977,
				"Collective Investment Trust"
			],
			[
				"F00001GGKA",
				"T. Rowe Price Retirement 2005 Fund",
				1399867,
				"Collective Investment Trust"
			],
			[
				"F00001GGK9",
				"T. Rowe Price Retirement 2010 Fund",
				786727,
				"Collective Investment Trust"
			]
		],
		"rated_as_option": [
			[
				"F00001GGK0",
				"T. Rowe Price Retirement 2050 Fund",
				243486090,
				"Collective Investment Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				43820054,
				129275108,
				0,
				0
			],
			"dff": [
				1090474,
				8939488,
				0,
				0
			],
			"gff": [
				396522,
				1553213,
				0,
				0
			],
			"pff": [
				6631349,
				11306990,
				0,
				0
			],
			"wff": [
				19219841,
				56891081,
				0,
				0
			],
			"tff": [
				2378939,
				2891782,
				0,
				0
			]
		}
	},
	"thrift-savings-plan": {
		"path": "thrift_savings_plan",
		"employer": "thrift-savings-plan",
		"year": 2022,
		"updated": " December 2022",
		"filing_received": " 12/31/2022",
		"participants": 6000000,
		"short_name": "Thrift Savings Plan",
		"plan_short_name": "The Thrift Savings Plan",
		"primary_plan_name": "Thrift Savings Plan",
		"chart_plan_title": "Thrift Savings Plan",
		"primary_plan_logo": "thrift_savings_plan",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Thrift Savings Plan",
		"default_fund_manager_path": "thrift_savings_plan",
		"default_fund_name": "Thrift Savings Plan L Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Thrift Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Thrift Savings Plan Financial Statements 2022",
				"thrift-savings-plan-financial-statements-2022.pdf"
			]
		],
		"plan_assets": 725800000000,
		"plan_option_count": 15,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 166000000000,
			"equity": 271653120000,
			"bond": 17786030000,
			"other": 231060850000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"STSP00000G",
				"TSP G Fund - Government Securities Investment Fund",
				292600000000,
				"TSP Fund"
			]
		],
		"bond_plan_options": [
			[
				"STSP00000F",
				"TSP F Fund - Fixed Income Index Investment Fund",
				30200000000,
				"TSP Fund"
			]
		],
		"equity_plan_options": [
			[
				"STSP00000C",
				"TSP C Fund - Common Stock Index Investment Fund",
				262900000000,
				"TSP Fund"
			],
			[
				"STSP00000S",
				"TSP S Fund - Small cap stock Index investment fund",
				78500000000,
				"TSP Fund"
			],
			[
				"STSP00000I",
				"TSP I Fund - International Stock Index Investment Fund",
				61600000000,
				"TSP Fund"
			]
		],
		"default_plan_options": [
			[
				"STSP0L2030",
				"TSP L 2030",
				45800000000,
				"TSP Fund"
			],
			[
				"STSP0L2040",
				"TSP L 2040",
				40500000000,
				"TSP Fund"
			],
			[
				"STSP0L2050",
				"TSP L 2050",
				29500000000,
				"TSP Fund"
			],
			[
				"STSP0LINCM",
				"TSP L Income",
				26500000000,
				"TSP Fund"
			],
			[
				"STSP0L2025",
				"TSP L 2025",
				9400000000,
				"TSP Fund"
			],
			[
				"STSP0L2035",
				"TSP L 2035",
				4900000000,
				"TSP Fund"
			],
			[
				"STSP0L2045",
				"TSP L 2045",
				3000000000,
				"TSP Fund"
			],
			[
				"STSP0L2065",
				"TSP L 2065",
				2500000000,
				"TSP Fund"
			],
			[
				"STSP0L2055",
				"TSP L 2055",
				2300000000,
				"TSP Fund"
			],
			[
				"STSP0L2060",
				"TSP L 2060",
				1600000000,
				"TSP Fund"
			]
		],
		"rated_as_option": [
			[
				"STSP0L2050",
				"TSP L 2050",
				29500000000,
				"TSP Fund"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				20955630983.01398,
				8861452200,
				0,
				0
			],
			"dff": [
				558278269.1241201,
				603040580,
				0,
				0
			],
			"gff": [
				296391438.4800471,
				78569068,
				0,
				0
			],
			"pff": [
				4353621707.506555,
				1388040559,
				0,
				0
			],
			"wff": [
				10886040704.808205,
				4378813128,
				0,
				0
			],
			"tff": [
				1648145649.238165,
				710519513,
				0,
				0
			]
		}
	},
	"tjx-companies": {
		"path": "tjx_companies",
		"employer": "tjx-companies",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/10/2024",
		"participants": 132895,
		"short_name": "TJX Companies",
		"plan_short_name": "The TJX Companies 401(k)",
		"primary_plan_name": "The TJX Companies, Inc. 401(k) Savings Plan",
		"chart_plan_title": "The TJX Companies, Inc.\n401(k) Savings Plan",
		"primary_plan_logo": "tjx_companies",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"The TJX Companies, Inc. 401(k) Savings Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"The TJX Companies, Inc. 401(k) Savings Plan Form 5500 Filing and Attachment 2023",
				"the-tjx-companies-inc-401k-savings-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 3096016000,
		"plan_option_count": 26,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1526192000,
			"equity": 1126742000,
			"bond": 191743000,
			"other": 251339000,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1525307000
		},
		"other_plan_options": [
			[
				"",
				"Security Backed GIC's and Underlying Investments",
				245303000,
				"Security Backed GIC's and Underlying Investments"
			],
			[
				"",
				"Galliard Capital Management, Inc. Short-Term Investment Fund II",
				6036000,
				"Stable Value Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00EH4",
				"PIMCO Total Return Institutional Fund",
				101895000,
				"Registered Investment Companies"
			],
			[
				"FOUSA00DIL",
				"Vanguard Institutional Total Bond Market Index Trust",
				89848000,
				"Common/Collective Trusts"
			]
		],
		"equity_plan_options": [
			[
				"F00000OLLC",
				"Putnam Large Cap Value Trust",
				217238000,
				"Common/Collective Trusts"
			],
			[
				"F00000JSDA",
				"JPMCB U.S. Active Core Equity Fund - CF - A",
				210394000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				194898000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA02TIF",
				"Vanguard U.S. Growth Fund Admiral Shares",
				151809000,
				"Registered Investment Companies"
			],
			[
				"F000002P1T",
				"American Funds EuroPacific Growth Fund - R6",
				96683000,
				"Registered Investment Companies"
			],
			[
				"FOUSA00GQ5",
				"Vanguard Small-Cap Index Fund Institutional Shares",
				78192000,
				"Registered Investment Companies"
			],
			[
				"FOUSA00J83",
				"Vanguard Mid-Cap Index Fund Institutional Shares",
				76056000,
				"Registered Investment Companies"
			],
			[
				"F00000JTBU",
				"Vanguard Institutional Total International Stock Market Index Trust",
				62158000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA00GQ7",
				"Vanguard Institutional Total Stock Market Index Trust",
				39314000,
				"Common/Collective Trusts"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				231348000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				217018000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				210954000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				168265000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				167108000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				151056000,
				"Common/Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				122967000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				99201000,
				"Common/Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				73092000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				60548000,
				"Common/Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				23391000,
				"Common/Collective Trusts"
			],
			[
				"",
				"Vanguard Target Retirement Income and Growth Trust Plus",
				885000,
				"Common/Collective Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				359000,
				"Common/Collective Trusts"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				151056000,
				"Common/Collective Trusts"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Trust Plus",
				231348000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Trust Plus",
				217018000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Trust Plus",
				210954000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Trust Plus",
				168265000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Trust Plus",
				167108000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Trust Plus",
				151056000,
				"Common/Collective Trusts"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Trust Plus",
				122967000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Trust Plus",
				99201000,
				"Common/Collective Trusts"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Trust Plus",
				73092000,
				"Common/Collective Trusts"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Trust Plus",
				60548000,
				"Common/Collective Trusts"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Trust Plus",
				23391000,
				"Common/Collective Trusts"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Trust Plus",
				359000,
				"Common/Collective Trusts"
			]
		],
		"screen_results": {
			"fff": [
				96988804,
				96977216,
				0,
				96977216
			],
			"dff": [
				2570914,
				6129486,
				0,
				6129486
			],
			"gff": [
				7172643,
				947096,
				0,
				947096
			],
			"pff": [
				21017256,
				13134976,
				0,
				13134976
			],
			"wff": [
				55386010,
				38869748,
				0,
				38869748
			],
			"tff": [
				9839751,
				6644151,
				0,
				6644151
			]
		}
	},
	"university-notre-dame": {
		"path": "university_notre_dame",
		"employer": "university-notre-dame",
		"year": 2023,
		"updated": " July 2024",
		"filing_received": " 07/29/2024",
		"participants": 14179,
		"short_name": "University of Notre Dame",
		"plan_short_name": "The University of Notre Dame 403(b) Retirement Plan",
		"primary_plan_name": "University of Notre Dame 403(b) Retirement Plan",
		"chart_plan_title": "University of Notre Dame\n403(b) Retirement Plan",
		"primary_plan_logo": "university_notre_dame",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"University of Notre Dame 403(b) Retirement Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"University of Notre Dame 403(b) Retirement Plan Form 5500 Filing and Attachment 2023",
				"university-of-notre-dame-403b-retirement-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 2236777456,
		"plan_option_count": 36,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 981382848,
			"equity": 781365292,
			"bond": 66458202,
			"other": 407571114,
			"sri": 26288213,
			"cref": 354010088,
			"vanguard_target": 981382848
		},
		"other_plan_options": [
			[
				"",
				"TIAA Traditional Non Benefit Responsive",
				259040728,
				"Fixed Rate Guaranteed Insurance Contract"
			],
			[
				"",
				"MetLife Fully Benefit Responsive",
				78256972,
				"Fixed Rate Guaranteed Insurance Contract"
			],
			[
				"",
				"TIAA Traditional Benefit Responsive",
				35959975,
				"Fixed Rate Guaranteed Insurance Contract"
			],
			[
				"",
				"TIAA Real Estate Account",
				22617705,
				"Pooled Separate Account"
			],
			[
				"",
				"CREF Money Market Account",
				10108477,
				"Variable Annuity Contract"
			],
			[
				"",
				"Vanguard Cash Reserves Federal Money Market Fund Admiral Shares",
				1587257,
				"Registered Investment Company"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund Institutional Shares",
				32059259,
				"Registered Investment Company"
			],
			[
				"STIAA00023",
				"CREF Core Bond Account",
				13727450,
				"Variable Annuity Contract"
			],
			[
				"FOUSA05IJD",
				"DFA Inflation-Protected Securities Portfolio Institutional Class",
				7993346,
				"Registered Investment Company"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond Account",
				7295242,
				"Variable Annuity Contract"
			],
			[
				"F00000NBIN",
				"Vanguard Total International Bond Index Fund Institutional Shares",
				5374377,
				"Registered Investment Company"
			],
			[
				"FOUSA06MKE",
				"AB Global Bond I",
				8528,
				"Registered Investment Company"
			]
		],
		"equity_plan_options": [
			[
				"STIAA00007",
				"CREF Stock Account",
				183131505,
				"Variable Annuity Contract"
			],
			[
				"F00000VE7X",
				"Vanguard Total Stock Market Index Fund Institutional Plus Shares",
				172832883,
				"Registered Investment Company"
			],
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund Plus Shares",
				148224922,
				"Registered Investment Company"
			],
			[
				"FOUSA00GPW",
				"Vanguard Extended Market Index Fund Institutional Shares",
				46027464,
				"Registered Investment Company"
			],
			[
				"STIAA00011",
				"CREF Growth Account",
				45617271,
				"Variable Annuity Contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities Account",
				44621855,
				"Variable Annuity Contract"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund Institutional Shares",
				36566814,
				"Registered Investment Company"
			],
			[
				"STIAA00003",
				"CREF Equity Index Account",
				33328552,
				"Variable Annuity Contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice Account",
				26288213,
				"Variable Annuity Contract",
				"sri"
			],
			[
				"F00001DHJZ",
				"Dodge & Cox Global Stock Fund Class X",
				19764934,
				"Registered Investment Company"
			],
			[
				"FOUSA04BEQ",
				"Vanguard Real Estate Index Fund Institutional Shares",
				14863596,
				"Registered Investment Company"
			],
			[
				"FOUSA00P1W",
				"Vanguard Emerging Markets Stock Index Fund Institutional",
				10097283,
				"Registered Investment Company"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				161799764,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				160673989,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				149444927,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				148235873,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				124484030,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				74853932,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				68989550,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				36740758,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				33408540,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				16213008,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				6057409,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund",
				481068,
				"Registered Investment Company"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				68989550,
				"Registered Investment Company"
			]
		],
		"cref_options": [
			[
				"STIAA00007",
				"CREF Stock Account",
				183131505,
				"Variable Annuity Contract"
			],
			[
				"STIAA00011",
				"CREF Growth Account",
				45617271,
				"Variable Annuity Contract"
			],
			[
				"STIAA00015",
				"CREF Global Equities Account",
				44621855,
				"Variable Annuity Contract"
			],
			[
				"STIAA00003",
				"CREF Equity Index Account",
				33328552,
				"Variable Annuity Contract"
			],
			[
				"STIAA00019",
				"CREF Social Choice Account",
				26288213,
				"Variable Annuity Contract"
			],
			[
				"STIAA00023",
				"CREF Core Bond Account",
				13727450,
				"Variable Annuity Contract"
			],
			[
				"STIAA00027",
				"CREF Inflation-Linked Bond Account",
				7295242,
				"Variable Annuity Contract"
			]
		],
		"vanguard_target_options": [
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				161799764,
				"Registered Investment Company"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				160673989,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				149444927,
				"Registered Investment Company"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				148235873,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				124484030,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				74853932,
				"Registered Investment Company"
			],
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				68989550,
				"Registered Investment Company"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				36740758,
				"Registered Investment Company"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income Fund",
				33408540,
				"Registered Investment Company"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				16213008,
				"Registered Investment Company"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				6057409,
				"Registered Investment Company"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund",
				481068,
				"Registered Investment Company"
			]
		],
		"screen_results": {
			"fff": [
				58724124,
				60222898,
				23307952,
				60222898
			],
			"dff": [
				2414976,
				3804337,
				1185643,
				3804337
			],
			"gff": [
				728504,
				588493,
				241634,
				588493
			],
			"pff": [
				9377521,
				8160926,
				2414144,
				8160926
			],
			"wff": [
				26976877,
				24140583,
				10624582,
				24140583
			],
			"tff": [
				3607961,
				4126768,
				1021075,
				4126768
			]
		}
	},
	"vertex-pharmaceuticals": {
		"path": "vertex_pharmaceuticals",
		"employer": "vertex-pharmaceuticals",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 5338,
		"short_name": "Vertex Pharmaceuticals",
		"plan_short_name": "Vertex Pharmaceuticals' 401(k)",
		"primary_plan_name": "Vertex Pharmaceuticals Incorporated 401(k) Plan",
		"chart_plan_title": "Vertex Pharmaceuticals\nIncorporated 401(k) Plan",
		"primary_plan_logo": "vertex_pharmaceuticals",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Fidelity Investments",
		"default_fund_manager_path": "fidelity_investments",
		"default_fund_name": "Fidelity Freedom Index series",
		"access_self_directed": "",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Vertex Pharmaceuticals Incorporated 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Vertex Pharmaceuticals Incorporated 401(k) Plan Form 5500 Filing and Attachment 2023",
				"vertex-pharmaceuticals-incorporated-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1077255194,
		"plan_option_count": 31,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 437041418,
			"equity": 451367856,
			"bond": 27334610,
			"other": 161511310,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Vertex Pharmaceuticals Incorporated real-time traded stock fund (non participant-directed investment)",
				139536155,
				"Common stock"
			],
			[
				"",
				"Fidelity Managed Income Portfolio Class 2 Fund",
				21975155,
				"Common collective trust"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity US Bond Index Fund",
				22626181,
				"Mutual fund"
			],
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund Class I",
				4708429,
				"Mutual fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				177081510,
				"Mutual fund"
			],
			[
				"F00000WOUK",
				"Harbor Capital Appreciation Fund Retirement Class",
				70004468,
				"Mutual fund"
			],
			[
				"F00000WJF7",
				"Baron Asset Fund",
				33040736,
				"Mutual fund"
			],
			[
				"F00000MJRP",
				"Fidelity Mid Cap Index Fund",
				27515858,
				"Mutual fund"
			],
			[
				"F00000MJRV",
				"Fidelity Small Cap Index Fund",
				25991299,
				"Mutual fund"
			],
			[
				"FOUSA06TXE",
				"Fidelity International Discovery K6 Fund",
				23291008,
				"Mutual fund"
			],
			[
				"F00000YM9F",
				"American Beacon Large Cap Value Fund R6",
				19352257,
				"Mutual fund"
			],
			[
				"F00000YI8K",
				"Fidelity Small Cap Growth K6 Fund",
				17013291,
				"Mutual fund"
			],
			[
				"FOUSA06B5B",
				"Vanguard FTSE All-World ex-US Index Fund Institutional Shares",
				15821206,
				"Mutual fund"
			],
			[
				"FOUSA00CHX",
				"Fidelity Real Estate Investment Port",
				12894016,
				"Mutual fund"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Fund Class R6",
				12267866,
				"Mutual fund"
			],
			[
				"F00000JTO4",
				"Columbia Trust Small Cap Value II Fund",
				9032994,
				"Common collective trust"
			],
			[
				"FOUSA06BY5",
				"Delaware Emerging Markets Fund Class R6",
				8061347,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"F00000VQAE",
				"Fidelity Freedom Index 2040 Fund",
				91692586,
				"Common collective trust"
			],
			[
				"F00000VQAD",
				"Fidelity Freedom Index 2035 Fund",
				64468362,
				"Common collective trust"
			],
			[
				"F00000VQAF",
				"Fidelity Freedom Index 2045 Fund",
				64296544,
				"Common collective trust"
			],
			[
				"F00000VQAG",
				"Fidelity Freedom Index 2050 Fund",
				59479434,
				"Common collective trust"
			],
			[
				"F00000VQ8F",
				"Fidelity Freedom Index 2055 Fund",
				48933868,
				"Common collective trust"
			],
			[
				"F00000VQAC",
				"Fidelity Freedom Index 2030 Fund",
				48440466,
				"Common collective trust"
			],
			[
				"F00000VQAB",
				"Fidelity Freedom Index 2025 Fund",
				25919406,
				"Common collective trust"
			],
			[
				"F00000VQ8G",
				"Fidelity Freedom Index 2060 Fund",
				15815101,
				"Common collective trust"
			],
			[
				"F00000VQAA",
				"Fidelity Freedom Index 2020 Fund",
				9771582,
				"Common collective trust"
			],
			[
				"F000013DKQ",
				"Fidelity Freedom Index 2065 Fund",
				3971629,
				"Common collective trust"
			],
			[
				"F00000VQAH",
				"Fidelity Freedom Index Income Fund",
				1633836,
				"Common collective trust"
			],
			[
				"F00000VQA8",
				"Fidelity Freedom Index 2010 Fund",
				1120066,
				"Common collective trust"
			],
			[
				"F00000VQA9",
				"Fidelity Freedom Index 2015 Fund",
				1101947,
				"Common collective trust"
			],
			[
				"F00000VQA7",
				"Fidelity Freedom Index 2005 Fund",
				396591,
				"Common collective trust"
			]
		],
		"rated_as_option": [
			[
				"F00000VQAG",
				"Fidelity Freedom Index 2050 Fund",
				59479434,
				"Common collective trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				31334374,
				31952635,
				0,
				0
			],
			"dff": [
				1497507,
				1934433,
				0,
				0
			],
			"gff": [
				402472,
				263112,
				0,
				0
			],
			"pff": [
				6766386,
				4308333,
				0,
				0
			],
			"wff": [
				17013278,
				12934342,
				0,
				0
			],
			"tff": [
				2032550,
				2270389,
				0,
				0
			]
		}
	},
	"visa": {
		"path": "visa",
		"employer": "visa",
		"year": 2022,
		"updated": " July 2023",
		"filing_received": " 07/11/2023",
		"participants": 15722,
		"short_name": "VISA",
		"plan_short_name": "VISA's 401(k)",
		"primary_plan_name": "VISA 401(k) plan",
		"chart_plan_title": "VISA 401(k) Plan",
		"primary_plan_logo": "visa",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"VISA 401(k) plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Visa 401(k) Plan Form 5500 Filing and Attachment 2022",
				"visa-401k-plan-form-5500-filing-and-attachment-2022.pdf"
			]
		],
		"plan_assets": 3044924734,
		"plan_option_count": 24,
		"plan_option_sri_count": 0,
		"allocations": {
			"default": 1129792211,
			"equity": 1656787828,
			"bond": 104168959,
			"other": 154175736,
			"sri": 0,
			"cref": 0,
			"vanguard_target": 1129792211
		},
		"other_plan_options": [
			[
				"",
				"Fidelity Short-Term Investment Fund",
				154002583,
				"Separately managed portfolio"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				173153,
				"Registered investment companies"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00C3M",
				"Dodge & Cox Income Fund",
				69383427,
				"Registered investment companies"
			],
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Fund Institutional",
				34785532,
				"Registered investment companies"
			]
		],
		"equity_plan_options": [
			[
				"F00000LZSI",
				"Fidelity 500 Index Fund",
				528842952,
				"Registered investment companies"
			],
			[
				"FOUSA06TXQ",
				"Fidelity Balanced Fund Class K",
				324910336,
				"Registered investment companies"
			],
			[
				"FOUSA02VIY",
				"TRP Institutional Large Cap Growth",
				186801971,
				"Registered investment companies"
			],
			[
				"FOUSA00C29",
				"DFA US Small Cap 1",
				137241567,
				"Registered investment companies"
			],
			[
				"F00000JXVS",
				"Vanguard External Market Index Fund Institutional Plus",
				131098221,
				"Registered investment companies"
			],
			[
				"FOUSA00IJP",
				"Vanguard Value Index Fund Institutional",
				114473516,
				"Registered investment companies"
			],
			[
				"FOUSA00GQ7",
				"Vanguard Total Stock Market Fund Institutional",
				87394919,
				"Registered investment companies"
			],
			[
				"F00000JTBV",
				"Vanguard Total International Stock Fund Institutional Plus",
				87329457,
				"Registered investment companies"
			],
			[
				"FOUSA02TGA",
				"Dodge & Cox International Stock Fund",
				58694889,
				"Registered investment companies"
			]
		],
		"default_plan_options": [
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund Institutional",
				193379056,
				"Registered investment companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund Institutional",
				172753763,
				"Registered investment companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund Institutional",
				167406188,
				"Registered investment companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund Institutional",
				166047367,
				"Registered investment companies"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund Institutional",
				127423676,
				"Registered investment companies"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund Institutional",
				105078896,
				"Registered investment companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund Institutional",
				77507744,
				"Registered investment companies"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund Institutional",
				63205529,
				"Registered investment companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund Institutional",
				29436096,
				"Registered investment companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund Institutional",
				17988268,
				"Registered investment companies"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund Institutional",
				9565628,
				"Registered investment companies"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund Institutional",
				172753763,
				"Registered investment companies"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA04B9A",
				"Vanguard Institutional Target Retirement 2045 Fund Institutional",
				193379056,
				"Registered investment companies"
			],
			[
				"FOUSA05HZH",
				"Vanguard Institutional Target Retirement 2050 Fund Institutional",
				172753763,
				"Registered investment companies"
			],
			[
				"FOUSA04B99",
				"Vanguard Institutional Target Retirement 2035 Fund Institutional",
				167406188,
				"Registered investment companies"
			],
			[
				"FOUSA05HZF",
				"Vanguard Institutional Target Retirement 2040 Fund Institutional",
				166047367,
				"Registered investment companies"
			],
			[
				"F00000ISUB",
				"Vanguard Institutional Target Retirement 2055 Fund Institutional",
				127423676,
				"Registered investment companies"
			],
			[
				"FOUSA05HZE",
				"Vanguard Institutional Target Retirement 2030 Fund Institutional",
				105078896,
				"Registered investment companies"
			],
			[
				"FOUSA04B98",
				"Vanguard Institutional Target Retirement 2025 Fund Institutional",
				77507744,
				"Registered investment companies"
			],
			[
				"F00000N8OD",
				"Vanguard Institutional Target Retirement 2060 Fund Institutional",
				63205529,
				"Registered investment companies"
			],
			[
				"FOUSA05HZD",
				"Vanguard Institutional Target Retirement 2020 Fund Institutional",
				29436096,
				"Registered investment companies"
			],
			[
				"FOUSA04B9B",
				"Vanguard Institutional Target Retirement Income Fund Institutional",
				17988268,
				"Registered investment companies"
			],
			[
				"F00000YE51",
				"Vanguard Institutional Target Retirement 2065 Fund Institutional",
				9565628,
				"Registered investment companies"
			]
		],
		"screen_results": {
			"fff": [
				117404847,
				78986808,
				0,
				78986808
			],
			"dff": [
				3416834,
				4994801,
				0,
				4994801
			],
			"gff": [
				1932286,
				770998,
				0,
				770998
			],
			"pff": [
				19037313,
				10693534,
				0,
				10693534
			],
			"wff": [
				62906757,
				31656114,
				0,
				31656114
			],
			"tff": [
				8726950,
				5410718,
				0,
				5410718
			]
		}
	},
	"whole-foods": {
		"path": "whole_foods",
		"employer": "whole-foods",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/04/2024",
		"participants": 125303,
		"short_name": "Whole Foods",
		"plan_short_name": "Whole Foods' 401(k)",
		"primary_plan_name": "Whole Foods Market Growing Your Future 401(k) Plan",
		"chart_plan_title": "Whole Foods Market Growing\nYour Future 401(k) Plan",
		"primary_plan_logo": "whole_foods",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "Vanguard",
		"default_fund_manager_path": "vanguard",
		"default_fund_name": "Vanguard Target Retirement Funds series",
		"access_self_directed": "Fidelity BrokerageLink",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"Whole Foods Market Growing Your Future 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"Whole Foods Market Growing Your Future 401(k) Plan Form 5500 Filing and Attachment 2023",
				"whole-foods-market-growing-your-future-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 1952523000,
		"plan_option_count": 28,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 1369672000,
			"equity": 460486000,
			"bond": 79221000,
			"other": 43144000,
			"sri": 28564000,
			"cref": 0,
			"vanguard_target": 1369672000
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust II",
				42457000,
				"Stable Value Fund"
			],
			[
				"",
				"Fidelity Government Money Market Fund",
				687000,
				"Mutual fund"
			]
		],
		"bond_plan_options": [
			[
				"F00000LZX3",
				"Fidelity U.S. Bond Index Fund",
				29534000,
				"Mutual fund"
			],
			[
				"F00000MN7G",
				"MetWest Total Return Bond Fund CIT - Class D",
				23886000,
				"Collective trust"
			],
			[
				"FOUSA00CGB",
				"Fidelity Capital and Income Fund",
				18529000,
				"Mutual fund"
			],
			[
				"FOUSA04BL6",
				"Vanguard Inflation-Protected Securities Fund Institutional Shares",
				5837000,
				"Mutual fund"
			],
			[
				"F00000NBIL",
				"Vanguard Total International Bond Index Fund",
				1435000,
				"Mutual fund"
			]
		],
		"equity_plan_options": [
			[
				"F00000YI8R",
				"Fidelity Contrafund Commingled Pool",
				146251000,
				"Collective trust"
			],
			[
				"FOUSA00L8W",
				"Vanguard Institutional 500 Index Trust",
				110613000,
				"Collective trust"
			],
			[
				"F00000WZVM",
				"Fidelity Total International Index Fund",
				43693000,
				"Mutual fund"
			],
			[
				"FOUSA02TY5",
				"Vanguard Explorer Fund Admiral Shares Fund",
				36440000,
				"Mutual fund"
			],
			[
				"F00000MJRH",
				"Fidelity Extended Market Index Fund",
				30980000,
				"Mutual fund"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity Income Admiral",
				29380000,
				"Mutual fund"
			],
			[
				"FOUSA06M6P",
				"Dimensional Fund Advisors US Sustainability Core 1",
				28564000,
				"Mutual fund",
				"sri"
			],
			[
				"F000002PIY",
				"American Funds New Perspective Fund Class R6",
				24642000,
				"Mutual fund"
			],
			[
				"FOUSA009MW",
				"American Beacon Small Cap Value Fund",
				9923000,
				"Mutual fund"
			]
		],
		"default_plan_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				226177000,
				"Collective trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				225256000,
				"Collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				172029000,
				"Collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				156600000,
				"Collective trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				149503000,
				"Collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				140459000,
				"Collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				99489000,
				"Collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				87662000,
				"Collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				46589000,
				"Collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				34208000,
				"Collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				28638000,
				"Collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund",
				3062000,
				"Collective trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				226177000,
				"Collective trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [
			[
				"FOUSA05HZH",
				"Vanguard Target Retirement 2050 Fund",
				226177000,
				"Collective trust"
			],
			[
				"FOUSA04B9A",
				"Vanguard Target Retirement 2045 Fund",
				225256000,
				"Collective trust"
			],
			[
				"FOUSA05HZF",
				"Vanguard Target Retirement 2040 Fund",
				172029000,
				"Collective trust"
			],
			[
				"F00000ISUB",
				"Vanguard Target Retirement 2055 Fund",
				156600000,
				"Collective trust"
			],
			[
				"FOUSA04B99",
				"Vanguard Target Retirement 2035 Fund",
				149503000,
				"Collective trust"
			],
			[
				"FOUSA05HZE",
				"Vanguard Target Retirement 2030 Fund",
				140459000,
				"Collective trust"
			],
			[
				"FOUSA04B98",
				"Vanguard Target Retirement 2025 Fund",
				99489000,
				"Collective trust"
			],
			[
				"F00000N8OD",
				"Vanguard Target Retirement 2060 Fund",
				87662000,
				"Collective trust"
			],
			[
				"FOUSA05HZD",
				"Vanguard Target Retirement 2020 Fund",
				46589000,
				"Collective trust"
			],
			[
				"F00000YE51",
				"Vanguard Target Retirement 2065 Fund",
				34208000,
				"Collective trust"
			],
			[
				"FOUSA04B9B",
				"Vanguard Target Retirement Income",
				28638000,
				"Collective trust"
			],
			[
				"F00001DBZ9",
				"Vanguard Target Retirement 2070 Fund",
				3062000,
				"Collective trust"
			]
		],
		"screen_results": {
			"fff": [
				45506033,
				95845123,
				0,
				95845123
			],
			"dff": [
				1232878,
				6062545,
				0,
				6062545
			],
			"gff": [
				602886,
				935272,
				0,
				935272
			],
			"pff": [
				5435637,
				12972535,
				0,
				12972535
			],
			"wff": [
				20327435,
				38410545,
				0,
				38410545
			],
			"tff": [
				2014491,
				6564929,
				0,
				6564929
			]
		}
	},
	"x-corp": {
		"path": "x_corp",
		"employer": "x-corp",
		"year": 2023,
		"updated": " October 2024",
		"filing_received": " 10/09/2024",
		"participants": 7760,
		"short_name": "X Corp",
		"plan_short_name": "The X Corp 401(k)",
		"primary_plan_name": "X Corp. 401(k) Plan",
		"chart_plan_title": "X Corp. 401(k) Plan",
		"primary_plan_logo": "x_corp",
		"coreissue": "fossil",
		"intro_statement": "",
		"default_fund_manager": "T. Rowe Price",
		"default_fund_manager_path": "t_rowe_price",
		"default_fund_name": "T. Rowe Price Retirement series",
		"access_self_directed": "Self-directed brokerage accounts",
		"climate_claim": "",
		"proposal_title": "",
		"proposal_url": "",
		"plan_names": [
			"X Corp. 401(k) Plan"
		],
		"secondary_plan_logos": [],
		"files": [
			[
				"X Corp. 401(k) Plan Form 5500 Filing and Attachment 2023",
				"x-corp-401k-plan-form-5500-filing-and-attachment-2023.pdf"
			]
		],
		"plan_assets": 559092962,
		"plan_option_count": 27,
		"plan_option_sri_count": 1,
		"allocations": {
			"default": 282513091,
			"equity": 243711945,
			"bond": 25149621,
			"other": 7718305,
			"sri": 2341185,
			"cref": 0,
			"vanguard_target": 0
		},
		"other_plan_options": [
			[
				"",
				"Vanguard Retirement Savings Trust III",
				6841876,
				"Common/Collective Trust"
			],
			[
				"",
				"Vanguard Federal Money Market Fund",
				876429,
				"Mutual Fund"
			]
		],
		"bond_plan_options": [
			[
				"FOUSA00DIL",
				"Vanguard Total Bond Market Index Fund",
				18035759,
				"Mutual Fund"
			],
			[
				"FOUSA069X9",
				"PIMCO Income Fund",
				4073447,
				"Mutual Fund"
			],
			[
				"FOUSA00EH4",
				"PIMCO Total Return Fund",
				3040415,
				"Mutual Fund"
			]
		],
		"equity_plan_options": [
			[
				"FOUSA00GPG",
				"Vanguard Institutional Index Fund",
				127006635,
				"Mutual Fund"
			],
			[
				"FOUSA00GPW",
				"Vanguard Extended Market Index Fund",
				41902841,
				"Mutual Fund"
			],
			[
				"F00000JTBU",
				"Vanguard Total International Stock Index Fund",
				33121901,
				"Mutual Fund"
			],
			[
				"F00000YI8R",
				"Fidelity Contrafund",
				14393635,
				"Mutual Fund"
			],
			[
				"FOUSA02TIM",
				"Vanguard Equity Income Fund",
				11142169,
				"Mutual Fund"
			],
			[
				"F00000ZJYS",
				"MFS International Diversification Fund",
				6284099,
				"Mutual Fund"
			],
			[
				"F00000MSXN",
				"JPMorgan U.S. Small Company Fund",
				4395659,
				"Mutual Fund"
			],
			[
				"F00000PGEH",
				"MFS Mid Cap Value Fund",
				3123821,
				"Mutual Fund"
			],
			[
				"F000011IZ5",
				"Vanguard FTSE Social Index Fund",
				2341185,
				"Mutual Fund",
				"sri"
			]
		],
		"default_plan_options": [
			[
				"FOUSA06BXM",
				"T. Rowe Price Retirement 2055 Trust",
				69516608,
				"Common/Collective Trust"
			],
			[
				"FOUSA068A3",
				"T. Rowe Price Retirement 2050 Trust",
				68031913,
				"Common/Collective Trust"
			],
			[
				"FOUSA06BXK",
				"T. Rowe Price Retirement 2045 Trust",
				52031726,
				"Common/Collective Trust"
			],
			[
				"F00000SZHY",
				"T. Rowe Price Retirement 2060 Trust",
				33099564,
				"Common/Collective Trust"
			],
			[
				"FOUSA04BF0",
				"T. Rowe Price Retirement 2040 Trust",
				29312333,
				"Common/Collective Trust"
			],
			[
				"FOUSA06BXI",
				"T. Rowe Price Retirement 2035 Trust",
				14664095,
				"Common/Collective Trust"
			],
			[
				"FOUSA04BEZ",
				"T. Rowe Price Retirement 2030 Trust",
				6793345,
				"Common/Collective Trust"
			],
			[
				"FOUSA06BXG",
				"T. Rowe Price Retirement 2025 Trust",
				3688933,
				"Common/Collective Trust"
			],
			[
				"F0000155P3",
				"T. Rowe Price Retirement 2065 Trust",
				1663428,
				"Common/Collective Trust"
			],
			[
				"FOUSA04BEY",
				"T. Rowe Price Retirement 2020 Trust",
				1526643,
				"Common/Collective Trust"
			],
			[
				"FOUSA06BXC",
				"T. Rowe Price Retirement 2005 Trust",
				1016806,
				"Common/Collective Trust"
			],
			[
				"FOUSA04BEX",
				"T. Rowe Price Retirement 2010 Trust",
				757422,
				"Common/Collective Trust"
			],
			[
				"FOUSA06BXE",
				"T. Rowe Price Retirement 2015 Trust",
				410275,
				"Common/Collective Trust"
			]
		],
		"rated_as_option": [
			[
				"FOUSA068A3",
				"T. Rowe Price Retirement 2050 Trust",
				68031913,
				"Common/Collective Trust"
			]
		],
		"cref_options": [],
		"vanguard_target_options": [],
		"screen_results": {
			"fff": [
				21952752,
				28340752,
				0,
				0
			],
			"dff": [
				828041,
				1962870,
				0,
				0
			],
			"gff": [
				299331,
				338561,
				0,
				0
			],
			"pff": [
				3543280,
				2472526,
				0,
				0
			],
			"wff": [
				9516534,
				12473333,
				0,
				0
			],
			"tff": [
				1456582,
				631056,
				0,
				0
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/Plans.json
// module id = 1010
// module chunks = 0